webpackJsonp([1],{

/***/ 108:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  USERS: "users", // user information
  USER_TOKEN: "token", // jwt token
  SITE_HISTORY: "siteList", // site name history list
  LOCAL_VIEWS: "views" // webconnect local views
});

/***/ }),

/***/ 138:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  'STREAM_QUALITY': 'quality', // low or high quality camera video
  'STREAM_MODE': 'mode', // live or archive camera video
  'SHOW_ALARMED_CAMS': 'alarmedCams' // show alarmed cams on map
});

/***/ }),

/***/ 139:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_inputText_js__ = __webpack_require__(448);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c07ca84_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InputText_vue__ = __webpack_require__(908);
function injectStyle (ssrContext) {
  __webpack_require__(907)
}
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0c07ca84"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_inputText_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c07ca84_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InputText_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 18:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EventBus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(20);

var EventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();

/***/ }),

/***/ 197:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_EventBus__ = __webpack_require__(18);






var _class = function () {
  function _class() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, _class);

    this.v = "v1";
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(_class, [{
    key: "get",
    value: function get(url) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].http.get("/api/" + this.v + "/" + url, options).then(function (r) {
        return r.body.data;
      }, function (r) {
        if (r.status !== 400) {
          __WEBPACK_IMPORTED_MODULE_4__services_EventBus__["a" /* EventBus */].$emit("error", {
            message: "global.temporarilyUnavailable",
            code: r.status
          });
        }

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(r);
      });
    }
  }, {
    key: "getImage",
    value: function getImage(url) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].http.get(url, options).then(function (r) {
        var urlCreator = window.URL || window.webkitURL;

        return urlCreator.createObjectURL(r.bodyBlob);
      });
    }
  }, {
    key: "getCams",
    value: function getCams() {
      return this.get("cameras");
    }
  }, {
    key: "getCam",
    value: function getCam(id) {
      return this.get("cameras/" + id);
    }
  }, {
    key: "getCamImage",
    value: function getCamImage(id) {
      return this.getImage("/api/v2/cameras/" + encodeURIComponent(id) + "/image", {
        responseType: "blob"
      });
    }
  }, {
    key: "getMapImage",
    value: function getMapImage(mapId, planId) {
      return this.getImage("/api/v1/maps/" + mapId + "/image/" + planId, {
        responseType: "blob"
      });
    }
  }, {
    key: "getMaps",
    value: function getMaps() {
      return this.get("maps");
    }
  }, {
    key: "getMap",
    value: function getMap(mapGroupId) {
      return this.get("maps/" + mapGroupId);
    }
  }, {
    key: "getPage",
    value: function getPage(name) {
      return __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].http.get("/static/pages/" + name + ".html").then(function (r) {
        return r.body;
      });
    }
  }, {
    key: "getAcsObject",
    value: function getAcsObject(type, id) {
      var _this = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        _this.get("acsconfig?type=" + type + "&ids=" + id).then(function (r) {
          resolve(r[0]);
        }).catch(function (e) {
          resolve(null);
        });
      });
    }
  }]);

  return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),

/***/ 199:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_tree_js__ = __webpack_require__(424);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cc93184c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tree_vue__ = __webpack_require__(859);
function injectStyle (ssrContext) {
  __webpack_require__(855)
}
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cc93184c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_tree_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cc93184c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tree_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 200:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_search_js__ = __webpack_require__(435);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ad59ec64_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__ = __webpack_require__(876);
function injectStyle (ssrContext) {
  __webpack_require__(875)
}
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ad59ec64"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_search_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ad59ec64_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 201:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cam_js__ = __webpack_require__(440);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57d38bf9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cam_vue__ = __webpack_require__(888);
function injectStyle (ssrContext) {
  __webpack_require__(885)
}
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-57d38bf9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cam_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57d38bf9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cam_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 202:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mapObjSizes; });
var mapObjSizes = {
  S: {
    cam: {
      template: 35,
      alarmIcon: 15,
      fontSize: 9
    },
    level: {
      width: 70,
      height: 16.8,
      fontSize: 9,
      arrowIcon: 14
    }
  },
  L: {
    cam: {
      template: 45.5,
      alarmIcon: 19.5,
      fontSize: 12
    },
    level: {
      width: 100,
      height: 24,
      fontSize: 13,
      arrowIcon: 20
    }
  }
};

/***/ }),

/***/ 203:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_dropdownSelect_js__ = __webpack_require__(443);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ccd02ba_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DropdownSelect_vue__ = __webpack_require__(901);
function injectStyle (ssrContext) {
  __webpack_require__(890)
}
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4ccd02ba"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_dropdownSelect_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ccd02ba_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DropdownSelect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 417:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__consts_mapObjTypes__ = __webpack_require__(837);






var MAP_IMAGE_PART = "/map_image/";
var HTTP_PART = "http";

/* harmony default export */ __webpack_exports__["a"] = ({
  preloadImage: function preloadImage(src) {
    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var image = new Image();

      image.onload = function () {
        resolve(image);
      };

      image.onerror = function () {
        image.src = "";
        reject();
      };

      image.src = src;
    });
  },
  isEqual: function isEqual(obj1, obj2) {
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, obj1)) === __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, obj2));
  },
  transformMap: function transformMap(item, i, map) {
    var itemProcessed = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, item, {
      id: i,
      imageId: item.image.split("/").pop(),
      image: null,
      parent: item.parent || 0,
      width: item.width,
      height: item.height,
      group: { id: map.id, name: map.name },
      url: null
    });

    if (item.image.indexOf(MAP_IMAGE_PART) !== -1 || item.image.indexOf(HTTP_PART) !== -1) {
      itemProcessed.imageId = null;
      itemProcessed.url = item.image;
    }

    itemProcessed.objects = itemProcessed.objects.reduce(function (acc, item) {
      if (item.type === "LEVEL" || item.type === "CAM") {
        return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(acc), [item]);
      } else {
        for (var _i = 0; _i < __WEBPACK_IMPORTED_MODULE_4__consts_mapObjTypes__["a" /* default */].length; _i++) {
          var webviewObjType = __WEBPACK_IMPORTED_MODULE_4__consts_mapObjTypes__["a" /* default */][_i];
          if (item.type.startsWith(webviewObjType)) {
            return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(acc), [__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, item, {
              type: webviewObjType,
              status: webviewObjType
            })]);
          }
        }
      }
      return acc;
    }, []);

    return itemProcessed;
  }
});

/***/ }),

/***/ 418:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MainView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__consts_consts__ = __webpack_require__(84);



/**
 * @class MainView
 * @property {Array<string|number>} cams Cameras ids: [cam1id,cam2id,cam3id,...]
 * @property {number} grid View grid: 4
 * @property {string} id View id: main
 * @property {string} name View name: tabs.mainView
 * @property {boolean} changed don't know
 * @property {boolean} temp don't know
 * @property {boolean} isGlobalView is global view flag
 */

var MainView = function MainView() {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, MainView);

  this.id = __WEBPACK_IMPORTED_MODULE_1__consts_consts__["c" /* MAIN_VIEW_ID */];
  this.name = "tabs.mainView";
  this.cams = [];
  this.grid = __WEBPACK_IMPORTED_MODULE_1__consts_consts__["a" /* DEFAULT_GRID_ID */];

  this.changed = false;
  this.temp = true;

  this.isGlobalView = false;
};

/***/ }),

/***/ 420:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_perfect_scrollbar__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_perfect_scrollbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_perfect_scrollbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_dropdown_Dropdown_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_tree_Tree_vue__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_sidebar_Sidebar_vue__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_loader_Loader_vue__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_search_Search_vue__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_searchMapLevel_SearchMapLevel_vue__ = __webpack_require__(877);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_camsList_CamsList_vue__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_mapList_MapList_vue__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__modules_viewTabs_ViewTabs_vue__ = __webpack_require__(905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__modules_alarms_Alarms_vue__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__modules_userInfo_UserInfo_vue__ = __webpack_require__(949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__services_EventBus_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__api_view_view_api__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__api_alarm_alarm_api__ = __webpack_require__(465);





















function getVisualRectPersent() {
  return {
    left: 0,
    right: 100,
    top: 0,
    bottom: 100
  };
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Dashboard",
  data: function data() {
    return {
      videoStreams: [{ name: "header.videoQuality.base", value: 1 }, { name: "header.videoQuality.lowResolution", value: 2 }, { name: "header.videoQuality.highResolution", value: 3 }],
      modes: [{ name: "header.videoType.live", value: 0, alias: "live" }, { name: "header.videoType.playback", value: 1, alias: "playback" }],
      sidebars: {
        cams: {
          open: true,
          show: true,
          search: "",
          scroll: null,
          modes: {
            active: "list",
            list: [{ name: "List", value: "list" }, { name: "Preview", value: "preview" }]
          }
        },
        maps: {
          open: true,
          search: "",
          modes: {
            active: "map",
            list: [{ name: "global.map", value: "map" }, { name: "global.video", value: "views" }]
          },
          isViewCamsSetted: false
        }
      },
      loading: {
        alarms: false
      },
      modals: {
        agreement: true
      },
      prevParams: {
        mapGroupId: null,
        mapId: null
      },
      visualRectPersent: getVisualRectPersent(),
      latestAlarms: []
    };
  },

  components: {
    ViewTabs: __WEBPACK_IMPORTED_MODULE_14__modules_viewTabs_ViewTabs_vue__["a" /* default */],
    Dropdown: __WEBPACK_IMPORTED_MODULE_6__components_dropdown_Dropdown_vue__["a" /* default */],
    Tree: __WEBPACK_IMPORTED_MODULE_7__components_tree_Tree_vue__["a" /* default */],
    Sidebar: __WEBPACK_IMPORTED_MODULE_8__components_sidebar_Sidebar_vue__["a" /* default */],
    Loader: __WEBPACK_IMPORTED_MODULE_9__components_loader_Loader_vue__["a" /* default */],
    VuePerfectScrollbar: __WEBPACK_IMPORTED_MODULE_5_vue_perfect_scrollbar___default.a,
    UserInfo: __WEBPACK_IMPORTED_MODULE_16__modules_userInfo_UserInfo_vue__["a" /* default */],
    Search: __WEBPACK_IMPORTED_MODULE_10__components_search_Search_vue__["a" /* default */],
    SearchMapLevel: __WEBPACK_IMPORTED_MODULE_11__components_searchMapLevel_SearchMapLevel_vue__["a" /* default */],
    CamsList: __WEBPACK_IMPORTED_MODULE_12__components_camsList_CamsList_vue__["a" /* default */],
    MapList: __WEBPACK_IMPORTED_MODULE_13__components_mapList_MapList_vue__["a" /* default */]
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_18__api_view_view_api__["a" /* viewApiService */].getViews(this.$store.state.user.login).then(function (views) {
      _this.$store.commit("setViews", views);

      // todo
      var view = _this.$store.getters["getActiveView"];

      if (view) {
        _this.$store.commit("setGrid", view.grid);
      }
    });

    this.$store.dispatch("getMaps");

    __WEBPACK_IMPORTED_MODULE_17__services_EventBus_js__["a" /* EventBus */].$on("resize:end", this.onResizeEnd);
    __WEBPACK_IMPORTED_MODULE_17__services_EventBus_js__["a" /* EventBus */].$on("changeMapPosition", this.onChangeMapPosition);
  },
  mounted: function mounted() {
    this.setCamsMode("list");
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_17__services_EventBus_js__["a" /* EventBus */].$off("resize:end", this.onResizeEnd);
    __WEBPACK_IMPORTED_MODULE_17__services_EventBus_js__["a" /* EventBus */].$off("changeMapPosition", this.onChangeMapPosition);
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])({
    maps: "getMaps",
    alarmMaps: "getAlarmMaps",
    allCams: "getCams",
    user: "getUser",
    activeView: "getActiveView",
    grids: "getGrids",
    stream: "getStream",
    activeGrid: "getActiveGrid",
    activeMap: "getActiveMap"
  }), {
    cams: function cams() {
      var _this2 = this;

      var cams = this.allCams.filter(function (item) {
        var name = item.name.toLowerCase();
        var search = _this2.sidebars.cams.search.toLowerCase();

        return name.indexOf(search) > -1;
      });

      return cams || [];
    },
    disableGrid: function disableGrid() {
      return this.$route.name === "alarms" || this.$route.name === "map" && this.$store.state.mapMode === "map" || this.$route.name === "map" && this.activeMap && !this.activeMap.cams.length || this.activeView && this.activeView.isGlobalView;
    },
    gridTitle: function gridTitle() {
      return this.activeView && this.activeView.isGlobalView ? this.$t("global.disabledGrid") : "";
    }
  }),
  watch: {
    $route: {
      immediate: true,
      handler: function handler(route) {
        if (route.name !== "views") {
          this.sidebars.maps.isViewCamsSetted = false;
        }
        switch (route.name) {
          case "alarms":
            this.sidebars.cams.show = false;
            this.sidebars.maps.open = false;
            break;

          case "views":
            this.sidebars.cams.show = true;

            if (route.params.mapId && route.params.mapGroupId) this.sidebars.maps.modes.active = "views";

            this.$nextTick(function () {
              return __WEBPACK_IMPORTED_MODULE_17__services_EventBus_js__["a" /* EventBus */].$emit("views:select");
            });
            break;

          case "map":
            this.sidebars.cams.show = true;
            break;
        }
      }
    },
    activeMap: {
      handler: function handler(map) {
        var _this3 = this;

        /**
         * Из за resetTempView или addCamsIntoView
         * может вызываться последовательность getters
         * getCams (использует state.views и view.cams) =>
         * getCamsMap => getMapById => getActiveMap. Это влечет зацикливание,
         * поэтому сделаем такую проверку
         *
         * ВАЖНО - карта ЗАВИСИМА от камер, а не от параметров route.params.mapGroupId и
         * route.params.mapId, то есть пока не пройдет хотя бы первый запрос камер
         * getCamsMap => getMapById => getActiveMap - эти геттеры не вызовутся
         */
        // if (map && this.sidebars.maps.modes.active === 'views' && !this.sidebars.maps.isViewCamsSetted) {

        if (!map) return;

        var isMapGroupNotDefined = this.prevParams.mapGroupId === null || this.prevParams.mapGroupId === undefined;

        var isMapIdNotDefined = this.prevParams.mapId === null || this.prevParams.mapId === undefined;

        var isSameMap = this.prevParams.mapId === map.id && this.prevParams.mapGroupId === this.$route.params.mapGroupId;

        if (!isMapGroupNotDefined && !isMapIdNotDefined && isSameMap && this.$route.params.camId == undefined) {
          return;
        }

        var camIds = [];
        if (this.$route.params.camId !== undefined) {
          camIds = [this.$route.params.camId];
        } else {
          var camsFilter = map.cams.filter(function (cam) {
            return cam.x >= _this3.visualRectPersent.left && cam.x <= _this3.visualRectPersent.right && cam.y >= _this3.visualRectPersent.top && cam.y <= _this3.visualRectPersent.bottom;
          });
          camIds = camsFilter.map(function (cam) {
            return cam.id;
          });
        }

        this.$store.commit("resetTempView");

        this.$store.commit("addCamsIntoView", {
          camIds: camIds,
          viewId: "main"
        });

        this.prevParams = {
          mapId: map.id,
          mapGroupId: this.$route.params.mapGroupId
        };

        this.sidebars.maps.isViewCamsSetted = true;
      },

      immediate: true
    }
  },
  methods: {
    setMode: function setMode(mode) {
      this.$store.commit("setMode", mode);

      this.$nextTick(function () {
        __WEBPACK_IMPORTED_MODULE_17__services_EventBus_js__["a" /* EventBus */].$emit("mode:change");
      });
    },
    setCamsMode: function setCamsMode(mode) {
      this.sidebars.cams.modes.active = mode;
      this.updateScroll(this.$refs.camsScroll);
    },
    setGrid: function setGrid(grid) {
      this.$store.dispatch("setGrid", grid.value);
      this.$nextTick(function () {
        __WEBPACK_IMPORTED_MODULE_17__services_EventBus_js__["a" /* EventBus */].$emit("views:select");
      });
    },
    changeMapMode: function changeMapMode(mode) {
      if (mode === "map") {
        this.visualRectPersent = getVisualRectPersent();
      }
      if (this.activeMap) {
        var params = {
          mapGroupId: this.activeMap.group.id,
          mapId: this.activeMap.id
        };

        if (mode === "views") params.viewId = "main";
        this.$router.push({ name: mode, params: params });
      }

      this.sidebars.maps.modes.active = mode;
    },
    onResizeEnd: function onResizeEnd() {
      this.updateScroll(this.$refs.camsScroll);
      this.updateScroll(this.$refs.mapsScroll);
      this.updateScroll(this.$refs.mapsAlarmScroll);
    },
    onChangeMapPosition: function onChangeMapPosition(visualRectPersent) {
      this.visualRectPersent = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, visualRectPersent);
    },
    getAllAlarms: function getAllAlarms() {
      this.sidebars.cams.show = false;
      this.$router.push({ name: "alarms" });
    },
    updateScroll: function updateScroll(ref) {
      if (ref) {
        this.$nextTick(function () {
          ref.update();
        });
      }
    },
    openAlarms: function openAlarms() {
      var _this4 = this;

      this.loading.alarms = true;

      var params = {
        startTime: __WEBPACK_IMPORTED_MODULE_4_moment___default()().startOf("day").format(),
        stopTime: __WEBPACK_IMPORTED_MODULE_4_moment___default()().format(),
        max_count: 6
      };

      __WEBPACK_IMPORTED_MODULE_19__api_alarm_alarm_api__["a" /* alarmApiService */].getAlarms(this.cams, params).then(function (alarms) {
        _this4.latestAlarms = alarms;
        _this4.loading.alarms = false;
      }).finally(function () {
        return _this4.loading.alarms = false;
      });
    },
    getAlarmComment: function getAlarmComment(alarm) {
      return __WEBPACK_IMPORTED_MODULE_15__modules_alarms_Alarms_vue__["a" /* default */].methods.getComment(alarm);
    },
    onSelectStream: function onSelectStream(stream) {
      this.$store.commit("changeStream", stream.value);
    },
    goToAlarm: function goToAlarm(alarm) {
      var _this5 = this;

      this.$router.push({
        name: "alarms",
        params: { alarmId: alarm.id }
      });
      this.$nextTick(function () {
        return _this5.$store.commit("setMode", 1);
      });
    },
    isCamSelected: function isCamSelected(cam) {
      if (this.activeView) return this.activeView.cams.some(function (c) {
        return c.id == cam.id;
      });

      if (this.activeMap) return this.activeMap.cams.some(function (c) {
        return c.id == cam.id;
      });

      return false;
    }
  }
});

/***/ }),

/***/ 421:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_EventBus__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_uuid__ = __webpack_require__(847);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Dropdown",
  data: function data() {
    return {
      show: this.open,
      positions: this.type,
      id: Object(__WEBPACK_IMPORTED_MODULE_2_uuid__["a" /* v4 */])()
    };
  },

  props: {
    type: {
      type: String,
      default: "right"
    },
    isSelect: {
      type: Boolean,
      default: false
    },
    container: {
      default: null
    },
    open: {
      type: Boolean,
      default: false
    },
    closeOther: {
      type: Boolean,
      default: true
    },
    notHideOnList: {
      type: Boolean,
      default: false
    },
    widthContainer: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    var _this = this;

    if (this.isSelect) this.$parent.$on("select:open", function () {
      _this.calculate();
    });

    this.$parent.$on("select:close", function () {
      _this.show = false;
      _this.$emit("update:open", false);
    });
  },

  watch: {
    open: function open(value) {
      this.show = value;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_1__services_EventBus__["a" /* EventBus */].$on("root-click", function () {
      _this2.show = false;
      _this2.$emit("update:open", false);
    });

    __WEBPACK_IMPORTED_MODULE_1__services_EventBus__["a" /* EventBus */].$on("dropdown:open", function (target) {
      var elementInside = _this2.$children.some(function (childElement) {
        return childElement.$el.dataset.id == target.dataset.id;
      });

      if (_this2.id != target.dataset.id && _this2.show && !elementInside) {
        _this2.show = false;
        _this2.$emit("update:open", false);
      }
    });
  },

  methods: {
    toggle: function toggle(event) {
      var _this3 = this;

      if (!this.show && this.closeOther) {
        __WEBPACK_IMPORTED_MODULE_1__services_EventBus__["a" /* EventBus */].$emit("dropdown:open", event.target);
      }

      this.show = !this.show;
      this.$emit("update:open", this.show);

      if (this.show) {
        if (this.container) {
          this.$nextTick(function () {
            if (!_this3.isSelect) _this3.calculate();

            _this3.$emit("open");
          });
        } else this.$emit("open");
      }
    },
    calculate: function calculate() {
      var containerRects = this.container.getBoundingClientRect();
      var toggleRects = this.$refs.toggle.getBoundingClientRect();
      var listRects = this.$refs.list.getBoundingClientRect();
      var align = containerRects.right - listRects.right < 0 ? "right" : "left";
      var valign = containerRects.bottom - (toggleRects.bottom + listRects.height) < 0 ? "bottom" : "right";
      this.positions = align + " " + valign;
    },
    onClickList: function onClickList() {
      if (!this.notHideOnList) {
        this.show = false;
      }
    }
  }
});

/***/ }),

/***/ 424:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_tree_Tree_item_vue__ = __webpack_require__(856);




__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('tree-item', __WEBPACK_IMPORTED_MODULE_2__components_tree_Tree_item_vue__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Tree',
    data: function data() {
        return {
            bus: new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]()
        };
    },
    created: function created() {
        var _this = this;

        this.bus.$on('select', function (model) {
            _this.$emit('select', model);
        });

        this.bus.$on('update', function () {
            __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].nextTick(function () {
                _this.$emit('update');
            });
        });
    },

    props: {
        data: {
            type: Array,
            required: true
        },
        root: {
            type: [Number, String],
            default: null
        },
        value: {
            type: [Number, String],
            default: null
        },
        search: {
            type: String,
            default: ''
        },
        /**
         * для выклчения иерархии, но сейчас не используется
         */
        notHierarchy: {
            type: Boolean,
            default: false
        },
        selectOnName: {
            type: Boolean,
            default: false
        },
        /**
         * открытые по умолчанию деревья,
         * если false то см. компонент tree-item
         */
        openDefault: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        tree: function tree() {
            var _this2 = this;

            var tree = [];
            this.data.forEach(function (item) {
                var sorted = _.sortBy(item.children, function (map) {
                    return map.parent;
                }).map(function (m) {
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, m, { root: item.value, children: [] });
                });
                var treeList = [];
                var lookup = {};
                sorted.forEach(function (obj) {
                    if (!_this2.notHierarchy) {
                        if (lookup[obj.value] === undefined) {
                            lookup[obj.value] = obj;
                        }
                    } else {
                        tree.push(obj);
                    }
                });

                if (!_this2.notHierarchy) {
                    sorted.forEach(function (obj) {
                        if (obj.parent !== 0) {
                            lookup[obj.parent].children.push(obj);
                        } else {
                            treeList.push(obj);
                        }
                    });
                    tree.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item, {
                        children: treeList,
                        value: null,
                        root: item.value
                    }));
                }
            });
            return tree;
        }
    }
});

/***/ }),

/***/ 425:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_utils_isContains__ = __webpack_require__(426);




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'TreeItem',
    data: function data() {
        return {
            open: false

        };
    },

    props: {
        model: {
            type: Object
        },
        bus: {
            type: Object,
            required: true
        },
        root: {
            type: [Number, String],
            default: null
        },
        value: {
            type: [Number, String],
            default: null
        },
        search: {
            type: String,
            default: ''
        },
        level: {
            type: Number,
            default: 1
        },
        /**
         * Если в model имеется поле isHighRoot
         * в значении true, то действие этого свойства
         * отменяется
         */
        selectOnName: {
            type: Boolean,
            default: false
        },
        openDefault: {
            type: Boolean,
            default: false
        }
    },
    created: function created() {
        this.updateTree();
    },

    computed: {
        hasChildren: function hasChildren() {
            return this.model.children && this.model.children.length;
        },
        active: function active() {
            return this.model.root == this.root && this.model.value == this.value;
        },
        found: function found() {
            return this.isContains(this.search, this.model.name);
        }
    },
    watch: {
        search: function search() {
            this.updateTree();
        },
        value: function value() {
            this.updateTree();
        }
    },
    methods: {
        isContains: __WEBPACK_IMPORTED_MODULE_2__components_utils_isContains__["a" /* isContains */],

        toggle: function toggle() {
            var _this = this;

            this.open = !this.open;
            this.$nextTick(function () {
                _this.bus.$emit('update');
            });
        },
        emitSelect: function emitSelect() {
            this.bus.$emit('select', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.model));
        },
        select: function select(model) {
            if (this.selectOnName && !model.isHighRoot || !this.model.children || this.model.children.length === 0) {
                this.emitSelect();
                return;
            }
            this.toggle();
        },
        onIconClick: function onIconClick(event, model) {
            if (this.selectOnName && !model.isHighRoot) {
                event.stopPropagation();
                this.toggle();
            }
        },
        findByCriteria: function findByCriteria(model, criteria) {
            var i = void 0,
                currentChild = void 0,
                result = void 0;

            if (criteria(model)) {
                return model;
            } else {
                if (model.children) for (i = 0; i < model.children.length; i++) {
                    currentChild = model.children[i];

                    result = this.findByCriteria(currentChild, criteria);

                    if (result !== false) {
                        return result;
                    }
                }

                return false;
            }
        },
        updateTree: function updateTree() {
            var _this2 = this;

            if (this.openDefault) {
                this.open = true;
                return;
            }
            if (this.search && this.search.length) {
                this.open = !!this.findByCriteria(this.model, function (model) {
                    return model.children.some(function (item) {
                        return _this2.isContains(_this2.search, item.name);
                    });
                });
            } else {
                if (this.model.root == this.root) {
                    this.open = this.findByCriteria(this.model, function (model) {
                        return model.children.some(function (item) {
                            return item.value == _this2.value;
                        });
                    }) || this.open;
                }
            }
        }
    }
});

/***/ }),

/***/ 426:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isContains; });
var isContains = function isContains(keyword, string) {
  var isEmptyString = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (isEmptyString && !keyword.length) {
    return true;
  }
  return keyword.length && string.toLowerCase().indexOf(keyword.toLowerCase()) > -1;
};

/***/ }),

/***/ 427:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_sidebar_js__ = __webpack_require__(428);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_078c664a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__ = __webpack_require__(872);
function injectStyle (ssrContext) {
  __webpack_require__(860)
}
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-078c664a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_sidebar_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_078c664a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 428:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_downloadList_DownloadList_vue__ = __webpack_require__(861);


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Sidebar',
    data: function data() {
        return {
            downloadVisible: false
        };
    },

    props: {
        type: {
            type: String,
            default: 'left'
        },
        open: {
            type: Boolean,
            default: true
        },
        show: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        toggle: function toggle(isShow) {
            this.$emit('update:open', isShow === true ? isShow : !this.open);

            if (this.open) this.$emit('open');
        }
    },
    components: {
        DownloadList: __WEBPACK_IMPORTED_MODULE_0__components_downloadList_DownloadList_vue__["a" /* default */]
    }
});

/***/ }),

/***/ 429:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__downloadListItem_DownloadListItem_vue__ = __webpack_require__(863);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_circleProgress_CircleProgress_vue__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_perfect_scrollbar__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_perfect_scrollbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_perfect_scrollbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(41);







/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'download-list',
    props: {
        closeMenu: {
            type: Boolean,
            default: false
        }
    },
    data: function data() {
        return {
            compactMode: true
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({
        videos: 'getUplodedVideos',
        videoState: 'getVideoState'
    })),
    components: {
        DownloadListItem: __WEBPACK_IMPORTED_MODULE_1__downloadListItem_DownloadListItem_vue__["a" /* default */],
        CircleProgress: __WEBPACK_IMPORTED_MODULE_2__components_circleProgress_CircleProgress_vue__["a" /* default */],
        VuePerfectScrollbar: __WEBPACK_IMPORTED_MODULE_3_vue_perfect_scrollbar___default.a
    },
    methods: {
        toggle: function toggle() {
            if (!this.closeMenu) {
                this.compactMode = !this.compactMode;
                this.$emit('changeVisible', !this.compactMode);
            }
        }
    },
    watch: {
        videos: function videos() {
            if (!this.videos || !this.videos.length) {
                this.compactMode = true;
                this.$emit('changeVisible', !this.compactMode);
            }
        },
        closeMenu: function closeMenu() {
            if (this.closeMenu) {
                this.compactMode = true;
                this.$emit('changeVisible', !this.compactMode);
            }
        }
    }
});

/***/ }),

/***/ 430:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_EventBus__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_circleProgress_CircleProgress_vue__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_tooltip_Tooltip_vue__ = __webpack_require__(867);



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'download-list-item',
    props: {
        video: {
            type: Object,
            default: {
                intervalDateVideo: null,
                percent: null,
                source_id: null,
                session: null,
                link: null,
                statusLoad: null,
                tooltipText: null
            }
        },
        index: {
            type: Number,
            required: true
        }
    },
    methods: {
        deleteVideo: function deleteVideo() {
            __WEBPACK_IMPORTED_MODULE_0__services_EventBus__["a" /* EventBus */].$emit('stop-export-file', this.video.session);
            this.$store.commit('deleteUplodedVideo', this.video.session);
        }
    },
    components: {
        CircleProgress: __WEBPACK_IMPORTED_MODULE_1__components_circleProgress_CircleProgress_vue__["a" /* default */],
        Tooltip: __WEBPACK_IMPORTED_MODULE_2__components_tooltip_Tooltip_vue__["a" /* default */]
    }
});

/***/ }),

/***/ 431:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_circleProgress_js__ = __webpack_require__(432);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e0bfaff_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CircleProgress_vue__ = __webpack_require__(866);
function injectStyle (ssrContext) {
  __webpack_require__(865)
}
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5e0bfaff"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_circleProgress_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e0bfaff_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CircleProgress_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 432:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'circle-progress',
    props: {
        progress: {
            type: Number,
            default: 50
        },
        status: {
            default: 'progress',
            validator: function validator(value) {
                return ['success', 'fail', 'progress'].includes(value);
            }
        }
    },
    data: function data() {
        return {
            circumference: 2 * Math.PI * 54
        };
    },

    computed: {
        dashoffset: function dashoffset() {
            return this.circumference * (1 - this.progress / 100);
        }
    }
});

/***/ }),

/***/ 433:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    name: "Tooltip",
    props: {
        text: {
            type: String,
            default: null
        },
        animation: {
            type: Boolean,
            default: false
        },
        position: {
            type: String,
            required: false,
            default: 'top-right'
        }
    }
});

/***/ }),

/***/ 434:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Loader',
    data: function data() {
        return {};
    },

    props: {
        type: {
            type: String,
            default: 'medium'
        }
    },
    methods: {}
});

/***/ }),

/***/ 435:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Search',
  props: {
    value: String,
    placeholder: String,
    clear: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onInput: function onInput() {
      this.$emit('input', this.$refs.searchInput.value);
    },
    clearInput: function clearInput() {
      this.$emit('input', '');
    }
  }
});

/***/ }),

/***/ 436:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_modal_Modal_vue__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_mapList_MapList_vue__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_search_Search_vue__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_dropdownSelect_DropdownSelect_vue__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_utils_isContains__ = __webpack_require__(426);








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SearchMapLevel',
  props: {
    maps: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    routeName: {
      type: String,
      default: 'map' // map || views
    }
  },
  data: function data() {
    return {
      modalShow: false,
      search: '',
      selectedMapGroups: [],
      mapListKey: false
    };
  },

  computed: {
    groupOptions: function groupOptions() {
      return this.maps.map(function (mapGroup) {
        var groupOption = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, mapGroup);
        delete groupOption.map;
        return groupOption;
      });
    },
    mapsCmp: function mapsCmp() {
      var _this = this;

      var result = [];
      // фильтр по выбранным группам
      result = this.maps.filter(function (mapGroup) {
        if (!_this.selectedMapGroups.length) return true;
        return _this.selectedMapGroups.find(function (selectedGroup) {
          return selectedGroup.id === mapGroup.id;
        }) !== undefined;
      });
      result = result.map(function (mapGroup) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, mapGroup, {
          map: mapGroup.map.reduce(function (acc, map) {
            /**
             * при рекурсии this.getAllMapParents, карта уже может быть доабвлена,
             */
            if (acc.find(function (mapAcc) {
              return mapAcc.id === map.id;
            }) === undefined) {
              /**
               * Подмешиваем новые свойства из стора
               */
              var mapObjects = _this.$store.getters.getCamsMap(map.objects);
              // фильтр по моделке поиска
              mapObjects = mapObjects.filter(function (cam) {
                return Object(__WEBPACK_IMPORTED_MODULE_6__components_utils_isContains__["a" /* isContains */])(_this.search, cam.name, true);
              });

              if (Object(__WEBPACK_IMPORTED_MODULE_6__components_utils_isContains__["a" /* isContains */])(_this.search, map.name, true) || mapObjects.length) {
                var mapParents = [];
                /**
                 * избегаем строгого равенства
                 */
                if (map.parent && acc.find(function (accMap) {
                  return accMap.id == map.parent;
                }) === undefined) {
                  mapParents = _this.getAllMapParents(map, mapGroup.map, []);
                }

                return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(acc), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(mapParents), [__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, map, {
                  objects: mapObjects
                })]).sort(function (a, b) {
                  return a.id - b.id;
                });
              }
            }
            return acc;
          }, [])
        });
      }, []);
      // Если во вложенных уровнях и объектах нет совпадений по search моделе, то
      // филтруем названия групп по search моделе
      result = result.filter(function (mapGroup) {
        if (!mapGroup.map.length) {
          return Object(__WEBPACK_IMPORTED_MODULE_6__components_utils_isContains__["a" /* isContains */])(_this.search, mapGroup.name, true);
        } else return mapGroup;
      });
      return result;
    }
  },
  methods: {
    isContains: __WEBPACK_IMPORTED_MODULE_6__components_utils_isContains__["a" /* isContains */],
    /**
     * 
     * @param {*} map - карта по которой ищем родителей
     * @param {*} arrayGroup - общий массив по которому ищем родителей
     * @param {*} acc - результирующий массив
     */
    getAllMapParents: function getAllMapParents(map, arrayGroup) {
      var _this2 = this;

      var acc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

      if (map.parent) {
        /**
         * избегаем строгого равенства
         */
        var parentMap = arrayGroup.find(function (mapObject) {
          return mapObject.id == map.parent;
        });
        var parentMapObjects = this.$store.getters.getCamsMap(parentMap.objects).filter(function (cam) {
          return Object(__WEBPACK_IMPORTED_MODULE_6__components_utils_isContains__["a" /* isContains */])(_this2.search, cam.name, true);
        });
        var newAcc = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(acc), [__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, parentMap, {
          objects: parentMapObjects
        })]);
        return this.getAllMapParents(parentMap, arrayGroup, newAcc);
      }
      return acc;
    },
    clearFilters: function clearFilters() {
      this.search = '';
      this.selectedMapGroups = [];
      this.mapListKey = !this.mapListKey;
    },
    openModal: function openModal() {
      this.modalShow = true;
      document.getElementById('container').dataset.modal = true;
    },
    hideModal: function hideModal() {
      this.clearFilters();
      this.modalShow = false;
      document.getElementById('container').dataset.modal = false;
    }
  },
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_2__components_modal_Modal_vue__["a" /* default */],
    MapList: __WEBPACK_IMPORTED_MODULE_3__components_mapList_MapList_vue__["a" /* default */],
    Search: __WEBPACK_IMPORTED_MODULE_4__components_search_Search_vue__["a" /* default */],
    DropdownSelect: __WEBPACK_IMPORTED_MODULE_5__components_dropdownSelect_DropdownSelect_vue__["a" /* default */]
  }
});

/***/ }),

/***/ 437:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Modal',
    data: function data() {
        return {};
    },

    props: {
        show: {
            type: Boolean,
            default: false
        }
    }
});

/***/ }),

/***/ 438:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapList_js__ = __webpack_require__(439);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_465d7981_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MapList_vue__ = __webpack_require__(889);
function injectStyle (ssrContext) {
  __webpack_require__(881)
}
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-465d7981"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapList_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_465d7981_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MapList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 439:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_perfect_scrollbar__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_perfect_scrollbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_perfect_scrollbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_tree_Tree_vue__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_cam_Cam_vue__ = __webpack_require__(201);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MapList',
  props: {
    maps: {
      type: Array,
      default: []
    },
    routeName: {
      type: String,
      default: 'map' // map || views
    },
    search: {
      type: String,
      default: ''
    },
    showObjects: {
      type: Boolean,
      default: false
    },
    openDefault: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    mapData: function mapData() {
      return this.getMapGroup(this.maps);
    }
  },
  components: {
    VuePerfectScrollbar: __WEBPACK_IMPORTED_MODULE_3_vue_perfect_scrollbar___default.a,
    Tree: __WEBPACK_IMPORTED_MODULE_4__components_tree_Tree_vue__["a" /* default */],
    Cam: __WEBPACK_IMPORTED_MODULE_5__components_cam_Cam_vue__["a" /* default */]
  },
  methods: {
    getMapGroup: function getMapGroup(mapList) {
      var _this = this;

      var result = mapList.map(function (group) {
        if (group) {
          var map = group.map.reduce(function (acc, item) {
            var itemCorrect = {
              value: item.id,
              name: item.name,
              parent: item.parent
            };
            var cams = [];
            if (_this.showObjects && item.objects && item.objects.length) {
              cams = _this.$store.getters.getCamsMap(item.objects).map(function (cam) {
                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
                  /**
                   * именно item.id - то есть id карты,
                   * так как по итогу нажатие на элемент должно
                   * установить нужную карту
                   */
                  value: item.id,
                  name: cam.name,
                  parent: item.id
                }, cam);
              });
            }
            /**
             * Порядок добавления acc, cams, itemCorrect ОБЯЗАТЕЛЕН!!!
             */
            var result = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(acc), [itemCorrect], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(cams));
            return result;
          }, []);

          return {
            value: group.id,
            name: group.name,
            children: map,
            isHighRoot: true
          };
        }
      });
      return result;
    },
    checkSameRoute: function checkSameRoute(newRouteObj) {
      if (this.$route.name !== newRouteObj.name) {
        return false;
      }
      var paramsKeys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$route.params);
      for (var i = 0; i < paramsKeys.length; i++) {
        var key = paramsKeys[i];
        if (this.$route.params[key] !== newRouteObj.params[key]) {
          return false;
        }
      }
      return true;
    },
    setMap: function setMap(map) {
      if (this.routeName === 'map' && !map.value) {
        return;
      }
      var params = { mapGroupId: map.root, mapId: map.value };
      if (this.routeName === 'views') {
        params.viewId = 'main';
      }
      var newRouteObj = { name: this.routeName, params: params };
      if (!this.checkSameRoute(newRouteObj)) {
        this.$router.push(newRouteObj);
      }
      this.$emit('map-setted');
    },
    updateScroll: function updateScroll() {
      var _this2 = this;

      this.$nextTick(function () {
        _this2.$refs.mapListScroll.update();
      });
    }
  }
});

/***/ }),

/***/ 440:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_EventBus__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_iconCam_IconCam_vue__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(73);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Cam",
  data: function data() {
    return {};
  },

  props: {
    cam: {
      type: Object
    },
    draggable: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Boolean,
      default: false
    },
    inMap: {
      type: Boolean,
      default: false
    },
    notHover: {
      type: Boolean,
      default: false
    },
    notContraction: {
      type: Boolean,
      default: false
    },
    notViews: {
      type: Boolean,
      default: false
    },
    hovered: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    status: function status() {
      var cam = this.cam;

      return cam && cam.status && cam.status.state || null;
    }
  },
  methods: {
    dragStart: function dragStart() {
      if (this.selected || !this.draggable) return false;

      __WEBPACK_IMPORTED_MODULE_0__services_EventBus__["a" /* EventBus */].$emit("cam:dragstart");
    },
    dragEnd: function dragEnd() {
      __WEBPACK_IMPORTED_MODULE_0__services_EventBus__["a" /* EventBus */].$emit("cam:dragend");
    },
    selectView: function selectView(view) {
      this.$store.commit("setGrid", view.grid);
      this.$router.push({ name: "views", params: { viewId: view.id } });
    },

    getViewName: __WEBPACK_IMPORTED_MODULE_2__utils__["c" /* getViewName */]
  },
  components: {
    IconCam: __WEBPACK_IMPORTED_MODULE_1__components_iconCam_IconCam_vue__["a" /* default */]
  }
});

/***/ }),

/***/ 441:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_iconCam_js__ = __webpack_require__(442);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29c67b2e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IconCam_vue__ = __webpack_require__(887);
function injectStyle (ssrContext) {
  __webpack_require__(886)
}
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-29c67b2e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_iconCam_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29c67b2e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IconCam_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 442:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__consts_mapObjSizes__ = __webpack_require__(202);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "IconCam",
  props: {
    cam: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      default: "map" // map | preview - если map вычисляется поворот иконки, позиционировние задается в род. компоенете
    },
    isAlarm: {
      type: Boolean,
      default: false
    },
    isHighlight: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: 35
    },
    scale: {
      type: String,
      default: "",
      validator: function validator(scaleType) {
        return ["S", "L", ""].includes(scaleType);
      }
    }
  },
  computed: {
    styleIcon: function styleIcon() {
      var res = {};
      if (this.type !== "preview") {
        res.width = this.width + "px";
        res.height = this.width + "px";
      }
      if (this.type === "map") {
        res.transform = "rotate(" + this.cam.rotation + "rad)";
      }
      return res;
    },
    iconStatusSize: function iconStatusSize() {
      if (this.scale !== "" && this.type === "map") {
        return {
          height: __WEBPACK_IMPORTED_MODULE_0__consts_mapObjSizes__["a" /* mapObjSizes */][this.scale].cam.alarmIcon + "px",
          width: __WEBPACK_IMPORTED_MODULE_0__consts_mapObjSizes__["a" /* mapObjSizes */][this.scale].cam.alarmIcon + "px"
        };
      }

      return {
        height: 15 + "px",
        width: 15 + "px"
      };
    },
    status: function status() {
      var cam = this.cam;

      return cam && cam.status && cam.status.state || null;
    }
  }
});

/***/ }),

/***/ 443:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_dropdown_Dropdown_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_perfect_scrollbar__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_perfect_scrollbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_perfect_scrollbar__);






/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'dropdown-select',
    data: function data() {
        return {
            scroll: false,
            container: document.body
        };
    },

    props: {
        list: {
            type: Array,
            default: function _default() {
                return [];
            }
        },
        value: {
            default: null // String | Object | Array<object>
        },
        /**
         * при множественном выборе
         * предполагается, что выбираться будут все
         * по умолчанию, поэтому в этом случае placeholder
         * обязателен
         */
        placeholderAll: {
            type: String,
            default: 'global.all'
        },
        name: String,
        /**
         * максимальное количество показа элементов
         */
        max: {
            type: Number,
            default: 8
        },
        /**
         * классы стилей
         */
        type: {
            type: String
        },
        /**
         * будет ли emit input 
         * всего обекта, а не только поля имени
         */
        isValueObject: {
            type: Boolean,
            default: false
        },
        idField: {
            type: String,
            default: 'id'
        },
        nameField: {
            type: String,
            default: 'name'
        }
    },
    computed: {
        selected: function selected() {
            if (Array.isArray(this.value)) {
                return this.value.length !== 0;
            }
            return !!this.value;
        },
        valueText: function valueText() {
            var _this = this;

            if (Array.isArray(this.value)) {
                if (!this.value.length || this.value.length === this.list.length) {
                    return this.placeholderAll;
                }
                if (this.value.length === 1) {
                    return this.value[0][this.nameField];
                }
                return this.value.length;
            }
            if (this.value !== null && this.value !== undefined) {
                if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(this.value) === 'object') {
                    return this.value[this.nameField];
                }
                /**
                 * Поскольку мы отправляем id как значение (для компонента карты)
                 * то нужно найти текст значения в самих опциях
                 * 
                 * 
                 * !!лучше НЕ строгое равенство
                 */
                var listOption = this.list.find(function (option) {
                    return option[_this.idField] == _this.value;
                });
                if (listOption) {
                    return listOption[this.nameField];
                }
                return this.value;
            }
            return '';
        },
        getOptionName: function getOptionName() {
            var _this2 = this;

            return function (option) {
                if ((typeof option === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(option)) === 'object') {
                    return option[_this2.nameField];
                }
                return option;
            };
        },
        getOptionActive: function getOptionActive() {
            var _this3 = this;

            return function (option) {
                /**
                 * пока рассматривается ТОЛЬКО сценарий массива объектов
                 */
                if (Array.isArray(_this3.value)) {
                    return _this3.value.find(function (valueItem) {
                        return valueItem[_this3.idField] === option[_this3.idField];
                    });
                }
                if (_this3.isValueObject) {
                    return _this3.value[_this3.idField] === option[_this3.idField];
                }
                /**
                 * отправляем мы именно idField (для компоенента карты)
                 */
                return option[_this3.idField] === _this3.value;
            };
        }
    },
    methods: {
        emitValue: function emitValue(emitedValue) {
            this.$emit('update:value', emitedValue);
            this.$emit('change', emitedValue);
            this.$emit('input', emitedValue);
            this.$emit('blur');
        },
        select: function select(item) {
            var _this4 = this;

            var emitedValue = item;
            /**
             * пока рассматривается ТОЛЬКО сценарий массива объектов
             */
            if (Array.isArray(this.value)) {
                emitedValue = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.value));
                var itemIndexValue = emitedValue.findIndex(function (valueItem) {
                    return valueItem[_this4.idField] === item[_this4.idField];
                });
                if (itemIndexValue !== -1) {
                    emitedValue.splice(itemIndexValue, 1);
                } else {
                    emitedValue.push(item);
                }
            } else if (this.isValueObject) {
                emitedValue = item;
            } else {
                /**
                 * отправляем мы именно idField (для компоенента карты)
                 */
                emitedValue = (typeof item === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(item)) === 'object' ? item[this.idField] : item;
            }
            this.emitValue(emitedValue);
        },
        selectAll: function selectAll() {
            var emitedValue = [];
            if (this.value.length < this.list.length) {
                emitedValue = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.list));
            }
            this.emitValue(emitedValue);
        },
        openDropdown: function openDropdown() {
            var _this5 = this;

            var option = this.$refs.scroll.$el.getElementsByClassName('first')[0];
            var content = this.$refs.options;
            var wrap = this.$refs.wrap;

            if (option && content) {
                this.$nextTick(function () {
                    var itemHeight = option.clientHeight + _this5.getStyleValue(option, 'marginBottom') + _this5.getStyleValue(option, 'marginTop');
                    var maxHeight = itemHeight * _this5.max + _this5.getStyleValue(wrap, 'paddingBottom') + _this5.getStyleValue(wrap, 'paddingTop');
                    var height = _this5.list.length * itemHeight;
                    _this5.scroll = height > maxHeight;

                    content.style.height = _this5.scroll ? maxHeight + 'px' : 'auto';

                    _this5.$refs.scroll.update();
                    _this5.$emit('select:open');
                });
            }
        },
        getStyleValue: function getStyleValue(el, style) {
            return parseInt(window.getComputedStyle(el)[style]);
        }
    },
    components: {
        Dropdown: __WEBPACK_IMPORTED_MODULE_3__components_dropdown_Dropdown_vue__["a" /* default */],
        VuePerfectScrollbar: __WEBPACK_IMPORTED_MODULE_4_vue_perfect_scrollbar___default.a
    }
});

/***/ }),

/***/ 445:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_camsList_js__ = __webpack_require__(446);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_767452b8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CamsList_vue__ = __webpack_require__(904);
function injectStyle (ssrContext) {
  __webpack_require__(903)
}
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-767452b8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_camsList_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_767452b8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CamsList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 446:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_tree_Tree_vue__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_cam_Cam_vue__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_EventBus_js__ = __webpack_require__(18);






var sortName = function sortName(a, b) {
    if (a.name < b.name) {
        return -1;
    }
    if (a.name > b.name) {
        return 1;
    }
    return 0;
};
var sortGroup = function sortGroup(a, b) {

    if (!Array.isArray(a) && Array.isArray(b)) {
        return 1;
    }

    if (Array.isArray(a) && !Array.isArray(b)) {
        return -1;
    }

    if (Array.isArray(a) && Array.isArray(b)) {
        return sortName(a[0], b[0]);
    }

    return sortName(a, b);
};

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'cams-list',
    props: {
        cams: {
            type: Array,
            default: function _default() {
                return [];
            }
        },
        preview: {
            type: Boolean,
            default: false
        },
        draggable: {
            type: Boolean,
            default: false
        },
        hovered: {
            type: Boolean,
            default: false
        },
        /**
         * принимает объект камеры и возвращает булево
         */
        isCamSelected: {
            type: Function
        }
    },
    components: {
        Tree: __WEBPACK_IMPORTED_MODULE_2__components_tree_Tree_vue__["a" /* default */],
        Cam: __WEBPACK_IMPORTED_MODULE_3__components_cam_Cam_vue__["a" /* default */]
    },
    computed: {
        camGroups: function camGroups() {
            var groups = [];
            // для себя определим собственный разделитель
            var operateDelemeter = ':';
            // тут перечисляем все разделители в массиве
            var delimeterSymbols = [operateDelemeter];
            var pathDelimeter = new RegExp('[' + delimeterSymbols.map(function (s) {
                return '\\' + s;
            }).join('') + ']+');

            this.cams.forEach(function (camObj) {
                var groupPath = camObj.name.split(pathDelimeter).map(function (path) {
                    return path.trim();
                });
                if (groupPath.length > 1) {
                    var existGroup = null;

                    var _loop = function _loop(i) {
                        var path = groupPath[i];
                        if (i === 0) {
                            existGroup = groups.find(function (g) {
                                return Array.isArray(g) && g[0].value === path;
                            });
                            if (!existGroup) {
                                existGroup = [{
                                    value: path,
                                    name: path,
                                    children: []
                                }];
                                groups.push(existGroup);
                            }
                        } else {
                            var pathItem = groupPath.slice(0, i + 1).join(operateDelemeter);
                            var pathParent = groupPath.slice(0, i).join(operateDelemeter);
                            if (!existGroup[0].children.find(function (item) {
                                return item.pathParent === pathParent && item.value === pathItem;
                            })) {
                                if (i !== groupPath.length - 1) {

                                    existGroup[0].children.push({
                                        name: path,
                                        value: pathItem,
                                        parent: i == 1 ? 0 : pathParent,
                                        pathParent: pathParent
                                    });
                                } else {
                                    existGroup[0].children.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, camObj, {
                                        name: path,
                                        value: pathItem,
                                        parent: i == 1 ? 0 : pathParent,
                                        pathParent: pathParent
                                    }));
                                }

                                existGroup[0].children.sort(sortName);
                            }
                        }
                    };

                    for (var i = 0; i < groupPath.length; i++) {
                        _loop(i);
                    }
                } else {
                    groups.push(camObj);
                }
            });
            groups.sort(sortGroup);
            return groups;
        }
    },
    methods: {
        onCamDrag: function onCamDrag(data, event) {
            __WEBPACK_IMPORTED_MODULE_4__services_EventBus_js__["a" /* EventBus */].$emit('cam:dragstart');

            event.dataTransfer.setData('text', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
                camera_id: data.camera_id,
                connection_id: ''
            }));
        }
    }
});

/***/ }),

/***/ 447:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_EventBus__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_modal_Modal_vue__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_dropdown_Dropdown_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_inputText_InputText_vue__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_loader_Loader_vue__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modules_timeInterval_TimeInterval_vue__ = __webpack_require__(909);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__services_translateService__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__api_view_view_api__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__consts_consts__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils__ = __webpack_require__(73);


















var PATHS_TO_LOCALES = {
  exportPeriod: "video.exportPeriod",
  exportAllPeriod: "video.exportAllPeriod"
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "view-tabs",
  PATHS_TO_LOCALES: PATHS_TO_LOCALES,
  data: function data() {
    return {
      form: {
        name: {
          name: "name",
          validator: { required: true, uniqueTabName: true },
          placeholder: "viewCreateModal.inputLabel"
        }
      },
      saving: null,
      removing: null,
      max: null,
      more: false,
      updating: true,
      full: false,
      limit: false,
      isShowDownload: false,
      camera_list: "",
      isCopy: false,
      titleTextPath: ""
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_13__services_translateService__["a" /* translateService */].translate) === 0)) {
                _context.next = 4;
                break;
              }

              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_13__services_translateService__["a" /* translateService */].getTranslates();

            case 3:
              __WEBPACK_IMPORTED_MODULE_13__services_translateService__["a" /* translateService */].translate = _context.sent;

            case 4:

              _this.$validator.extend("uniqueTabName", {
                getMessage: function getMessage(field) {
                  return "customValidationError.uniqueViewName";
                },
                validate: function validate(value) {
                  return (!_this.localViews.some(function (item) {
                    return value == item.name;
                  }) ||
                  // здесь имена вьюс могут совпадать
                  !_this.isCopy && value == _this.saving.name) && value !== __WEBPACK_IMPORTED_MODULE_13__services_translateService__["a" /* translateService */].translate.ru["tabs"]["mainView"] && value !== "Main View";
                }
              });

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  mounted: function mounted() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_7__services_EventBus__["a" /* EventBus */].$on("resize:start", function () {
      _this2.updating = true;
    });
    __WEBPACK_IMPORTED_MODULE_7__services_EventBus__["a" /* EventBus */].$on("resize:end", this.updateTabs);
    __WEBPACK_IMPORTED_MODULE_7__services_EventBus__["a" /* EventBus */].$on("open:export", this.toggleExport);
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])({
    activeView: "getActiveView",
    grids: "getGrids",
    activeGrid: "getActiveGrid",
    archCnvEnabled: "getArchCnvEnabled",
    views: "getViews",
    localViews: "getLocalViews"
  }), {
    list: function list() {
      var _this3 = this;

      var result = this.views.map(function (item) {
        _this3.$set(item, "menu", false);
        return item;
      });
      return {
        tabs: result.slice(0, this.max),
        dropdown: result.slice(this.max)
      };
    },
    downloadCamsView: function downloadCamsView() {
      return this.activeView.cams.filter(function (cam) {
        return cam.privilege !== 1;
      });
    },
    dropdownMenu: function dropdownMenu() {
      var _this4 = this;

      return function (tab) {
        var isHorizintal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

        return [{
          title: "viewAction.undo",
          action: function action() {
            return _this4.reset(tab);
          },
          isHorizintal: true,
          displayCondition: tab.isGlobalView ? false : tab.changed && _this4.activeView && _this4.activeView.id == tab.id
        }, {
          title: "viewAction.clear",
          action: function action() {
            return _this4.removeCamsFromView();
          },
          displayCondition: tab.isGlobalView ? false : tab.temp && tab.cams.length && _this4.activeView && _this4.activeView.id == tab.id
        }, {
          title: "btn.save",
          action: function action() {
            return _this4.save(tab);
          },
          isHorizintal: true,
          displayCondition: tab.isGlobalView ? false : !tab.temp && tab.changed && _this4.activeView && _this4.activeView.id == tab.id
        }, {
          title: "viewAction.saveAs",
          action: function action() {
            return _this4.edit(tab, !tab.temp);
          },
          displayCondition: tab.isGlobalView ? false : tab.temp ? tab.changed && _this4.activeView && _this4.activeView.id == tab.id : true
        }, {
          title: "viewAction.delete",
          action: function action() {
            return _this4.removing = tab;
          },
          displayCondition: tab.isGlobalView ? false : !tab.temp
        }, {
          title: "viewAction.rename",
          action: function action() {
            return _this4.edit(tab);
          },
          displayCondition: tab.isGlobalView ? false : !tab.temp
        }, {
          title: "viewAction.downloadAll",
          action: function action() {
            return _this4.toggleExport(_this4.downloadCamsView.map(function (cam) {
              return cam.id;
            }).join(";"), _this4.$options.PATHS_TO_LOCALES.exportAllPeriod);
          },
          displayCondition: _this4.archCnvEnabled && _this4.activeView && _this4.activeView.id == tab.id && _this4.downloadCamsView.length !== 0
        }].filter(function (option) {
          return option.displayCondition && (isHorizintal === false ? option.isHorizintal !== true : true);
        });
      };
    }
  }),
  watch: {
    views: {
      immediate: true,
      handler: function handler() {
        var _this5 = this;

        this.$nextTick(function () {
          _this5.updateTabs();
        });
      }
    },
    "$store.state.stream": {
      handler: function handler() {
        this.updateTabs();
      }
    }
  },
  methods: {
    setMaxTabs: function setMaxTabs() {
      var _this6 = this;

      if (this.$refs.list) {
        var items = this.$refs.list.children;

        var itemsWidth = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(items)).reduce(function (prev, curr) {
          var selector = curr.getElementsByClassName("inner");
          var el = selector.length ? selector[0] : curr;

          return prev + el.clientWidth;
        }, 0);

        this.full = itemsWidth / this.$refs.list.clientWidth > 0.5;

        if (items.length && this.$refs.list.clientHeight > items[0].clientHeight) {
          this.max = this.max - 1;
          this.more = true;

          this.$nextTick(function () {
            _this6.setMaxTabs();
          });
        } else {
          this.updating = false;
        }
      }
    },
    updateTabs: function updateTabs() {
      var _this7 = this;

      this.updating = true;
      this.more = false;
      this.max = this.views.length;

      setTimeout(function () {
        _this7.setMaxTabs();
      }, 300);
    },
    select: function select(view) {
      this.$store.commit("setGrid", view.grid);
      this.$router.push({ name: "views", params: { viewId: view.id } });
    },
    edit: function edit(tab) {
      var _this8 = this;

      var isCopy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (tab.isGlobalView) {
        return;
      }

      this.isCopy = isCopy;

      if (this.views.length > 10 && (tab.temp || this.isCopy)) {
        this.limit = true;
      } else {
        this.form.name.value = tab.temp ? this.getNewName() : tab.name;
        this.saving = tab;
        if (this.isCopy) {
          this.saving = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.saving, { id: undefined });
        }

        __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].nextTick(function () {
          var input = _this8.$refs["form-name"];

          if (input) input.$emit("focus");
        });

        tab.menu = false;
      }
    },
    save: function save(tab) {
      var _this9 = this;

      if (tab.isGlobalView) {
        return;
      }

      var name = this.form.name.value;
      this.$validator.validateAll().then(function (result) {
        if (result) {
          __WEBPACK_IMPORTED_MODULE_14__api_view_view_api__["a" /* viewApiService */].saveView(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, tab, {
            cams: tab.cams.slice(0, _this9.grids.find(function (g) {
              return g.value == tab.grid;
            }).max),
            name: name ? name : tab.name
          }), _this9.$store.state.user.login).then(function (view) {
            _this9.$store.commit("resetTempView");
            _this9.$store.commit("saveView", view);

            _this9.isCopy = false;
            _this9.form.name.value = null;
            _this9.saving = null;
            _this9.$router.push({ name: "views", params: { viewId: view.id } }, function () {
              _this9.$store.commit("setGrid", view.grid);
            });
          });
        }
      });
    },
    reset: function reset(tab) {
      if (tab.isGlobalView) {
        return;
      }

      if (tab.temp) {
        this.$store.commit("resetTempView");
        this.$store.commit("setGrid", 1);
      } else {
        var views = __WEBPACK_IMPORTED_MODULE_14__api_view_view_api__["a" /* viewApiService */].getLocalViews(this.$store.state.user.login);

        var view = views.find(function (v) {
          return v.id == tab.id;
        });
        this.$store.commit("setGrid", view.grid);
        this.$store.commit("saveView", view);
        this.$nextTick(function () {
          __WEBPACK_IMPORTED_MODULE_7__services_EventBus__["a" /* EventBus */].$emit("views:select");
        });
      }
    },
    removeCamsFromView: function removeCamsFromView() {
      this.$store.commit("removeCamFromView", {
        camId: null,
        viewId: this.$store.getters.getActiveView.id
      });
    },
    remove: function remove(tab) {
      var _this10 = this;

      if (tab.isGlobalView) {
        return;
      }

      this.removing = null;

      __WEBPACK_IMPORTED_MODULE_14__api_view_view_api__["a" /* viewApiService */].removeView(tab.id, this.$store.state.user.login).then(function (viewId) {
        _this10.$store.commit("removeView", viewId);

        if (_this10.views.length === 1 && !_this10.views[0].cams.length) {
          _this10.$store.commit("resetTempView");
          _this10.$store.commit("setGrid", 1);
        }

        if (viewId == _this10.$route.params.viewId) {
          _this10.$router.push({
            name: "views",
            params: { viewId: _this10.views[0].id }
          });
        }
      });
    },
    toggleExport: function toggleExport() {
      var camera_list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      var titleTextPath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : PATHS_TO_LOCALES.exportPeriod;

      this.camera_list = camera_list;
      this.isShowDownload = !this.isShowDownload;
      this.titleTextPath = titleTextPath;
    },
    onSaveVideo: function onSaveVideo(data) {
      __WEBPACK_IMPORTED_MODULE_7__services_EventBus__["a" /* EventBus */].$emit("export-files", __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, data, {
        camera_list: this.camera_list
      }));
      this.toggleExport();
    },
    getNewName: function getNewName() {
      var result = 1;

      this.localViews.forEach(function (item) {
        var itemIdNumber = Number(item.id.split(__WEBPACK_IMPORTED_MODULE_15__consts_consts__["b" /* LOCAL_VIEW_ID_PREFIX */])[1]);

        if (result <= itemIdNumber) result = itemIdNumber + 1;
      });

      return this.$t("tabs.view") + " " + result;
    },

    getViewName: __WEBPACK_IMPORTED_MODULE_16__utils__["c" /* getViewName */]
  },
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_8__components_modal_Modal_vue__["a" /* default */],
    Dropdown: __WEBPACK_IMPORTED_MODULE_9__components_dropdown_Dropdown_vue__["a" /* default */],
    InputText: __WEBPACK_IMPORTED_MODULE_10__components_inputText_InputText_vue__["a" /* default */],
    Loader: __WEBPACK_IMPORTED_MODULE_11__components_loader_Loader_vue__["a" /* default */],
    TimeInterval: __WEBPACK_IMPORTED_MODULE_12__modules_timeInterval_TimeInterval_vue__["a" /* default */]
  }
});

/***/ }),

/***/ 448:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'input-text',
    data: function data() {
        return {
            model: this.value,
            focused: false
        };
    },
    created: function created() {
        var _this = this;

        this.$on('focus', function () {
            _this.$refs.input.focus();
        });
    },

    computed: {
        empty: function empty() {
            return !this.model;
        }
    },
    props: {
        placeholder: String,
        name: String,
        disabled: {
            type: Boolean,
            default: false
        },
        hasError: Boolean,
        value: String,
        type: {
            type: String,
            default: 'text'
        }
    },
    watch: {
        model: function model(value) {
            this.$emit('update:value', value);
            this.$emit('input', value);
        },
        value: function value(_value) {
            this.model = _value;
        },
        placeholder: function placeholder() {
            this.model = this.value;
        }
    },
    methods: {
        clear: function clear() {
            var _this2 = this;

            this.$nextTick(function () {
                _this2.$refs.input.focus();
            });

            this.model = null;
        }
    }
});

/***/ }),

/***/ 449:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ext_datetime_datetime_vue__ = __webpack_require__(911);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_EventBus__ = __webpack_require__(18);




var formatView = 'MM-DD-YYYY HH:mm:ss.000';

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'TimeInterval',
    props: {
        titleTextPath: {
            type: String,
            default: 'video.exportPeriod'
        }
    },
    data: function data() {
        return {
            lang: this.$store.state.i18n.locale,
            start_date: __WEBPACK_IMPORTED_MODULE_1_moment___default()().startOf('day').format(formatView),
            end_date: __WEBPACK_IMPORTED_MODULE_1_moment___default()().endOf('day').format(formatView),
            format: formatView,
            error: false
        };
    },

    components: {
        Datetime: __WEBPACK_IMPORTED_MODULE_0__components_ext_datetime_datetime_vue__["a" /* default */]
    },
    computed: {
        errorDifferent: function errorDifferent() {
            return __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.end_date, this.format).isBefore(__WEBPACK_IMPORTED_MODULE_1_moment___default()(this.start_date, this.format));
        }
    },
    methods: {
        saveVideo: function saveVideo() {
            if (!this.error && !this.errorDifferent) {
                this.$emit('save', {
                    start_date: __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.start_date, formatView),
                    end_date: __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.end_date, formatView)
                });
            }
        },
        getError: function getError(data) {
            this.error = data;
        }
    }
});

/***/ }),

/***/ 450:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ext_input_text_input_text_vue__ = __webpack_require__(913);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ext_datepicker_datepicker_vue__ = __webpack_require__(921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ext_dropdown_dropdown_vue__ = __webpack_require__(924);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ext_button_button_vue__ = __webpack_require__(927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_EventBus__ = __webpack_require__(18);







var _data = {
    en: {
        date: {
            regex: /^\s*(1[012]|0?[1-9])\.(3[01]|[12][0-9]|0?[1-9])\.((?:19|20)\d{2})\s*$/,
            format: 'MM.DD.YYYY'
        },
        time: {
            regex: /^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/,
            format: 'HH:mm'
        }
    },
    ru: {
        date: {
            regex: /^\s*(3[01]|[12][0-9]|0?[1-9])\.(1[012]|0?[1-9])\.((?:19|20)\d{2})\s*$/,
            format: 'DD.MM.YYYY'
        },
        time: {
            regex: /^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/,
            format: 'HH:mm'
        }
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'datetime',
    inject: ['$validator'],
    data: function data() {
        return {
            control: {
                date: null,
                time: null
            }
        };
    },

    props: {
        value: {
            type: String
        },
        name: {
            type: String,
            required: true
        },
        lang: {
            type: String,
            default: 'en'
        },
        format: {
            type: String,
            default: ''
        },
        error: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        control: {
            deep: true,
            handler: function handler(control) {
                var date = __WEBPACK_IMPORTED_MODULE_4_moment_moment___default()(control.date, this.data.date.format, true);
                var time = __WEBPACK_IMPORTED_MODULE_4_moment_moment___default()(control.time, this.data.time.format, true);

                if (date.isValid() && time.isValid()) {
                    var diff = time.diff(time.clone().startOf('day')) / 1000;
                    var datetime = date.add(diff, 'seconds');
                    this.$emit('input', datetime.format(this.format));
                    this.$emit('error', false);
                } else {
                    this.$emit('error', true);
                }
            }
        },
        value: {
            immediate: true,
            handler: function handler(value) {
                this.setControl(value);
            }
        },
        lang: function lang() {
            this.setControl(this.value);
        }
    },
    computed: {
        data: function data() {
            return _data[this.lang];
        }
    },
    methods: {
        setControl: function setControl(value) {
            if (value) {
                this.control.date = __WEBPACK_IMPORTED_MODULE_4_moment_moment___default()(value, this.format, true).format(this.data.date.format);
                this.control.time = __WEBPACK_IMPORTED_MODULE_4_moment_moment___default()(value, this.format, true).format(this.data.time.format);
            }
        },
        closePicker: function closePicker() {
            __WEBPACK_IMPORTED_MODULE_5__services_EventBus__["a" /* EventBus */].$emit('root-click');
        }
    },
    components: {
        InputText: __WEBPACK_IMPORTED_MODULE_0__components_ext_input_text_input_text_vue__["a" /* default */],
        Datepicker: __WEBPACK_IMPORTED_MODULE_1__components_ext_datepicker_datepicker_vue__["a" /* default */],
        Dropdown: __WEBPACK_IMPORTED_MODULE_2__components_ext_dropdown_dropdown_vue__["a" /* default */],
        'v-button': __WEBPACK_IMPORTED_MODULE_3__components_ext_button_button_vue__["a" /* default */]
    }
});

/***/ }),

/***/ 451:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ext_the_mask_the_mask_vue__ = __webpack_require__(915);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "text-input",
  data: function data() {
    return {
      focused: false
    };
  },

  props: {
    name: {
      type: String,
      required: true
    },
    value: {
      type: [String, Number]
    },
    type: {
      type: String,
      default: "text"
    },
    placeholder: {
      type: [String, Number],
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    error: {
      default: null
    },
    mask: {
      type: String,
      default: ""
    },
    masked: {
      type: Boolean,
      default: false
    },
    errorText: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    input: function input(a, b, c) {}
  },
  components: {
    TheMask: __WEBPACK_IMPORTED_MODULE_0__components_ext_the_mask_the_mask_vue__["a" /* default */]
  }
});

/***/ }),

/***/ 452:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__directive__ = __webpack_require__(916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tokens__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tokens___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__tokens__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__masker__ = __webpack_require__(453);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'TheMask',
    directives: { mask: __WEBPACK_IMPORTED_MODULE_0__directive__["a" /* default */] },
    props: {
        value: {
            type: [String, Number],
            default: null
        },
        mask: {
            type: [String, Array],
            required: true
        },
        masked: {
            type: Boolean,
            default: false
        },
        tokens: {
            type: Object,
            default: function _default() {
                return __WEBPACK_IMPORTED_MODULE_1__tokens___default.a;
            }
        },
        disabled: {
            type: Boolean,
            default: false
        },
        type: {
            type: String,
            default: 'text'
        },
        name: {
            type: String,
            required: true
        },
        placeholder: {
            type: String,
            default: ''
        }
    },
    data: function data() {
        return {
            lastValue: null, // avoid unecessary emit when has no change
            display: this.value
        };
    },

    computed: {
        config: function config() {
            return {
                mask: this.mask,
                tokens: this.tokens,
                masked: this.masked
            };
        }
    },
    watch: {
        value: function value(newValue) {
            if (newValue !== this.lastValue) {
                this.display = newValue;
            }
        },
        masked: function masked() {
            this.refresh(this.display);
        }
    },
    methods: {
        onInput: function onInput(e) {
            if (e.isTrusted) return; // ignore native event
            this.refresh(e.target.value);
        },
        refresh: function refresh(value) {
            this.display = value;
            value = Object(__WEBPACK_IMPORTED_MODULE_2__masker__["a" /* default */])(value, this.mask, this.masked, this.tokens);

            if (value !== this.lastValue) {
                this.lastValue = value;
                this.$emit('input', value);
            }
        }
    }
});

/***/ }),

/***/ 453:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__maskit__ = __webpack_require__(917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dynamic_mask__ = __webpack_require__(918);


// Facade to maskit/dynamicMask when mask is String or Array
/* harmony default export */ __webpack_exports__["a"] = (function (value, mask) {
    var masked = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var tokens = arguments[3];

    return Array.isArray(mask) ? Object(__WEBPACK_IMPORTED_MODULE_1__dynamic_mask__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__maskit__["a" /* default */], mask, tokens)(value, mask, masked, tokens) : Object(__WEBPACK_IMPORTED_MODULE_0__maskit__["a" /* default */])(value, mask, masked, tokens);
});

/***/ }),

/***/ 454:
/***/ (function(module, exports) {

module.exports = {
    '#': { pattern: /\d/ },
    'X': { pattern: /[0-9a-zA-Z]/ },
    'S': { pattern: /[a-zA-Z]/ },
    'A': { pattern: /[a-zA-Z]/, transform: function transform(v) {
            return v.toLocaleUpperCase();
        } },
    'a': { pattern: /[a-zA-Z]/, transform: function transform(v) {
            return v.toLocaleLowerCase();
        } },
    '!': { escape: true }
};

/***/ }),

/***/ 455:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment_moment__);


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'datepicker',
    props: {
        value: {},
        format: {
            type: String,
            default: 'YYYY-MM-DD'
        },
        lang: {
            type: String,
            default: 'en'
        }
    },
    data: function data() {
        return {
            days: {
                en: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
                ru: ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс']
            },
            today: null,
            month: null
        };
    },

    watch: {
        value: {
            immediate: true,
            handler: function handler(value) {
                this.today = __WEBPACK_IMPORTED_MODULE_0_moment_moment___default()().startOf('day');

                if (__WEBPACK_IMPORTED_MODULE_0_moment_moment___default()(value, this.format, true).isValid()) {
                    this.month = __WEBPACK_IMPORTED_MODULE_0_moment_moment___default()(value, this.format, true).startOf('month').format();
                } else {
                    this.month = __WEBPACK_IMPORTED_MODULE_0_moment_moment___default()().startOf('month').format();
                }
            }
        }
    },
    computed: {
        grid: function grid() {
            __WEBPACK_IMPORTED_MODULE_0_moment_moment___default.a.locale(this.lang);

            var month = [];
            var week = [];
            var date = __WEBPACK_IMPORTED_MODULE_0_moment_moment___default()(this.month);
            var daysInMonth = date.daysInMonth();
            var dayIndex = date.weekday();
            var count = daysInMonth + dayIndex;

            if (count % 7 > 0) {
                count += 7 - count % 7;
            }

            date = date.subtract(dayIndex, 'days');

            for (var i = 1; i <= count; i++) {
                week.push({
                    date: date.format(),
                    num: date.format('D'),
                    otherMonth: i < dayIndex + 1 || i >= daysInMonth + dayIndex + 1,
                    selected: date.isSame(__WEBPACK_IMPORTED_MODULE_0_moment_moment___default()(this.value, this.format)),
                    today: this.today.isSame(date)
                });

                if (i % 7 === 0) {
                    month.push(week);
                    week = [];
                }

                date.add(1, 'days');
            }

            return month;
        }
    },
    methods: {
        prevMonth: function prevMonth() {
            this.month = __WEBPACK_IMPORTED_MODULE_0_moment_moment___default()(this.month).subtract(1, 'months').format();
        },
        nextMonth: function nextMonth() {
            this.month = __WEBPACK_IMPORTED_MODULE_0_moment_moment___default()(this.month).add(1, 'months').format();
        },
        select: function select(day) {
            this.$emit('input', __WEBPACK_IMPORTED_MODULE_0_moment_moment___default()(day.date).format(this.format));
        }
    }
});

/***/ }),

/***/ 456:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_EventBus__ = __webpack_require__(18);

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'dropdown',
    data: function data() {
        return {
            show: false
        };
    },

    props: {
        disabled: {
            type: Boolean,
            default: false
        }
    },
    created: function created() {
        __WEBPACK_IMPORTED_MODULE_0__services_EventBus__["a" /* EventBus */].$on('root-click', this.closeOther);
    },
    beforeDestroy: function beforeDestroy() {
        __WEBPACK_IMPORTED_MODULE_0__services_EventBus__["a" /* EventBus */].$off('root-click', this.closeOther);
    },

    watch: {
        show: function show() {
            this.$emit('change', this.show);
        }
    },
    methods: {
        toggle: function toggle() {
            if (!this.disabled) {
                this.show = !this.show;
            }
        },
        closeOther: function closeOther() {
            var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            if (this.$el !== el && !this.$el.contains(el)) {
                this.show = false;
            }
        }
    }
});

/***/ }),

/***/ 457:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'v-button',
    props: {
        type: {
            default: 'primary'
        },
        disabled: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false
        },
        submit: {
            default: false
        }
    },
    components: {}
});

/***/ }),

/***/ 458:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return translateService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);





var TranslateService = function () {
  function TranslateService() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, TranslateService);

    this.translate = {};
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(TranslateService, [{
    key: "getTranslates",
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var ruLocaleRequest, ruLocale, enLocaleRequest, enLocale;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return fetch("/static/locales/ru.json");

              case 2:
                ruLocaleRequest = _context.sent;
                _context.next = 5;
                return ruLocaleRequest.json();

              case 5:
                ruLocale = _context.sent;
                _context.next = 8;
                return fetch("/static/locales/en.json");

              case 8:
                enLocaleRequest = _context.sent;
                _context.next = 11;
                return enLocaleRequest.json();

              case 11:
                enLocale = _context.sent;
                return _context.abrupt("return", {
                  ru: ruLocale,
                  en: enLocale
                });

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getTranslates() {
        return _ref.apply(this, arguments);
      }

      return getTranslates;
    }()
  }]);

  return TranslateService;
}();

var translateService = new TranslateService();

/***/ }),

/***/ 459:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return viewApiService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_classCallCheck__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_createClass__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_ApiService__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__consts_storageKeys__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__classes_views_globalView__ = __webpack_require__(932);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__classes_views_localView__ = __webpack_require__(933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__consts_consts__ = __webpack_require__(84);
















var ViewApi = function () {
  function ViewApi() {
    __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_classCallCheck___default()(this, ViewApi);

    /** @private */
    this.http = new __WEBPACK_IMPORTED_MODULE_9__services_ApiService__["a" /* default */]();
  }

  /**
   * @param {string} login Current user login
   * @return {Promise<{
   * globalViews: GlobalView[],
   * localView: LocalView[]}>}
   *
   */


  __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_createClass___default()(ViewApi, [{
    key: "getViews",
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee(login) {
        var globalViews, localViews, views;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.http.get("named_markups");

              case 2:
                globalViews = _context.sent;
                localViews = this.getLocalViews(login);
                views = {
                  globalViews: globalViews.map(function (view) {
                    return new __WEBPACK_IMPORTED_MODULE_12__classes_views_globalView__["a" /* GlobalView */](view);
                  }),
                  localViews: localViews
                };
                return _context.abrupt("return", views);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getViews(_x) {
        return _ref.apply(this, arguments);
      }

      return getViews;
    }()

    /**
     * @param {string} login Current user login
     * @return {LocalView[]} Array of local views from localStorage
     */

  }, {
    key: "getLocalViews",
    value: function getLocalViews(login) {
      var localViewsJson = localStorage.getItem(__WEBPACK_IMPORTED_MODULE_10__consts_storageKeys__["a" /* default */].LOCAL_VIEWS);

      if (!localViewsJson) {
        return [];
      }

      var parsedLocalViewsObject = JSON.parse(localViewsJson);

      if (Array.isArray(parsedLocalViewsObject) || (typeof parsedLocalViewsObject === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(parsedLocalViewsObject)) !== "object") {
        localStorage.removeItem(__WEBPACK_IMPORTED_MODULE_10__consts_storageKeys__["a" /* default */].LOCAL_VIEWS);

        return [];
      }

      var _transformLocalViews = Object(__WEBPACK_IMPORTED_MODULE_11__utils__["e" /* transformLocalViews */])(parsedLocalViewsObject[login]),
          isChanged = _transformLocalViews.isChanged,
          localViewsArray = _transformLocalViews.localViewsArray;

      if (isChanged) {
        localStorage.setItem(__WEBPACK_IMPORTED_MODULE_10__consts_storageKeys__["a" /* default */].LOCAL_VIEWS, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, parsedLocalViewsObject, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, login, localViewsArray))));
      }

      return localViewsArray.map(function (view) {
        return new __WEBPACK_IMPORTED_MODULE_13__classes_views_localView__["a" /* LocalView */](view);
      });
    }
  }, {
    key: "saveView",
    value: function saveView(view, login) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var localViews = JSON.parse(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_10__consts_storageKeys__["a" /* default */].LOCAL_VIEWS)) || {};

        if (localViews && !localViews[login]) {
          localViews[login] = [];
        }

        var copyView = {
          id: view.id,
          name: view.name,
          grid: view.grid,
          cams: view.cams.map(function (cam) {
            return cam.id;
          })
        };

        if (copyView.id === undefined || copyView.id === __WEBPACK_IMPORTED_MODULE_14__consts_consts__["c" /* MAIN_VIEW_ID */]) {
          copyView.id = __WEBPACK_IMPORTED_MODULE_14__consts_consts__["b" /* LOCAL_VIEW_ID_PREFIX */] + localViews[login].reduce(function (prev, next) {
            var id = Number(next.id.split(__WEBPACK_IMPORTED_MODULE_14__consts_consts__["b" /* LOCAL_VIEW_ID_PREFIX */])[1]);

            return id >= prev ? id + 1 : prev;
          }, 1);

          localViews[login].push(copyView);
        } else {
          var viewIndex = localViews[login].findIndex(function (v) {
            return copyView.id === v.id;
          });

          if (viewIndex > -1) {
            localViews[login][viewIndex] = copyView;
          } else {
            reject();
          }
        }

        localStorage.setItem(__WEBPACK_IMPORTED_MODULE_10__consts_storageKeys__["a" /* default */].LOCAL_VIEWS, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(localViews));

        resolve(copyView);
      });
    }
  }, {
    key: "removeView",
    value: function removeView(viewId, login) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var views = JSON.parse(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_10__consts_storageKeys__["a" /* default */].LOCAL_VIEWS) || '{"' + login + '":[]}');

        var viewIndex = views[login].findIndex(function (view) {
          return view.id === viewId;
        });

        if (viewIndex > -1) {
          views[login].splice(viewIndex, 1);

          localStorage.setItem(__WEBPACK_IMPORTED_MODULE_10__consts_storageKeys__["a" /* default */].LOCAL_VIEWS, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(views));

          resolve(viewId);
        } else {
          reject();
        }
      });
    }
  }]);

  return ViewApi;
}();

var viewApiService = new ViewApi();

/***/ }),

/***/ 460:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_alarms_js__ = __webpack_require__(461);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d5191b0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Alarms_vue__ = __webpack_require__(948);
function injectStyle (ssrContext) {
  __webpack_require__(935)
}
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1d5191b0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_alarms_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d5191b0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Alarms_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 461:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set__ = __webpack_require__(936);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_perfect_scrollbar__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_perfect_scrollbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_perfect_scrollbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_sidebar_Sidebar_vue__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_datepicker_Datepicker_vue__ = __webpack_require__(942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_dropdown_Dropdown_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_loader_Loader_vue__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_player_Player_vue__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_search_Search_vue__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_camsList_CamsList_vue__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__services_EventBus__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__api_alarm_alarm_api__ = __webpack_require__(465);





















/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Alarms",
  components: {
    Datepicker: __WEBPACK_IMPORTED_MODULE_11__components_datepicker_Datepicker_vue__["a" /* default */],
    Sidebar: __WEBPACK_IMPORTED_MODULE_10__components_sidebar_Sidebar_vue__["a" /* default */],
    VuePerfectScrollbar: __WEBPACK_IMPORTED_MODULE_9_vue_perfect_scrollbar___default.a,
    Dropdown: __WEBPACK_IMPORTED_MODULE_12__components_dropdown_Dropdown_vue__["a" /* default */],
    Loader: __WEBPACK_IMPORTED_MODULE_13__components_loader_Loader_vue__["a" /* default */],
    Player: __WEBPACK_IMPORTED_MODULE_14__components_player_Player_vue__["a" /* default */],
    Search: __WEBPACK_IMPORTED_MODULE_15__components_search_Search_vue__["a" /* default */],
    CamsList: __WEBPACK_IMPORTED_MODULE_16__components_camsList_CamsList_vue__["a" /* default */]
  },
  data: function data() {
    return {
      loading: false,
      groups: {
        views: {
          name: "global.views",
          placeholder: "placeHolders.findViews",
          search: "",
          open: true
        },
        cams: {
          name: "global.cameras",
          placeholder: "placeHolders.findCameras",
          search: "",
          open: true
        }
      },
      filters: {
        open: true
      },
      datepicker: {
        open: false,
        start: __WEBPACK_IMPORTED_MODULE_8_moment___default()().startOf("day").format(),
        stop: __WEBPACK_IMPORTED_MODULE_8_moment___default()().endOf("day").format()
      },
      searchAlarms: {
        placeholder: "placeHolders.findAlarms",
        value: ""
      },
      prevRoute: null,
      viewsFilterHeight: 0,
      prevCameraMode: null,
      list: [],
      pagination: {
        isListEnded: true,
        offset: 0,
        max_count: 100,
        loading: false
      },
      previousDate: {
        start: __WEBPACK_IMPORTED_MODULE_8_moment___default()().startOf("day").format(),
        stop: __WEBPACK_IMPORTED_MODULE_8_moment___default()().endOf("day").format()
      }
    };
  },
  created: function created() {
    this.getAlarms();
    this.prevCameraMode = this.$store.state.mode;
  },
  mounted: function mounted() {
    this.updateScroll();
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      vm.prevRoute = from;
    });
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.$store.commit("setMode", this.prevCameraMode);
    next();
  },

  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])({
    cams: "getCams",
    views: "getAlarmViews",
    activeViews: "getAlarmsActiveViews"
  }), {
    activeAlarm: function activeAlarm() {
      var _this = this;

      return this.list.find(function (item) {
        return item.id === _this.$route.params.alarmId;
      }) || null;
    },
    selectedCamsIds: function selectedCamsIds() {
      var queryCams = this.$route.query.cams ? this.$route.query.cams.split(",") : [];
      var queryView = this.activeViews && this.activeViews.length && this.activeViews.reduce(function (result, _ref) {
        var cams = _ref.cams;
        return [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(result), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(cams.map(function (cam) {
          return cam.id;
        })));
      }, []) || [];

      return [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a([].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(queryCams), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(queryView)))));
    },
    isItemSelected: function isItemSelected() {
      var _this2 = this;

      return function (key, item) {
        if (!key || !item || !item.id) return false;
        return !!(_this2.$route.query[key] && _this2.$route.query[key].split(",").find(function (id) {
          return id === item.id.toString();
        })) || false;
      };
    },
    alarms: function alarms() {
      var _this3 = this;

      var camsIds = this.selectedCamsIds.length ? this.selectedCamsIds : this.cams.map(function (cam) {
        return cam.id;
      });

      var result = this.list.filter(function (item) {
        return camsIds.indexOf(item.camId) > -1 && item.name.toLowerCase().indexOf(_this3.searchAlarms.value.toLowerCase().trim()) !== -1;
      });

      result = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.groupBy(result, function (item) {
        return __WEBPACK_IMPORTED_MODULE_8_moment___default.a.unix(item.timestamp).startOf("day").format();
      });

      return result;
    },
    filteredItems: function filteredItems() {
      return function (items, search) {
        return items && items.length && items.filter(function (item) {
          return item.name.toLowerCase().indexOf(search.toLowerCase()) > -1;
        }) || [];
      };
    },
    isEmpty: function isEmpty() {
      return __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.isEmpty(this.alarms);
    },
    playerData: function playerData() {
      return {
        mode: 1,
        layout: 1,
        camera_list: this.activeAlarm ? [this.activeAlarm.camId] : [],
        time: this.activeAlarm ? this.activeAlarm.time : null
      };
    },
    dateStart: function dateStart() {
      var datepicker = this.datepicker;

      return datepicker && datepicker.start && this.getDate(datepicker.start) || null;
    },
    dateStop: function dateStop() {
      var datepicker = this.datepicker;

      return datepicker && datepicker.stop && this.getDate(datepicker.stop) || null;
    },
    showLoadMore: function showLoadMore() {
      return this.isEmpty === false && this.pagination.isListEnded === false;
    }
  }),
  watch: {
    filteredCams: function filteredCams() {
      this.updateScroll();
    },
    views: function views() {
      this.updateScroll();
    },
    alarms: function alarms() {
      this.updateScroll(this.$refs.alarmsScroll);
    },
    $route: function $route(to, from) {
      this.$nextTick(function () {
        __WEBPACK_IMPORTED_MODULE_17__services_EventBus__["a" /* EventBus */].$emit("views:select");
      });
    }
  },
  methods: {
    getViewName: __WEBPACK_IMPORTED_MODULE_18__utils__["c" /* getViewName */],
    getDate: function getDate(date) {
      return date ? __WEBPACK_IMPORTED_MODULE_8_moment___default()(date).locale(this.$store.state.i18n.locale).format("DD MMMM YYYY").toLowerCase() : null;
    },
    selectDate: function selectDate(date) {
      this.datepicker = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, this.datepicker, {
        start: date.start,
        stop: date.end,
        open: false
      });

      this.pagination.offset = 0;
      this.pagination.isListEndedded = true;
      this.loading = true;
      this.list = [];

      this.getAlarms();
    },
    toggleGroup: function toggleGroup(type) {
      this.groups[type].open = !this.groups[type].open;
      this.updateScroll();
    },
    updateScroll: function updateScroll() {
      var _this4 = this;

      var viewsScroll = this.$refs.viewsScroll || null;
      var camsScroll = this.$refs.camsScroll || null;
      var update = function update(ref) {
        if (ref) _this4.$nextTick(function () {
          ref.update();
          _this4.viewsFilterHeightCheck();
        });
      };
      if (viewsScroll) update(viewsScroll);
      if (camsScroll) update(camsScroll);
    },
    getComment: function getComment(alarm) {
      if (alarm.action === "SPEAKER_STATE_READY" || alarm.action === "SPEAKER_STATE_ACQUIRED") {
        return __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].i18n.translate("eventStatus.EVENT_" + alarm.action) + "\n" + alarm.comment;
      }

      if (alarm.comment) return alarm.comment;

      if (alarm.description) return alarm.description;

      return __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].i18n.translate("eventStatus.EVENT_" + alarm.action);
    },
    getAlarms: function getAlarms() {
      var _this5 = this;

      this.loading = this.list.length === 0;

      this.paginationAction();

      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_19__api_alarm_alarm_api__["a" /* alarmApiService */].getAlarms(_this5.cams, {
          startTime: _this5.datepicker.start,
          stopTime: _this5.datepicker.stop,
          max_count: _this5.pagination.max_count,
          offset: _this5.pagination.offset
        }).then(function (alarms) {
          var _list;

          (_list = _this5.list).push.apply(_list, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(alarms));

          _this5.pagination.isListEnded = alarms.length < _this5.pagination.max_count;
          _this5.pagination.loading = false;

          _this5.updateScroll(_this5.$refs.alarmsScroll);
        }).finally(function () {
          return _this5.loading = false;
        });
      }, 500);
    },
    paginationAction: function paginationAction() {
      if (this.list.length === 0) {
        return;
      }

      this.pagination.loading = true;

      if (this.datepicker.start === this.previousDate.start && this.datepicker.stop === this.previousDate.stop) {
        this.pagination.offset += this.pagination.max_count;
      } else {
        this.previousDate.start = this.datepicker.start;
        this.previousDate.stop = this.datepicker.stop;
      }
    },
    toggleAlarm: function toggleAlarm(alarm) {
      var query = {
        cams: this.$route.query.cams,
        view: this.$route.query.view
      };

      var route = {
        name: "alarms",
        params: {
          alarmId: this.$route.params.alarmId === alarm.id ? null : alarm.id
        },
        query: query
      };

      this.$store.commit("setMode", route.params.alarmId ? 1 : this.prevCameraMode);

      this.$router.replace(route);
    },
    goBack: function goBack() {
      var _this6 = this;

      var paramsRoute = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.$route.params).filter(function (key) {
        return _this6.$route.params[key] !== undefined;
      });
      if (paramsRoute.length) {
        this.$router.push(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, this.$route, { params: {} }));
      } else if (this.prevRoute) {
        this.$router.push(this.prevRoute);
      } else {
        this.$router.push("/");
      }
    },
    resetRouterQuery: function resetRouterQuery(key) {
      var query = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, this.$route.query);
      if (query[key]) {
        delete query[key];
        this.$router.push({ query: query });
      }
    },
    addedRouterQuery: function addedRouterQuery(key, item) {
      if (!key || !item || !item.id) return;
      var itemQuery = this.$route.query[key];
      var items = itemQuery ? itemQuery.split(",") : [];
      var itemsFilter = items && items.length && items.map(function (id) {
        return id === item.id.toString() ? null : id;
      }).filter(function (id) {
        return id;
      }) || [];
      var result = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(itemsFilter.length === items.length ? [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(itemsFilter), [item.id]) : itemsFilter)).join(",");
      var query = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, this.$route.query, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, key, result));
      if (!result) delete query[key];
      this.$router.push({ query: query });
    },
    viewsFilterHeightCheck: function viewsFilterHeightCheck() {
      var _this7 = this;

      this.$nextTick(function () {
        var viewsBlock = _this7.$refs["views-filter-group"];
        _this7.viewsFilterHeight = viewsBlock && viewsBlock.clientHeight || 0;
      });
    }
  }
});

/***/ }),

/***/ 462:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'datepicker',
    props: {
        dateStart: {
            type: String
        },
        dateEnd: {
            type: String
        },
        lang: {
            type: String,
            default: 'en'
        }
    },
    data: function data() {
        return {
            days: {
                en: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
                ru: ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс']
            },
            today: __WEBPACK_IMPORTED_MODULE_0_moment___default()().startOf('day'),
            selectedMonth: __WEBPACK_IMPORTED_MODULE_0_moment___default()().startOf('month').format(),
            selectedDateStart: this.dateStart,
            selectedDateEnd: this.dateEnd
        };
    },

    computed: {
        month: function month() {
            __WEBPACK_IMPORTED_MODULE_0_moment___default.a.locale(this.lang);

            var month = [];
            var week = [];
            var date = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.selectedMonth);
            var daysInMonth = date.daysInMonth();
            var dayIndex = date.weekday();
            var count = daysInMonth + dayIndex;

            if (count % 7 > 0) count += 7 - count % 7;

            date = date.subtract(dayIndex, 'days');

            for (var i = 1; i <= count; i++) {
                var otherMonth = i < dayIndex + 1 || i >= daysInMonth + dayIndex + 1;

                week.push({
                    date: date.format(),
                    num: date.format('D'),
                    disabled: otherMonth || date > __WEBPACK_IMPORTED_MODULE_0_moment___default()().endOf('day'),
                    otherMonth: otherMonth,
                    today: this.today.isSame(date),
                    limitDate: date.isSame(__WEBPACK_IMPORTED_MODULE_0_moment___default()(this.selectedDateStart)) || date.isSame(__WEBPACK_IMPORTED_MODULE_0_moment___default()(this.selectedDateEnd).startOf('day'))
                });

                if (i % 7 === 0) {
                    month.push(week);
                    week = [];
                }

                date.add(1, 'days');
            }

            return month;
        }
    },
    methods: {
        prevMonth: function prevMonth() {
            this.selectedMonth = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.selectedMonth).subtract(1, 'months').format();
        },
        nextMonth: function nextMonth() {
            this.selectedMonth = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.selectedMonth).add(1, 'months').format();
        },
        selectDate: function selectDate(day) {
            if (this.selectedDateStart && this.selectedDateEnd) {
                this.selectedDateStart = day.date;
                this.selectedDateEnd = null;
            } else if (!this.selectedDateEnd) {
                if (__WEBPACK_IMPORTED_MODULE_0_moment___default()(day.date) < __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.selectedDateStart)) {
                    this.selectedDateEnd = this.selectedDateStart;
                    this.selectedDateStart = day.date;
                } else this.selectedDateEnd = day.date;
            }
        },
        isSelected: function isSelected(date) {
            if (this.selectedDateStart && this.selectedDateEnd) {
                return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date) >= __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.selectedDateStart) && __WEBPACK_IMPORTED_MODULE_0_moment___default()(date) <= __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.selectedDateEnd);
            } else if (!this.selectedDateEnd) {
                return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).isSame(__WEBPACK_IMPORTED_MODULE_0_moment___default()(this.selectedDateStart));
            }
        },
        submit: function submit() {
            var end = this.selectedDateEnd ? __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.selectedDateEnd).endOf('day').format() : __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.selectedDateStart).endOf('day').format();
            this.$emit('select', { start: this.selectedDateStart, end: end });
        },
        cancel: function cancel() {
            this.$emit('cancel');
        }
    }
});

/***/ }),

/***/ 463:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_player_js__ = __webpack_require__(464);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d605113_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Player_vue__ = __webpack_require__(947);
function injectStyle (ssrContext) {
  __webpack_require__(945)
}
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5d605113"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_player_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d605113_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Player_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 464:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_loader_Loader_vue__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_EventBus__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__const_playerEvents__ = __webpack_require__(946);










/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Player",
  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_6__components_loader_Loader_vue__["a" /* default */]
  },
  props: {
    data: {
      type: Object
    }
  },
  inject: ["auth"],
  data: function data() {
    return {
      domain: location.origin,
      loading: true,
      options: {
        login: this.$store.state.user.login,
        password: this.auth.getTokenFromStorage(localStorage.getItem("token"))[1],
        monitor_id: {"MAIN_URL":"http://85.202.239.74:12113","WEBVIEW_URL":"http://85.202.239.74:25888","PLAYER":{"monitorId":1,"transport":4},"updateInterval":10000}.PLAYER.monitorId,
        transport: {"MAIN_URL":"http://85.202.239.74:12113","WEBVIEW_URL":"http://85.202.239.74:25888","PLAYER":{"monitorId":1,"transport":4},"updateInterval":10000}.PLAYER.transport
      },
      camsData: null,
      intervalDateVideo: null,
      isShowSolo: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({
    stream: "getStream"
  }), {
    params: function params() {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this.options, this.data, {
        stream_role: this.stream
      });
    }
  }),
  watch: {
    stream: function stream() {
      this.sendMessage({
        command: __WEBPACK_IMPORTED_MODULE_8__const_playerEvents__["a" /* playerEvents */].INIT,
        stream_role: this.stream
      });
    },
    "$store.state.i18n.locale": function $storeStateI18nLocale() {
      this.initiatePlayer();
    }
  },
  created: function created() {
    window.addEventListener("message", this.getMessage, false);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("message", this.getMessage);
    __WEBPACK_IMPORTED_MODULE_7__services_EventBus__["a" /* EventBus */].$off("views:select");
    __WEBPACK_IMPORTED_MODULE_7__services_EventBus__["a" /* EventBus */].$off("mode:change");
    __WEBPACK_IMPORTED_MODULE_7__services_EventBus__["a" /* EventBus */].$off("cam:dragstart");
    __WEBPACK_IMPORTED_MODULE_7__services_EventBus__["a" /* EventBus */].$off("export-files");
    __WEBPACK_IMPORTED_MODULE_7__services_EventBus__["a" /* EventBus */].$off("stop-export-file");
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_7__services_EventBus__["a" /* EventBus */].$on("views:select", this.update);
    __WEBPACK_IMPORTED_MODULE_7__services_EventBus__["a" /* EventBus */].$on("mode:change", this.changeMode);
    __WEBPACK_IMPORTED_MODULE_7__services_EventBus__["a" /* EventBus */].$on("cam:dragstart", this.getCamsData);
    __WEBPACK_IMPORTED_MODULE_7__services_EventBus__["a" /* EventBus */].$on("export-files", this.exportFiles);
    __WEBPACK_IMPORTED_MODULE_7__services_EventBus__["a" /* EventBus */].$on("stop-export-file", this.stopExportFile);

    this.initiatePlayer();
  },

  methods: {
    initiatePlayer: function initiatePlayer() {
      this.preloading();

      var startForm = document.createElement("form");
      startForm.setAttribute("method", "post");
      startForm.setAttribute("target", "webview_player");
      startForm.setAttribute("action", "/webview/video");
      startForm.setAttribute("style", "display: none");
      var startFromHtml = "";

      var paramsSend = {
        command: __WEBPACK_IMPORTED_MODULE_8__const_playerEvents__["a" /* playerEvents */].SHOW_MONITOR,
        auto_logon: 1,
        close_current_session: 1
      };

      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(paramsSend, this.params);
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(paramsSend).forEach(function (key) {
        startFromHtml += "<input name=\"" + key + "\" value=\"" + paramsSend[key] + "\">";
      });
      startForm.innerHTML = startFromHtml;
      document.body.appendChild(startForm);
      startForm.submit();
      startForm.remove();
    },
    update: function update() {
      this.isShowSolo = false;

      if (this.params) {
        var data = {
          command: __WEBPACK_IMPORTED_MODULE_8__const_playerEvents__["a" /* playerEvents */].SHOW_MONITOR,
          monitor_id: this.params.monitor_id,
          mode: this.params.mode,
          geometry: this.params.geometry,
          camera_list: this.params.camera_list.join(","),
          layout: this.params.layout,
          stream_role: this.params.stream_role
        };

        if (this.params.time) data.time = this.params.time;

        this.sendMessage(data);
      }
    },
    changeMode: function changeMode() {
      this.sendMessage({
        command: __WEBPACK_IMPORTED_MODULE_8__const_playerEvents__["a" /* playerEvents */].CHANGE_MONITOR_MODE,
        mode: this.params.mode
      });
    },
    sendMessage: function sendMessage(data) {
      if (this.$refs.player) this.$refs.player.contentWindow.postMessage(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data), "*");
    },
    preloading: function preloading() {
      var _this = this;

      this.loading = true;
      setTimeout(function () {
        return _this.loading = false;
      }, 1500);
    },
    getCamsData: function getCamsData() {
      this.sendMessage({
        command: __WEBPACK_IMPORTED_MODULE_8__const_playerEvents__["a" /* playerEvents */].GET_CAMERAS_DATA,
        request_id: 1
      });
    },
    exportFiles: function exportFiles(data) {
      var startDateFormat = data.start_date.creationData().format;
      var endDateFormat = data.end_date.creationData().format;
      var startDateView = data.start_date.format(startDateFormat);
      var endDateView = data.end_date.format(endDateFormat);
      var formatSend = "DD-MM-YYYY HH:mm:ss.000";
      data.start_date = data.start_date.format(formatSend);
      data.end_date = data.end_date.format(formatSend);
      this.intervalDateVideo = startDateView.slice(0, 16) + " - " + endDateView.slice(0, 16);
      var exportParams = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, data, {
        command: __WEBPACK_IMPORTED_MODULE_8__const_playerEvents__["a" /* playerEvents */].START_EXPORT
      });
      this.sendMessage(exportParams);
    },
    stopExportFile: function stopExportFile(id) {
      this.sendMessage({
        command: __WEBPACK_IMPORTED_MODULE_8__const_playerEvents__["a" /* playerEvents */].STOP_EXPORT,
        id: id
      });
    },
    getMessage: function getMessage(event) {
      var _this2 = this;

      if (event && event.data && typeof event.data === "string") {
        var data = JSON.parse(event.data);

        switch (data.action) {
          case __WEBPACK_IMPORTED_MODULE_8__const_playerEvents__["a" /* playerEvents */].ALERTS:
            this.$router.push({
              name: "alarms",
              query: { cams: data.camera_id }
            });
            break;
          case __WEBPACK_IMPORTED_MODULE_8__const_playerEvents__["a" /* playerEvents */].ON_MAP:
            var params = null;

            this.$store.state.maps.forEach(function (item) {
              item.map.forEach(function (i) {
                i.objects.forEach(function (o) {
                  if (data.camera_id == o.id) params = { mapGroupId: item.id, mapId: i.id };
                });
              });
            });

            if (params) {
              this.$store.commit("setCamIdFromCell", data.camera_id);
              this.$router.push({ name: "map", params: params });
            }
            break;

          case __WEBPACK_IMPORTED_MODULE_8__const_playerEvents__["a" /* playerEvents */].SET_PLAYER_MODE:
            this.$store.commit("setMode", data.mode);
            break;

          case __WEBPACK_IMPORTED_MODULE_8__const_playerEvents__["a" /* playerEvents */].CLOSE_CAMERA:
            {
              this.$store.commit("removeCamFromView", {
                camId: data.camera_id,
                viewId: this.$store.getters.getActiveView.id
              });

              if (this.isShowSolo) {
                this.$nextTick(function () {
                  return _this2.update();
                });
              }

              break;
            }

          case __WEBPACK_IMPORTED_MODULE_8__const_playerEvents__["a" /* playerEvents */].ADD_CAMERA:
            if (this.camsData) {
              this.camsData.list.forEach(function (item) {
                if (item.camera_index == data.camera_index) {
                  if (item.camera_id === "null") {
                    _this2.$store.commit("addCamsIntoView", {
                      camIds: [data.camera_id],
                      viewId: _this2.$store.getters.getActiveView.id
                    });
                  } else {
                    _this2.$store.commit("replaceCam", {
                      camId: data.camera_id,
                      replacedCamId: item.camera_id,
                      viewId: _this2.$store.getters.getActiveView.id
                    });
                  }
                }
              });
            }

            break;

          case __WEBPACK_IMPORTED_MODULE_8__const_playerEvents__["a" /* playerEvents */].GET_CAMERAS_DATA:
            this.camsData = data;
            break;
          case __WEBPACK_IMPORTED_MODULE_8__const_playerEvents__["a" /* playerEvents */].LONG_POOL_UPLOAD:
            {
              this.$store.commit("setUplodedVideos", __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, data, {
                intervalDateVideo: this.intervalDateVideo
              }));
              break;
            }

          case __WEBPACK_IMPORTED_MODULE_8__const_playerEvents__["a" /* playerEvents */].PLAYER_DOUBLE_CLICK:
            {
              this.isShowSolo = !this.isShowSolo;

              var messageData = {
                command: __WEBPACK_IMPORTED_MODULE_8__const_playerEvents__["a" /* playerEvents */].SHOW_MONITOR,
                monitor_id: this.params.monitor_id,
                geometry: this.isShowSolo ? "" : this.params.geometry,
                mode: this.params.mode,
                camera_list: this.isShowSolo ? data.camera_id : this.params.camera_list.join(","),
                layout: this.isShowSolo ? 1 : this.params.layout,
                time: data.date
              };

              if (this.params.time) {
                messageData.time = this.params.time;
              }

              this.sendMessage(messageData);
            }
        }

        switch (data.command) {
          case __WEBPACK_IMPORTED_MODULE_8__const_playerEvents__["a" /* playerEvents */].EXPORT_CONTROL:
            __WEBPACK_IMPORTED_MODULE_7__services_EventBus__["a" /* EventBus */].$emit("open:export", data.camera_id);
            break;
          case __WEBPACK_IMPORTED_MODULE_8__const_playerEvents__["a" /* playerEvents */].INIT:
            if (+data.arch_cnv_enabled === 0) {
              this.$store.commit("setArchCnvEnabled", false);
            } else {
              this.$store.commit("setArchCnvEnabled", true);
            }
            break;
        }
      }
    }
  }
});

/***/ }),

/***/ 465:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return alarmApiService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_ApiService__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_sortBy__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_sortBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_sortBy__);










/**
 * @typedef {Object} Alarm
 * @property {string} camId Camera id: cam1id
 * @property {string} name Camera name: Cam 1
 * @property {number} timestamp Event unix timestamp
 * @property {string} comment Event comment
 * @property {string} id Event id
 * @property {string} time_write Event time write in base
 * @property {string} time Event timestamp DD-MM-YY HH:mm:ss
 * @property {"ATTACH"|"BLINDING"|"DETACH"|"DEFOCUSED"|"FOCUSED"|"MD_START"|"MD_STOP"|"REC"|"REC_STOP"|"UNBLINDING"|"ARMED"|"DISARMED"|"REC_ERROR"} action Event action
 */

/**
 * @typedef {Object} Params
 * @property {string} startTime  Date start time 2023-06-21T16:43:27+03:00
 * @property {string} stopTime Date start time 2023-06-21T16:43:27+03:00
 * @property {number} max_count Maximum number of Events
 */

var AlarmApi = function () {
  function AlarmApi() {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, AlarmApi);

    /** @private */
    this.http = new __WEBPACK_IMPORTED_MODULE_6__services_ApiService__["a" /* default */]();
  }

  /**
   * @param {Array<{id: string}>} cams Current active cams
   * @param {Params} params Params for request
   * @return {Promise<Alarm[]>} Array with alarms ordered by newer to older
   *
   */


  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(AlarmApi, [{
    key: "getAlarms",
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(cams) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var requestDateFormat, transformedCams, paramsCopy, response, result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                requestDateFormat = "YYYYMMDDTHHmmss";
                transformedCams = cams.reduce(function (result, currentCam) {
                  result[currentCam.id] = currentCam;

                  return result;
                }, {});
                paramsCopy = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, params);


                paramsCopy.startTime = __WEBPACK_IMPORTED_MODULE_7_moment___default()(paramsCopy.startTime).format(requestDateFormat);
                paramsCopy.stopTime = __WEBPACK_IMPORTED_MODULE_7_moment___default()(paramsCopy.stopTime).format(requestDateFormat);

                _context.next = 7;
                return this.http.get("protocol/?", {
                  params: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
                    ids: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(transformedCams).toString(),
                    type: "CAM",
                    order: "desc"
                  }, paramsCopy)
                });

              case 7:
                response = _context.sent;
                result = response.map(function (event) {
                  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
                    camId: event.obj_id,
                    name: transformedCams[event.obj_id] ? transformedCams[event.obj_id].name : "Not Found",
                    timestamp: __WEBPACK_IMPORTED_MODULE_7_moment___default()(event.time, "DD-MM-YY HH:mm:ss").unix()
                  }, event);
                });
                return _context.abrupt("return", __WEBPACK_IMPORTED_MODULE_8_lodash_sortBy___default()(result, function (alarm) {
                  return -alarm.timestamp;
                }));

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getAlarms(_x) {
        return _ref.apply(this, arguments);
      }

      return getAlarms;
    }()
  }]);

  return AlarmApi;
}();

var alarmApiService = new AlarmApi();

/***/ }),

/***/ 466:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_modal_Modal_vue__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_inputText_InputText_vue__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_dropdown_Dropdown_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_modalPage_ModalPage_vue__ = __webpack_require__(951);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__consts_storageKeys__ = __webpack_require__(108);








var contractionString = function contractionString(inputString) {

    if (!inputString) {
        return '';
    }

    if (inputString.length <= 14) {
        return inputString;
    }

    return inputString.slice(0, 14).trim() + '...';
};

var updateSiteNameInSiteHistory = function updateSiteNameInSiteHistory(id, newName) {
    var siteHistoryJSON = localStorage.getItem(__WEBPACK_IMPORTED_MODULE_6__consts_storageKeys__["a" /* default */].SITE_HISTORY);

    if (!siteHistoryJSON) {
        return [];
    }

    var siteHistory = JSON.parse(siteHistoryJSON);

    var siteInHistory = siteHistory.find(function (site) {
        return site.id === id;
    });
    siteInHistory.name = newName;
    localStorage.setItem(__WEBPACK_IMPORTED_MODULE_6__consts_storageKeys__["a" /* default */].SITE_HISTORY, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(siteHistory));
    return siteHistory;
};

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'user-info',
    inject: ['auth', 'localization'],
    data: function data() {
        return {
            form: {
                site: {
                    name: 'site',
                    validator: { required: true, uniqueObject: true },
                    placeholder: 'global.site',
                    value: null
                }
            },
            editing: false,
            siteHistory: [],
            links: [{ name: 'global.aboutSecuros', alias: 'about' }],
            lang: {
                active: this.$store.state.i18n.locale,
                modal: false,
                list: [{ name: 'en', title: 'Eng' }, { name: 'ru', title: 'Рус' }]
            }
        };
    },

    computed: {
        title: function title() {
            if (this.$store.state.user === false || !this.$store.state.user.site.name) {
                return this.loginText('', contractionString(this.$store.state.user.login));
            }

            return this.loginText(contractionString(this.$store.state.user.site.name), this.$store.state.user.login);
        },
        siteActionName: function siteActionName() {
            if (this.$store.state.user === false || !this.$store.state.user.site.name) {
                return this.$t('profileMenu.addSiteName');
            }

            return this.$t('profileMenu.editSiteName');
        },
        modalTitle: function modalTitle() {
            if (this.$store.state.user === false || !this.$store.state.user.site.name) {
                return this.$t("editSite.createSiteTitle");
            }
            return this.$t('editSite.editSiteTitle');
        }
    },
    created: function created() {
        var _this = this;

        var siteHistoryJSON = localStorage.getItem(__WEBPACK_IMPORTED_MODULE_6__consts_storageKeys__["a" /* default */].SITE_HISTORY);
        this.siteHistory = siteHistoryJSON ? JSON.parse(siteHistoryJSON) : [];

        this.$validator.extend('uniqueObject', {
            getMessage: function getMessage(field) {
                return 'customValidationError.uniqueObject';
            },
            validate: function validate(newSiteName) {

                return !_this.siteHistory.some(function (site) {
                    return newSiteName == site.name;
                });
            }
        });
    },

    methods: {
        logout: function logout() {
            var _this2 = this;

            this.auth.logout().then(function () {
                var websoketConnection = _this2.$store.state.wsWebConnect;
                if (websoketConnection) {
                    websoketConnection.close();
                }
                _this2.$router.push({ name: 'auth' });
            });
        },
        edit: function edit() {
            var _this3 = this;

            this.form.site.value = this.$store.state.user.site.name;
            this.editing = true;

            __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].nextTick(function () {
                var input = _this3.$refs['form-object'];

                if (input) input.$emit('focus');
            });
        },
        save: function save() {
            var _this4 = this;

            var usersJson = localStorage.getItem(__WEBPACK_IMPORTED_MODULE_6__consts_storageKeys__["a" /* default */].USERS);

            if (!usersJson) {
                return;
            }

            var users = JSON.parse(usersJson);
            var user = users.find(function (userInUsers) {
                return userInUsers.login == _this4.$store.state.user.login;
            });

            if (!user) {
                return;
            }

            user.site.name = this.form.site.value;
            this.$store.commit('setUser', user);
            localStorage.setItem(__WEBPACK_IMPORTED_MODULE_6__consts_storageKeys__["a" /* default */].USERS, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(users));

            this.siteHistory = updateSiteNameInSiteHistory(user.site.id, this.form.site.value);

            this.editing = false;
        },
        changeLang: function changeLang() {
            this.localization.set(this.lang.active);
            this.lang.modal = false;
        },
        loginText: function loginText() {
            var siteName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
            var login = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.$store.state.user.login;

            var siteNameFromStore = this.$store.state.user && this.$store.state.user.site && this.$store.state.user.site.name ? this.$store.state.user.site.name : '';
            var siteNameCopy = siteName ? siteName : siteNameFromStore;

            if (!siteNameCopy) {
                return login;
            }

            return siteNameCopy + ' > ' + login;
        }
    },
    components: {
        Modal: __WEBPACK_IMPORTED_MODULE_2__components_modal_Modal_vue__["a" /* default */],
        InputText: __WEBPACK_IMPORTED_MODULE_3__components_inputText_InputText_vue__["a" /* default */],
        Dropdown: __WEBPACK_IMPORTED_MODULE_4__components_dropdown_Dropdown_vue__["a" /* default */],
        ModalPage: __WEBPACK_IMPORTED_MODULE_5__components_modalPage_ModalPage_vue__["a" /* default */]
    }
});

/***/ }),

/***/ 467:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_perfect_scrollbar__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_perfect_scrollbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_perfect_scrollbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_loader_Loader_vue__ = __webpack_require__(57);



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'modal-page',
    data: function data() {
        return {
            content: '',
            loaded: false
        };
    },

    props: {
        name: {
            String: String,
            required: true
        },
        title: {
            type: String
        }
    },
    mounted: function mounted() {
        if (this.show) this.getPage();
    },

    components: {
        VuePerfectScrollbar: __WEBPACK_IMPORTED_MODULE_0_vue_perfect_scrollbar___default.a,
        Loader: __WEBPACK_IMPORTED_MODULE_1__components_loader_Loader_vue__["a" /* default */]
    },
    computed: {
        show: function show() {
            return this.$route.query.modal === this.name;
        }
    },
    watch: {
        show: function show(value) {
            this.loaded = false;

            if (value) {
                this.getPage();
            }
        }
    },
    methods: {
        getPage: function getPage() {
            var _this = this;

            setTimeout(function () {
                _this.$store.dispatch('getPage', _this.name + '_' + _this.$store.state.i18n.locale).then(function (content) {
                    _this.content = content;
                    _this.loaded = true;
                });
            }, 500);
        }
    }
});

/***/ }),

/***/ 468:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_loader_Loader_vue__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_dropdown_Dropdown_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_inputText_InputText_vue__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_dropdownSelect_DropdownSelect_vue__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_modal_Modal_vue__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_regex__ = __webpack_require__(958);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__consts_storageKeys__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_dropDownSearch_DropdownSearch_vue__ = __webpack_require__(959);









/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Auth',
    inject: ['auth', 'localization'],
    data: function data() {
        return {
            mode: 'new',
            users: [],
            loading: false,
            authError: false,
            form: {
                site: {
                    control: 'search-select',
                    value: null,
                    placeholder: 'global.site',
                    mode: 'new',
                    alias: 'site'
                },
                login: {
                    control: 'input-text',
                    value: null,
                    validator: { required: true, disableRoot: true },
                    placeholder: 'authPage.login'
                },
                password: {
                    control: 'input-text',
                    type: 'password',
                    value: null,
                    validator: { required: true },
                    placeholder: 'authPage.password'
                },
                remember: {
                    control: 'checkbox',
                    value: true,
                    trueValue: true,
                    falseValue: false,
                    label: 'authPage.saveCredentials',
                    mode: 'new'
                }
            },
            forgot: {
                show: false
            },
            lang: {
                active: null,
                list: [{ name: 'en', title: 'Eng' }, { name: 'ru', title: 'Рус' }]
            },
            siteHistory: []
        };
    },
    created: function created() {
        var _this = this;

        var usersJson = localStorage.getItem(__WEBPACK_IMPORTED_MODULE_6__consts_storageKeys__["a" /* default */].USERS);

        if (usersJson) {
            this.users = JSON.parse(usersJson);
        }

        if (this.users.length) {
            this.form.login.value = this.users[0].login;
        }

        var siteHistoryJson = localStorage.getItem(__WEBPACK_IMPORTED_MODULE_6__consts_storageKeys__["a" /* default */].SITE_HISTORY);
        this.siteHistory = siteHistoryJson ? JSON.parse(siteHistoryJson) : [];

        if (this.siteHistory.length) {
            this.form.site.value = this.siteHistory[0].name;
        }

        this.lang.active = this.lang.list.find(function (item) {
            return item.name === _this.$store.state.i18n.locale;
        });

        this.$validator.extend('disableRoot', {
            getMessage: function getMessage(field) {
                return 'customValidationError.disableRoot';
            },
            validate: function validate(value) {
                return value.toLowerCase() !== 'root';
            }
        });
    },

    computed: {
        formData: function formData() {
            return {
                site: this.form.site.value,
                login: this.form.login.value,
                password: this.form.password.value,
                remember: this.form.remember.value
            };
        }
    },
    watch: {
        form: {
            handler: function handler(form) {
                var _this2 = this;

                this.errors.items.forEach(function (item) {
                    _this2.errors.removeById('backend');
                });
            },

            deep: true
        }
    },
    methods: {
        login: function login() {
            var _this3 = this;

            this.$validator.validateAll().then(function (result) {
                if (result) {
                    _this3.loading = true;

                    _this3.auth.login(_this3.formData).then(function () {
                        _this3.loading = false;
                        _this3.$router.push({ name: 'views', params: { viewId: 'main' } });
                    }, function (e) {

                        switch (e.status) {
                            case 400:
                                _this3.errors.add({ field: 'password', msg: 'customValidationError.auth', id: 'backend' });
                                break;
                            case 401:
                                _this3.errors.add({ field: 'password', msg: 'customValidationError.unauthorized', id: 'backend' });
                                break;
                        }

                        _this3.loading = false;
                    });
                }
            });
        }
    },
    components: {
        Loader: __WEBPACK_IMPORTED_MODULE_0__components_loader_Loader_vue__["a" /* default */],
        Dropdown: __WEBPACK_IMPORTED_MODULE_1__components_dropdown_Dropdown_vue__["a" /* default */],
        DropdownSelect: __WEBPACK_IMPORTED_MODULE_3__components_dropdownSelect_DropdownSelect_vue__["a" /* default */],
        InputText: __WEBPACK_IMPORTED_MODULE_2__components_inputText_InputText_vue__["a" /* default */],
        Modal: __WEBPACK_IMPORTED_MODULE_4__components_modal_Modal_vue__["a" /* default */],
        DropDownSearch: __WEBPACK_IMPORTED_MODULE_7__components_dropDownSearch_DropdownSearch_vue__["a" /* default */]
    }
});

/***/ }),

/***/ 469:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_dropdown_Dropdown_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_perfect_scrollbar__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_perfect_scrollbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_perfect_scrollbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_inputText_InputText_vue__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_http__ = __webpack_require__(961);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_http___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_http__);






/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'dropdown-search',
    data: function data() {
        return {
            scroll: false,
            container: document.body
        };
    },

    props: {
        list: {
            type: Array,
            default: function _default() {
                return [];
            }
        },
        value: {
            default: null // String 
        },
        /**
         * при множественном выборе
         * предполагается, что выбираться будут все
         * по умолчанию, поэтому в этом случае placeholder
         * обязателен
         */
        placeholder: {
            type: String,
            default: ''
        },
        /**
         * максимальное количество показа элементов
         */
        max: {
            type: Number,
            default: 3
        },
        /**
         * классы стилей
         */
        type: {
            type: String
        },
        idField: {
            type: String,
            default: 'id'
        },
        nameField: {
            type: String,
            default: 'name'
        }
    },
    computed: {
        getOptionName: function getOptionName() {
            var _this = this;

            return function (option) {
                if ((typeof option === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(option)) === 'object') {
                    return option[_this.nameField];
                }
                return option;
            };
        },
        dropdownHeight: function dropdownHeight() {
            if (this.filteredList.length > 3) {
                return 90;
            }

            if (this.filteredList.length === 1) {
                return 32;
            }

            return this.filteredList.length * 30;
        },
        dropdownStyle: function dropdownStyle() {
            return { height: this.dropdownHeight + 'px !important', maxHeight: this.dropdownHeight + 'px !important' };
        },

        inputedText: {
            get: function get() {
                return this.value;
            },
            set: function set(value) {
                this.emitValue(value);
            }
        },
        filteredList: function filteredList() {
            var _this2 = this;

            if (!this.inputedText) {
                return this.list;
            }

            return this.list.filter(function (itemInList) {
                return itemInList[_this2.nameField].toLowerCase().includes(_this2.inputedText.toLowerCase());
            });
        }
    },
    methods: {
        emitValue: function emitValue(emitedValue) {
            this.$emit('update:value', emitedValue);
            this.$emit('change', emitedValue);
            this.$emit('input', emitedValue);
            this.$emit('blur');
        },
        select: function select(item) {
            this.emitValue(item[this.nameField]);
        },
        openDropdown: function openDropdown() {
            var _this3 = this;

            var option = this.$refs.scroll.$el.getElementsByClassName('first')[0];
            var content = this.$refs.options;
            var wrap = this.$refs.wrap;

            if (option && content) {
                this.$nextTick(function () {
                    var itemHeight = option.clientHeight + _this3.getStyleValue(option, 'marginBottom') + _this3.getStyleValue(option, 'marginTop');
                    var maxHeight = itemHeight * _this3.max + _this3.getStyleValue(wrap, 'paddingBottom') + _this3.getStyleValue(wrap, 'paddingTop');
                    var height = _this3.list.length * itemHeight;
                    _this3.scroll = height > maxHeight;

                    content.style.height = _this3.scroll ? maxHeight + 'px' : 'auto';

                    _this3.$refs.scroll.update();
                    _this3.$emit('select:open');
                });
            }
        },
        getStyleValue: function getStyleValue(el, style) {
            return parseInt(window.getComputedStyle(el)[style]);
        },
        openDropDownSearch: function openDropDownSearch() {

            if (this.$refs.dropdown.show) {
                return;
            }

            this.$refs.dropdown.toggle({
                target: this.$refs.dropdown.$el
            });
        }
    },
    components: {
        Dropdown: __WEBPACK_IMPORTED_MODULE_1__components_dropdown_Dropdown_vue__["a" /* default */],
        VuePerfectScrollbar: __WEBPACK_IMPORTED_MODULE_2_vue_perfect_scrollbar___default.a,
        InputText: __WEBPACK_IMPORTED_MODULE_3__components_inputText_InputText_vue__["a" /* default */]
    }
});

/***/ }),

/***/ 481:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_EventBus__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_player_Player_vue__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_modal_Modal_vue__ = __webpack_require__(86);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Cams",
  data: function data() {
    return {
      dragging: false,
      info: {
        show: false
      }
    };
  },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_2__services_EventBus__["a" /* EventBus */].$on("cam:dragstart", this.onDragstart);
    __WEBPACK_IMPORTED_MODULE_2__services_EventBus__["a" /* EventBus */].$on("cam:dragend", this.onDragend);
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_2__services_EventBus__["a" /* EventBus */].$off("cam:dragstart", this.onDragstart);
    __WEBPACK_IMPORTED_MODULE_2__services_EventBus__["a" /* EventBus */].$off("cam:dragend", this.onDragend);
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    view: "getActiveView",
    mode: "getMode",
    map: "getActiveMap",
    grid: "getActiveGrid"
  }), {
    cams: function cams() {
      return this.view ? this.view.cams : [];
    },
    isMap: function isMap() {
      return this.$route.params.mapId && this.$route.params.mapGroupId;
    },
    playerData: function playerData() {
      return {
        mode: this.mode,
        geometry: this.view.geometry ? this.view.geometry : "",
        layout: this.grid.value,
        camera_list: this.cams.map(function (cam) {
          return cam.id;
        })
      };
    }
  }),
  methods: {
    add: function add(data) {
      this.$store.commit("addCamsIntoView", {
        camIds: [data.camera_id],
        viewId: this.view.id
      });
    },
    remove: function remove(cam) {
      this.$store.commit("removeCamFromView", {
        camId: cam,
        viewId: this.view.id
      });
    },
    onDragstart: function onDragstart() {
      this.dragging = true;
    },
    onDragend: function onDragend() {
      this.dragging = false;
    }
  },
  components: {
    Player: __WEBPACK_IMPORTED_MODULE_3__components_player_Player_vue__["a" /* default */],
    Modal: __WEBPACK_IMPORTED_MODULE_4__components_modal_Modal_vue__["a" /* default */]
  }
});

/***/ }),

/***/ 482:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_EventBus__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_loader_Loader_vue__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_map_object_map_object_vue__ = __webpack_require__(986);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_dropdownSelect_DropdownSelect_vue__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__consts_mapObjSizes__ = __webpack_require__(202);












/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Map",
  data: function data() {
    return {
      popup: {
        open: false
      },
      x: null,
      y: null,
      translate: {
        x: 0,
        y: 0
      },
      dragging: false,
      zoom: {
        active: 1,
        list: [{ name: "25%", value: 0.25 }, { name: "50%", value: 0.5 }, { name: "75%", value: 0.75 }, { name: "100%", value: 1 }, { name: "150%", value: 1.5 }, { name: "175%", value: 1.75 }, { name: "200%", value: 2 }, { name: "300%", value: 3 }, { name: "400%", value: 4 }, { name: "600%", value: 6 }, { name: "800%", value: 8 }],
        fit: { name: "map.fitIntoWindow", value: "fit" }
      },
      loading: false,

      indicateAlarmsDur: 1000,
      isIndicateAlarms: true,
      isShowIndicateAlarms: Object(__WEBPACK_IMPORTED_MODULE_9__utils__["a" /* getIsAlarmedForMap */])(this.$route.params.mapGroupId, this.$route.params.mapId),
      indicateAlarmsTimeout: null,

      camIdFromCellDur: 500,
      camIdFromCellCountMax: 6,
      camIdFromCellCountShow: 0,
      camIdFromCellTimeout: null,
      isIndicateCamIdFromCell: true,
      limitWidthIcon: 20,
      prevZoom: 1
    };
  },
  mounted: function mounted() {
    this.camIdFromCellTimeout = setTimeout(this.onCamIdFromCellTimeout, this.camIdFromCellDur);

    if (this.isShowIndicateAlarms) {
      this.indicateAlarmsTimeout = setTimeout(this.onIndicateAlarmsTimeout, this.indicateAlarmsDur);
    }

    __WEBPACK_IMPORTED_MODULE_5__services_EventBus__["a" /* EventBus */].$on("mouseup", this.mouseup);

    __WEBPACK_IMPORTED_MODULE_5__services_EventBus__["a" /* EventBus */].$on("mousemove", this.mousemove);
  },
  beforeDestroy: function beforeDestroy() {
    clearTimeout(this.indicateAlarmsTimeout);
    this.indicateAlarmsTimeout = null;

    clearTimeout(this.camIdFromCellTimeout);
    this.camIdFromCellTimeout = null;
    this.$store.commit("setCamIdFromCell", "");

    __WEBPACK_IMPORTED_MODULE_5__services_EventBus__["a" /* EventBus */].$off("mouseup", this.mouseup);
    __WEBPACK_IMPORTED_MODULE_5__services_EventBus__["a" /* EventBus */].$off("mousemove", this.mouseup);
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
    maps: "getMaps",
    cams: "getCams",
    alarmCams: "getAlarmCams",
    activeMap: "getActiveMap",
    grids: "getGrids",
    camIdFromCell: "getCamIdFromCell"
  }), {
    map: function map() {
      var _this = this;

      if (this.activeMap) {
        var activeMap = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.activeMap, {
          cams: this.activeMap.cams.map(function (cam) {
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, _this.cams.find(function (c) {
              return c.id == cam.id;
            }), cam);
          }).filter(function (cam) {
            return !!cam.status;
          })
        });
        return activeMap;
      }

      return null;
    },
    mapObjects: function mapObjects() {
      return [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.map.cams), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.map.mapObjs));
    },
    isShowIndicateAlarmsControl: function isShowIndicateAlarmsControl() {
      var _this2 = this;

      return this.alarmCams.some(function (aCam) {
        return _this2.map.cams.some(function (mCam) {
          return aCam.id === mCam.id;
        });
      });
    },
    zoomList: function zoomList() {
      return [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.zoom.list), [this.zoom.fit]);
    },
    objsStyle: function objsStyle() {
      var _this3 = this;

      /**
       * в пикселях. Учитываем, что ширина равна высоте (круг)
       */
      var defaultWidth = __WEBPACK_IMPORTED_MODULE_10__consts_mapObjSizes__["a" /* mapObjSizes */][this.currentScale].cam.template;
      var minDistanceIcons = 5;
      var minDistanceCenter = defaultWidth + minDistanceIcons;

      var result = {};
      var mapWidth = this.map.width * this.zoom.active;
      var mapHeight = this.map.height * this.zoom.active;
      var mapObjs = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.map.cams), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.map.mapObjs));
      mapObjs.forEach(function (obj) {
        var addedObj = {
          id: obj.id,
          x: mapWidth / 100 * obj.x,
          y: mapHeight / 100 * obj.y,
          width: defaultWidth,
          left: mapWidth / 100 * obj.x - defaultWidth / 2,
          top: mapHeight / 100 * obj.y - defaultWidth / 2
        };
        var resultKey = obj.type === "CAM" ? obj.id : obj.type + "_" + obj.id;
        result[resultKey] = addedObj;
      });
      var styleObjArr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(result);
      styleObjArr.forEach(function (styleCompare) {
        styleObjArr.forEach(function (styleObj) {
          var distance = Math.sqrt(Math.pow(styleCompare.x - styleObj.x, 2) + Math.pow(styleCompare.y - styleObj.y, 2));
          if (distance !== 0) {
            var diffDistCenter = minDistanceCenter - distance;
            if (diffDistCenter > 0) {
              var maxWidthIcon = distance - minDistanceIcons;
              if (maxWidthIcon < _this3.limitWidthIcon) {
                maxWidthIcon = _this3.limitWidthIcon;
              }
              if (styleCompare.width > maxWidthIcon) {
                styleCompare.width = maxWidthIcon;
              }
              if (styleObj.width > maxWidthIcon) {
                styleObj.width = maxWidthIcon;
              }
            }
          }
        });
      });
      return result;
    },
    showGridMap: function showGridMap() {
      return this.map.width && this.map.width !== 1;
    },
    cellSize: function cellSize() {
      if (!this.showGridMap || !this.map) {
        return;
      }
      return Math.floor(Math.min(this.map.height, this.map.width) * 0.05) * this.zoom.active;
    },
    currentScale: function currentScale() {
      return this.activeMap.scale || "S";
    },
    levelOnMapSizes: function levelOnMapSizes() {
      return {
        maxWidth: __WEBPACK_IMPORTED_MODULE_10__consts_mapObjSizes__["a" /* mapObjSizes */][this.currentScale].level.width + "px",
        height: __WEBPACK_IMPORTED_MODULE_10__consts_mapObjSizes__["a" /* mapObjSizes */][this.currentScale].level.height + "px",
        fontSize: __WEBPACK_IMPORTED_MODULE_10__consts_mapObjSizes__["a" /* mapObjSizes */][this.currentScale].level.fontSize + "px"
      };
    },
    arrowOnLevelSize: function arrowOnLevelSize() {
      return {
        width: __WEBPACK_IMPORTED_MODULE_10__consts_mapObjSizes__["a" /* mapObjSizes */][this.currentScale].level.arrowIcon + "px",
        height: __WEBPACK_IMPORTED_MODULE_10__consts_mapObjSizes__["a" /* mapObjSizes */][this.currentScale].level.arrowIcon + "px"
      };
    }
  }),
  watch: {
    activeMap: {
      immediate: true,
      handler: function handler(map, prev) {
        var _this4 = this;

        var isSame = map && prev && map.id == prev.id && map.group.id == prev.group.id;

        if (!isSame) {
          this.setDefaultZoom();

          if (map) {
            this.loading = true;
            this.$store.dispatch("getMap", {
              mapId: map.id,
              mapGroupId: map.group.id,
              mapName: map.name
            }).then(function () {
              _this4.$store.dispatch("getMapImage", {
                mapGroupId: _this4.activeMap.group.id,
                mapId: _this4.activeMap.id,
                activeMap: _this4.activeMap
              }).finally(function () {
                _this4.setDefaultZoom();
                _this4.loading = false;
              });
            }).catch(function () {
              _this4.setDefaultZoom();
              _this4.loading = false;
            });
          }
        }
      }
    },
    $route: function $route(newRoute) {
      this.isShowIndicateAlarms = Object(__WEBPACK_IMPORTED_MODULE_9__utils__["a" /* getIsAlarmedForMap */])(newRoute.params.mapGroupId, newRoute.params.mapId);

      clearTimeout(this.indicateAlarmsTimeout);
      this.indicateAlarmsTimeout = null;

      if (this.isShowIndicateAlarms) {
        this.indicateAlarmsTimeout = setTimeout(this.onIndicateAlarmsTimeout, this.indicateAlarmsDur);
      } else {
        this.isIndicateAlarms = true;
      }

      clearTimeout(this.camIdFromCellTimeout);
      this.camIdFromCellTimeout = null;
      this.$store.commit("setCamIdFromCell", "");
    }
  },
  methods: {
    nextZoom: function nextZoom() {
      var _this5 = this;

      var zoomIn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      this.prevZoom = this.zoom.active;
      var next = void 0;

      if (!zoomIn) next = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.sortBy(this.zoom.list, function (item) {
        return item.value;
      }).find(function (item) {
        return item.value > _this5.zoom.active;
      });else next = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.sortBy(this.zoom.list, function (item) {
        return -item.value;
      }).find(function (item) {
        return item.value < _this5.zoom.active;
      });

      if (next) {
        this.zoom.active = next.value;
      }
    },
    setZoom: function setZoom(value) {
      if (!this.zoom.list.some(function (item) {
        return item.value === value;
      })) {
        var mapContainer = this.$refs.map;
        var ratio = this.map.width / this.map.height;
        var pratio = mapContainer.clientWidth / mapContainer.clientHeight;

        if (ratio < pratio) {
          value = mapContainer.clientHeight / this.map.height;
        } else {
          value = mapContainer.clientWidth / this.map.width;
        }

        this.zoom.fit.value = value;
      }

      this.translate.x = 0;
      this.translate.y = 0;
      this.zoom.active = value;
    },
    mousemove: function mousemove(e) {
      if (this.dragging) {
        this.translate.x = e.pageX - this.x;
        this.translate.y = e.pageY - this.y;
      }
    },
    mousedown: function mousedown(e) {
      e.preventDefault();
      this.dragging = true;
      this.x = e.pageX - this.translate.x;
      this.y = e.pageY - this.translate.y;
    },
    mouseup: function mouseup(e) {
      this.dragging = false;
      this.onChangeMapPosition();
    },
    mouseWheel: function mouseWheel(e) {
      this.nextZoom(e.deltaY > 0);
      this.onChangeMapPosition();
    },
    onIndicateAlarmsTimeout: function onIndicateAlarmsTimeout() {
      this.isIndicateAlarms = !this.isIndicateAlarms;
      this.indicateAlarmsTimeout = setTimeout(this.onIndicateAlarmsTimeout, this.indicateAlarmsDur);
    },
    onCamIdFromCellTimeout: function onCamIdFromCellTimeout() {
      if (this.camIdFromCellCountShow < this.camIdFromCellCountMax) {
        this.isIndicateCamIdFromCell = !this.isIndicateCamIdFromCell;
        this.camIdFromCellCountShow++;
        this.camIdFromCellTimeout = setTimeout(this.onCamIdFromCellTimeout, this.camIdFromCellDur);
      } else {
        this.isIndicateCamIdFromCell = false;
      }
    },
    onChangeShowIndicateAlarms: function onChangeShowIndicateAlarms() {
      Object(__WEBPACK_IMPORTED_MODULE_9__utils__["d" /* setIsAlarmedForMap */])(this.$route.params.mapGroupId, this.$route.params.mapId, this.isShowIndicateAlarms);

      if (this.isShowIndicateAlarms) {
        this.indicateAlarmsTimeout = setTimeout(this.onIndicateAlarmsTimeout, this.indicateAlarmsDur);
      } else {
        clearTimeout(this.indicateAlarmsTimeout);
        this.indicateAlarmsTimeout = null;
        this.isIndicateAlarms = true;
      }
    },
    onChangeMapPosition: function onChangeMapPosition() {
      var _this6 = this;

      this.$nextTick(function () {
        var mapContainer = _this6.$refs.map;
        var schemeImg = _this6.$refs.scheme;
        if (!mapContainer || !schemeImg) {
          return;
        }
        var parentPos = mapContainer.getBoundingClientRect();
        var childrenPos = schemeImg.getBoundingClientRect();
        var relativePos = {
          top: 0,
          bottom: 0,
          left: 0,
          right: 0
        };

        var iconCamHalfW = __WEBPACK_IMPORTED_MODULE_10__consts_mapObjSizes__["a" /* mapObjSizes */][_this6.currentScale].cam / 2;
        var iconCamHalfH = __WEBPACK_IMPORTED_MODULE_10__consts_mapObjSizes__["a" /* mapObjSizes */][_this6.currentScale].cam / 2;

        relativePos.top = childrenPos.top + iconCamHalfH - parentPos.top;
        relativePos.bottom = parentPos.bottom - childrenPos.bottom - iconCamHalfH;
        relativePos.left = childrenPos.left + iconCamHalfW - parentPos.left;
        relativePos.right = parentPos.right - childrenPos.right - iconCamHalfW;

        var visualRectPersent = {
          left: 0,
          right: 100,
          top: 0,
          bottom: 100
        };

        visualRectPersent.left = relativePos.left >= 0 ? 0 : Math.abs(relativePos.left / childrenPos.width * 100);
        visualRectPersent.right = relativePos.right >= 0 ? 100 : Math.abs((childrenPos.width + relativePos.right) / childrenPos.width * 100);
        visualRectPersent.top = relativePos.top >= 0 ? 0 : Math.abs(relativePos.top / childrenPos.height * 100);
        visualRectPersent.bottom = relativePos.bottom >= 0 ? 100 : Math.abs((childrenPos.height + relativePos.bottom) / childrenPos.height * 100);

        __WEBPACK_IMPORTED_MODULE_5__services_EventBus__["a" /* EventBus */].$emit("changeMapPosition", visualRectPersent);
      });
    },
    setDefaultZoom: function setDefaultZoom() {
      if (this.map && this.$refs.map) {
        var zoom = this.map.width > this.$refs.map.clientWidth || this.map.height > this.$refs.map.clientHeight ? "fit" : 1;
        this.setZoom(zoom);
      }
    },
    getMapObjKey: function getMapObjKey(mObj) {
      return mObj.type === "CAM" ? "cam" + mObj.id : mObj.type + "_" + mObj.id;
    },
    levelPositionOnMap: function levelPositionOnMap(level, elementKey) {
      var elementWitdh = 0;

      if (this.$refs[elementKey] && this.$refs[elementKey][0]) {
        elementWitdh = this.$refs[elementKey][0].$el.clientWidth;
      }

      return {
        top: this.map.height * this.zoom.active / 100 * level.y + "px",
        left: this.map.width * this.zoom.active / 100 * level.x - elementWitdh / 2 + "px"
      };
    }
  },
  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_6__components_loader_Loader_vue__["a" /* default */],
    MapObject: __WEBPACK_IMPORTED_MODULE_7__components_map_object_map_object_vue__["a" /* default */],
    DropdownSelect: __WEBPACK_IMPORTED_MODULE_8__components_dropdownSelect_DropdownSelect_vue__["a" /* default */]
  }
});

/***/ }),

/***/ 483:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_dropdown_Dropdown_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_loader_Loader_vue__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_iconCam_IconCam_vue__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_cam_Cam_vue__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__consts_mapObjSizes__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(73);









/* harmony default export */ __webpack_exports__["a"] = ({
  name: "MapObject",
  components: {
    Dropdown: __WEBPACK_IMPORTED_MODULE_2__components_dropdown_Dropdown_vue__["a" /* default */],
    IconCam: __WEBPACK_IMPORTED_MODULE_4__components_iconCam_IconCam_vue__["a" /* default */],
    Loader: __WEBPACK_IMPORTED_MODULE_3__components_loader_Loader_vue__["a" /* default */],
    Cam: __WEBPACK_IMPORTED_MODULE_5__components_cam_Cam_vue__["a" /* default */]
  },
  props: {
    map: {
      type: Object,
      required: true
    },
    type: {
      type: String, // cam | object
      default: "cam"
    },
    scale: {
      type: String,
      required: true,
      validator: function validator(scaleType) {
        return ["S", "L"].includes(scaleType);
      }
    },
    /**
     * объект камеры,
     * созданный после слияния объекта на карте
     * с type == 'CAM' и объекта камеры по запросу
     * cameras (fetchCams) (обязателен, если type === 'cam')
     */
    cam: {
      type: Object
    },
    /**
     * Другие объекты не являющиеся камерами (type !== 'CAM') -
     * обязателен, если type === 'object'
     */
    mapObject: {
      type: Object
    },
    limitWidthIcon: {
      type: Number,
      default: 20
    },
    /**
     * размеры иконки и расстояние между иконками на карте
     */
    styleWidthDistance: {
      type: Object,
      required: true
    },
    isHighlight: {
      type: Boolean
    },
    isIndicateAlarms: {
      type: Boolean
    }
  },
  data: function data() {
    return {
      dataObjectLoading: false,
      dataObject: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    alarmCams: "getAlarmCams"
  }), {
    loading: function loading() {
      var cam = this.cam;

      return cam && cam.image === "loading" || false;
    },
    isDataLoaded: function isDataLoaded() {
      if (this.type === "cam") {
        return this.cam.image && !this.loading;
      }
      return !this.dataObjectLoading;
    },
    isHaveImage: function isHaveImage() {
      return this.type === "cam" && ["DETACHED", "DISARM_DETACHED"].indexOf(this.cam.status.state) < 0;
    },
    image: function image() {
      var cam = this.cam;

      if (!cam) return null;
      return cam.image || cam.lastImage || null;
    },
    isLastImage: function isLastImage() {
      var cam = this.cam;

      if (!cam) return false;
      return !cam.image && cam.lastImage || false;
    },
    isViewCamera: function isViewCamera() {
      var isDataLoaded = this.isDataLoaded,
          isHaveImage = this.isHaveImage,
          dataObject = this.dataObject;

      return isDataLoaded && (isHaveImage || dataObject && dataObject.cameras);
    },
    isRefresh: function isRefresh() {
      var isHaveImage = this.isHaveImage,
          loading = this.loading;

      return !loading && isHaveImage;
    },
    imageDate: function imageDate() {
      var image = this.image,
          loading = this.loading,
          cam = this.cam;

      return !loading && image && cam.imageDate || null;
    },
    objectFontSize: function objectFontSize() {
      return {
        fontSize: __WEBPACK_IMPORTED_MODULE_6__consts_mapObjSizes__["a" /* mapObjSizes */][this.scale].cam.fontSize + "px"
      };
    }
  }),
  created: function created() {
    if (this.type === "object") {
      this.fetchObject();
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({
    getObject: "getObject"
  }), {
    getImage: function getImage() {
      if (this.isHaveImage) {
        this.$store.dispatch("getCamImage", this.cam.id);
      }
    },
    fetchObject: function fetchObject() {
      var _this = this;

      this.dataObjectLoading = true;
      this.getObject({
        type: this.mapObject.type,
        id: this.mapObject.id
      }).then(function (res) {
        _this.dataObject = res;
        _this.dataObjectLoading = false;
      });
    },
    onDropdownOpen: function onDropdownOpen(event) {
      if (event) {
        if (this.type === "cam") {
          this.getImage();
        } else {
          this.fetchObject();
        }
      }
    },
    viewCam: function viewCam() {
      if (this.type === "cam") {
        this.$router.push({
          name: "views",
          params: {
            viewId: "main",
            mapGroupId: this.map.group.id,
            mapId: this.map.id,
            camId: this.cam.id
          }
        });
      } else {
        this.$store.commit("addCamsIntoView", {
          camIds: this.dataObject.cameras.split(","),
          viewId: "main"
        });
        this.$router.push({
          name: "views",
          params: {
            viewId: "main"
          }
        });
      }
    },

    getViewName: __WEBPACK_IMPORTED_MODULE_7__utils__["c" /* getViewName */]
  })
});

/***/ }),

/***/ 484:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_EventBus_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_modal_Modal_vue__ = __webpack_require__(86);







/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'App',
    inject: ['auth'],
    data: function data() {
        return {
            timeout: null,
            resizing: false,
            version: 2,
            error: null,
            isIE: false
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
        activeMap: 'getActiveMap'
    })),
    created: function created() {
        var _this = this;

        var version = parseInt(localStorage.getItem('version'));

        if (version < this.version) localStorage.clear();

        localStorage.setItem('version', this.version);

        __WEBPACK_IMPORTED_MODULE_4__services_EventBus_js__["a" /* EventBus */].$on('error', function (data) {
            _this.error = data;
        });

        var ua = window.navigator.userAgent.toLowerCase();

        if (/trident/gi.test(ua) || /msie/gi.test(ua)) {
            this.isIE = true;
            __WEBPACK_IMPORTED_MODULE_4__services_EventBus_js__["a" /* EventBus */].$emit('error', {
                message: 'global.errorIE'
            });
        }
    },
    mounted: function mounted() {
        var _this2 = this;

        window.addEventListener('resize', function () {
            _this2.resizing = true;
            clearTimeout(_this2.timeout);

            _this2.timeout = setTimeout(function () {
                _this2.resizing = false;
            }, 200);
        });
    },

    watch: {
        resizing: function resizing(value) {
            __WEBPACK_IMPORTED_MODULE_4__services_EventBus_js__["a" /* EventBus */].$emit('resize:' + (value ? 'start' : 'end'));
        },
        activeMap: function activeMap(map, prev) {
            var isSame = map && prev && map.id == prev.id && map.group.id == prev.group.id;
            if (!isSame) {
                if (prev) {
                    this.subscribeObjectChanges(prev, 'delete');
                }
                if (map) {
                    this.subscribeObjectChanges(map);
                }
            }
        }
    },
    methods: {
        rootClick: function rootClick() {
            __WEBPACK_IMPORTED_MODULE_4__services_EventBus_js__["a" /* EventBus */].$emit('root-click');
        },
        mouseup: function mouseup() {
            __WEBPACK_IMPORTED_MODULE_4__services_EventBus_js__["a" /* EventBus */].$emit('mouseup');
        },
        mousemove: function mousemove(e) {
            __WEBPACK_IMPORTED_MODULE_4__services_EventBus_js__["a" /* EventBus */].$emit('mousemove', e);
        },
        subscribeObjectChanges: function subscribeObjectChanges(mapObject) {
            var _this3 = this;

            var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'add';

            mapObject.objects.filter(function (item) {
                return item.type !== 'LEVEL' && item.type !== 'CAM';
            }).forEach(function (o) {
                _this3.$store.state.wsWebConnect.send(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
                    type: 'subscribe',
                    data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, action + '_rules', [{
                        type: o.type,
                        id: o.id,
                        action: 'STATE_CHANGED'
                    }])
                }));
            });
        }
    },
    components: {
        Modal: __WEBPACK_IMPORTED_MODULE_5__components_modal_Modal_vue__["a" /* default */]
    }
});

/***/ }),

/***/ 485:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(486);
module.exports = __webpack_require__(688);


/***/ }),

/***/ 56:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_dropdown_js__ = __webpack_require__(421);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1497e296_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dropdown_vue__ = __webpack_require__(854);
function injectStyle (ssrContext) {
  __webpack_require__(846)
}
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1497e296"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_dropdown_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1497e296_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 57:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_loader_js__ = __webpack_require__(434);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39a8dca6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loader_vue__ = __webpack_require__(874);
function injectStyle (ssrContext) {
  __webpack_require__(873)
}
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-39a8dca6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_loader_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39a8dca6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 688:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_resource__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_i18n__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vee_validate__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_moment__ = __webpack_require__(710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex_router_sync__ = __webpack_require__(712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_store__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_router__ = __webpack_require__(841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_filters__ = __webpack_require__(990);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_translateService__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modules_app_App_vue__ = __webpack_require__(991);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__services_AuthService__ = __webpack_require__(994);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__services_LocalizationService__ = __webpack_require__(995);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_drag_drop__ = __webpack_require__(997);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_drag_drop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vue_drag_drop__);



var _this = this;
















__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_15_vue_drag_drop___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_moment___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vuex_i18n__["a" /* default */].plugin, __WEBPACK_IMPORTED_MODULE_8__store_store__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_10__common_filters__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vee_validate__["b" /* default */], {
  dictionary: {
    ru: {
      messages: {
        required: function required(field) {
          return "\u041F\u043E\u043B\u0435 \"" + field + "\" \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E \u0434\u043B\u044F \u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F.";
        },
        regex: function regex(field) {
          return "\u041F\u043E\u043B\u0435 \"" + field + "\" \u0441\u043E\u0434\u0435\u0440\u0436\u0438\u0442 \u043D\u0435\u0434\u043E\u043F\u0443\u0441\u0442\u0438\u043C\u044B\u0435 \u0441\u0438\u043C\u0432\u043E\u043B\u044B.";
        }
      }
    }
  }
});

var initiateI18Translate = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return __WEBPACK_IMPORTED_MODULE_11__services_translateService__["a" /* translateService */].getTranslates();

          case 2:
            __WEBPACK_IMPORTED_MODULE_11__services_translateService__["a" /* translateService */].translate = _context.sent;

            __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].i18n.add("ru", __WEBPACK_IMPORTED_MODULE_11__services_translateService__["a" /* translateService */].translate.ru);
            __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].i18n.add("en", __WEBPACK_IMPORTED_MODULE_11__services_translateService__["a" /* translateService */].translate.en);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function initiateI18Translate() {
    return _ref.apply(this, arguments);
  };
}();

initiateI18Translate();

Object(__WEBPACK_IMPORTED_MODULE_7_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_8__store_store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__common_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */]({
  el: "#app",
  router: __WEBPACK_IMPORTED_MODULE_9__common_router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_8__store_store__["a" /* default */],
  template: "<App/>",
  components: { App: __WEBPACK_IMPORTED_MODULE_12__modules_app_App_vue__["a" /* default */] },
  provide: {
    auth: new __WEBPACK_IMPORTED_MODULE_13__services_AuthService__["a" /* default */](__WEBPACK_IMPORTED_MODULE_8__store_store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__common_router__["a" /* default */]),
    localization: new __WEBPACK_IMPORTED_MODULE_14__services_LocalizationService__["a" /* default */]()
  }
});

/***/ }),

/***/ 708:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 711:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 260,
	"./af.js": 260,
	"./ar": 261,
	"./ar-dz": 262,
	"./ar-dz.js": 262,
	"./ar-kw": 263,
	"./ar-kw.js": 263,
	"./ar-ly": 264,
	"./ar-ly.js": 264,
	"./ar-ma": 265,
	"./ar-ma.js": 265,
	"./ar-sa": 266,
	"./ar-sa.js": 266,
	"./ar-tn": 267,
	"./ar-tn.js": 267,
	"./ar.js": 261,
	"./az": 268,
	"./az.js": 268,
	"./be": 269,
	"./be.js": 269,
	"./bg": 270,
	"./bg.js": 270,
	"./bm": 271,
	"./bm.js": 271,
	"./bn": 272,
	"./bn-bd": 273,
	"./bn-bd.js": 273,
	"./bn.js": 272,
	"./bo": 274,
	"./bo.js": 274,
	"./br": 275,
	"./br.js": 275,
	"./bs": 276,
	"./bs.js": 276,
	"./ca": 277,
	"./ca.js": 277,
	"./cs": 278,
	"./cs.js": 278,
	"./cv": 279,
	"./cv.js": 279,
	"./cy": 280,
	"./cy.js": 280,
	"./da": 281,
	"./da.js": 281,
	"./de": 282,
	"./de-at": 283,
	"./de-at.js": 283,
	"./de-ch": 284,
	"./de-ch.js": 284,
	"./de.js": 282,
	"./dv": 285,
	"./dv.js": 285,
	"./el": 286,
	"./el.js": 286,
	"./en-au": 287,
	"./en-au.js": 287,
	"./en-ca": 288,
	"./en-ca.js": 288,
	"./en-gb": 289,
	"./en-gb.js": 289,
	"./en-ie": 290,
	"./en-ie.js": 290,
	"./en-il": 291,
	"./en-il.js": 291,
	"./en-in": 292,
	"./en-in.js": 292,
	"./en-nz": 293,
	"./en-nz.js": 293,
	"./en-sg": 294,
	"./en-sg.js": 294,
	"./eo": 295,
	"./eo.js": 295,
	"./es": 296,
	"./es-do": 297,
	"./es-do.js": 297,
	"./es-mx": 298,
	"./es-mx.js": 298,
	"./es-us": 299,
	"./es-us.js": 299,
	"./es.js": 296,
	"./et": 300,
	"./et.js": 300,
	"./eu": 301,
	"./eu.js": 301,
	"./fa": 302,
	"./fa.js": 302,
	"./fi": 303,
	"./fi.js": 303,
	"./fil": 304,
	"./fil.js": 304,
	"./fo": 305,
	"./fo.js": 305,
	"./fr": 306,
	"./fr-ca": 307,
	"./fr-ca.js": 307,
	"./fr-ch": 308,
	"./fr-ch.js": 308,
	"./fr.js": 306,
	"./fy": 309,
	"./fy.js": 309,
	"./ga": 310,
	"./ga.js": 310,
	"./gd": 311,
	"./gd.js": 311,
	"./gl": 312,
	"./gl.js": 312,
	"./gom-deva": 313,
	"./gom-deva.js": 313,
	"./gom-latn": 314,
	"./gom-latn.js": 314,
	"./gu": 315,
	"./gu.js": 315,
	"./he": 316,
	"./he.js": 316,
	"./hi": 317,
	"./hi.js": 317,
	"./hr": 318,
	"./hr.js": 318,
	"./hu": 319,
	"./hu.js": 319,
	"./hy-am": 320,
	"./hy-am.js": 320,
	"./id": 321,
	"./id.js": 321,
	"./is": 322,
	"./is.js": 322,
	"./it": 323,
	"./it-ch": 324,
	"./it-ch.js": 324,
	"./it.js": 323,
	"./ja": 325,
	"./ja.js": 325,
	"./jv": 326,
	"./jv.js": 326,
	"./ka": 327,
	"./ka.js": 327,
	"./kk": 328,
	"./kk.js": 328,
	"./km": 329,
	"./km.js": 329,
	"./kn": 330,
	"./kn.js": 330,
	"./ko": 331,
	"./ko.js": 331,
	"./ku": 332,
	"./ku.js": 332,
	"./ky": 333,
	"./ky.js": 333,
	"./lb": 334,
	"./lb.js": 334,
	"./lo": 335,
	"./lo.js": 335,
	"./lt": 336,
	"./lt.js": 336,
	"./lv": 337,
	"./lv.js": 337,
	"./me": 338,
	"./me.js": 338,
	"./mi": 339,
	"./mi.js": 339,
	"./mk": 340,
	"./mk.js": 340,
	"./ml": 341,
	"./ml.js": 341,
	"./mn": 342,
	"./mn.js": 342,
	"./mr": 343,
	"./mr.js": 343,
	"./ms": 344,
	"./ms-my": 345,
	"./ms-my.js": 345,
	"./ms.js": 344,
	"./mt": 346,
	"./mt.js": 346,
	"./my": 347,
	"./my.js": 347,
	"./nb": 348,
	"./nb.js": 348,
	"./ne": 349,
	"./ne.js": 349,
	"./nl": 350,
	"./nl-be": 351,
	"./nl-be.js": 351,
	"./nl.js": 350,
	"./nn": 352,
	"./nn.js": 352,
	"./oc-lnc": 353,
	"./oc-lnc.js": 353,
	"./pa-in": 354,
	"./pa-in.js": 354,
	"./pl": 355,
	"./pl.js": 355,
	"./pt": 356,
	"./pt-br": 357,
	"./pt-br.js": 357,
	"./pt.js": 356,
	"./ro": 358,
	"./ro.js": 358,
	"./ru": 359,
	"./ru.js": 359,
	"./sd": 360,
	"./sd.js": 360,
	"./se": 361,
	"./se.js": 361,
	"./si": 362,
	"./si.js": 362,
	"./sk": 363,
	"./sk.js": 363,
	"./sl": 364,
	"./sl.js": 364,
	"./sq": 365,
	"./sq.js": 365,
	"./sr": 366,
	"./sr-cyrl": 367,
	"./sr-cyrl.js": 367,
	"./sr.js": 366,
	"./ss": 368,
	"./ss.js": 368,
	"./sv": 369,
	"./sv.js": 369,
	"./sw": 370,
	"./sw.js": 370,
	"./ta": 371,
	"./ta.js": 371,
	"./te": 372,
	"./te.js": 372,
	"./tet": 373,
	"./tet.js": 373,
	"./tg": 374,
	"./tg.js": 374,
	"./th": 375,
	"./th.js": 375,
	"./tk": 376,
	"./tk.js": 376,
	"./tl-ph": 377,
	"./tl-ph.js": 377,
	"./tlh": 378,
	"./tlh.js": 378,
	"./tr": 379,
	"./tr.js": 379,
	"./tzl": 380,
	"./tzl.js": 380,
	"./tzm": 381,
	"./tzm-latn": 382,
	"./tzm-latn.js": 382,
	"./tzm.js": 381,
	"./ug-cn": 383,
	"./ug-cn.js": 383,
	"./uk": 384,
	"./uk.js": 384,
	"./ur": 385,
	"./ur.js": 385,
	"./uz": 386,
	"./uz-latn": 387,
	"./uz-latn.js": 387,
	"./uz.js": 386,
	"./vi": 388,
	"./vi.js": 388,
	"./x-pseudo": 389,
	"./x-pseudo.js": 389,
	"./yo": 390,
	"./yo.js": 390,
	"./zh-cn": 391,
	"./zh-cn.js": 391,
	"./zh-hk": 392,
	"./zh-hk.js": 392,
	"./zh-mo": 393,
	"./zh-mo.js": 393,
	"./zh-tw": 394,
	"./zh-tw.js": 394
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 711;

/***/ }),

/***/ 713:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_getters__ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_mutations__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_actions__ = __webpack_require__(838);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__consts_sessionStorageKeys__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__classes_views_mainView__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__consts_consts__ = __webpack_require__(84);









__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var getInitialUploadedVideos = function getInitialUploadedVideos() {
  var uploadedVideos = localStorage.getItem("uploadedVideos");
  return uploadedVideos ? JSON.parse(uploadedVideos) : [];
};

var getInitialStateVideos = function getInitialStateVideos() {
  var uploadedVideos = localStorage.getItem("uploadedVideos");
  return uploadedVideos ? JSON.parse(uploadedVideos).length : 0;
};

var getInitialStreamQuality = function getInitialStreamQuality() {
  var streamQuality = sessionStorage.getItem(__WEBPACK_IMPORTED_MODULE_5__consts_sessionStorageKeys__["a" /* default */].STREAM_QUALITY);
  return streamQuality ? JSON.parse(streamQuality) : 1;
};

var getInitialStreamMode = function getInitialStreamMode() {
  var streamMode = sessionStorage.getItem(__WEBPACK_IMPORTED_MODULE_5__consts_sessionStorageKeys__["a" /* default */].STREAM_MODE);
  return streamMode ? JSON.parse(streamMode) : 0;
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: {
    user: false,
    cams: {},
    camIdFromCell: "",
    archCnvEnabled: true,
    mainView: new __WEBPACK_IMPORTED_MODULE_6__classes_views_mainView__["a" /* MainView */](),
    localViews: [],
    globalViews: [],
    maps: [],
    mode: getInitialStreamMode(),
    grids: [{ value: __WEBPACK_IMPORTED_MODULE_7__consts_consts__["a" /* DEFAULT_GRID_ID */], max: 1, icon: "grid-1" }, { value: 2, max: 4, icon: "grid-4" }, { value: 10, max: 4, icon: "grid-1-3" }, { value: 11, max: 6, icon: "grid-1-5" }, { value: 12, max: 6, icon: "grid-2-4" }, { value: 13, max: 7, icon: "grid-4-3" }, { value: 4, max: 9, icon: "grid-9" }, { value: 5, max: 8, icon: "grid-1-7" }, { value: 14, max: 12, icon: "grid-12" }, { value: 7, max: 13, icon: "grid-1-12" }, { value: 6, max: 16, icon: "grid-16" }],
    grid: 1,
    stream: getInitialStreamQuality(),
    uploadedVideos: getInitialUploadedVideos(),
    videoState: {
      percent: 0,
      allVideoCount: getInitialStateVideos(),
      completeVideoCount: getInitialStateVideos(),
      status: "success"
    },
    wsWebConnect: null
  },
  getters: __WEBPACK_IMPORTED_MODULE_2__store_getters__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_3__store_mutations__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_4__store_actions__["a" /* default */]
}));

/***/ }),

/***/ 714:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__);



/* harmony default export */ __webpack_exports__["a"] = ({
  getUser: function getUser(state) {
    return state.user;
  },
  getCams: function getCams(state, getters) {
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(state.cams).map(function (cam) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, cam, {
        views: getters.getViews.filter(function (view) {
          return view.cams.find(function (camInView) {
            return cam.id === camInView.id;
          });
        })
      });
    });
  },
  getCamIdFromCell: function getCamIdFromCell(state) {
    return state.camIdFromCell;
  },
  getViews: function getViews(state, getters) {
    return [__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.mainView, {
      cams: state.mainView.cams.map(function (idCamView) {
        return state.cams[idCamView] || { id: null, name: "Empty" };
      })
    })].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(getters.getGlobalViews), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(getters.getLocalViews));
  },
  getLocalViews: function getLocalViews(state) {
    return state.localViews.map(function (view) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, view, {
        cams: view.cams.map(function (idCamView) {
          return state.cams[idCamView] || { id: null, name: "Empty" };
        })
      });
    }).sort(function (view1, view2) {
      return view1.name.localeCompare(view2.name, undefined, {
        numeric: true,
        sensitivity: "accent"
      });
    });
  },
  getGlobalViews: function getGlobalViews(state) {
    return state.globalViews.map(function (view) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, view, {
        cams: view.cams.map(function (idCamView) {
          return state.cams[idCamView] || { id: null, name: "Empty" };
        })
      });
    }).sort(function (view1, view2) {
      return view1.name.localeCompare(view2.name, undefined, {
        numeric: true,
        sensitivity: "accent"
      });
    });
  },
  getActiveView: function getActiveView(state, getters) {
    return getters.getViews.find(function (view) {
      return view.id == state.route.params.viewId;
    }) || null;
  },
  getMaps: function getMaps(state) {
    return state.maps;
  },
  getCamsMap: function getCamsMap(state) {
    return function (mapObjects) {
      return mapObjects.filter(function (item) {
        return item.type == "CAM" && item.enabled !== false;
      }).map(function (mapCam) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, mapCam, state.cams[mapCam.id]);
      });
    };
  },

  getLevelsMap: function getLevelsMap() {
    return function (mapObjects, group) {
      return mapObjects.filter(function (item) {
        return item.type == "LEVEL";
      }).map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, item, { mapId: group.map.find(function (m) {
            return m.name == item.id;
          }).id });
      });
    };
  },

  getMapById: function getMapById(state, getters) {
    return function (groupId, mapId) {
      var group = state.maps.find(function (group) {
        return group.id == groupId;
      }) || null;

      if (group) {
        var map = group.map.find(function (map) {
          return map.id == mapId;
        });

        if (map) {
          var cams = getters.getCamsMap(map.objects);

          var levels = getters.getLevelsMap(map.objects, group);

          var mapObjs = map.objects.filter(function (item) {
            return item.type !== "LEVEL" && item.type !== "CAM";
          });

          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, map, {
            cams: cams,
            levels: levels,
            mapObjs: mapObjs
          });
        }

        return null;
      }

      return null;
    };
  },
  getAlarmCams: function getAlarmCams(state, getters) {
    return getters.getCams.filter(function (cam) {
      return ["DISARM_DETACHED", "DETACHED", "ALARMED"].includes(cam.status.state) || cam.status.valid === false || cam.status.focused === "false" || cam.status.unblinded === "false";
    });
  },
  getAlarmMaps: function getAlarmMaps(state, getters) {
    var alarmsCams = getters.getAlarmCams;
    var filterGroup = getters.getMaps.reduce(function (accGroup, group) {
      var maps = group.map.reduce(function (accMap, map) {
        var camObjs = map.objects.filter(function (camObj) {
          return !!alarmsCams.find(function (ac) {
            return ac.id === camObj.id;
          });
        });
        if (camObjs.length) {
          return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(accMap), [__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, map, {
            parent: 0,
            objects: camObjs
          })]);
        }
        return accMap;
      }, []);
      if (maps.length) {
        return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(accGroup), [__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, group, {
          map: maps
        })]);
      }
      return accGroup;
    }, []);

    return filterGroup;
  },
  getActiveMap: function getActiveMap(state, getters) {
    return getters.getMapById(state.route.params.mapGroupId, state.route.params.mapId) || null;
  },
  getAlarmViews: function getAlarmViews(_, getters) {
    return getters.getViews.slice(1);
  },
  getAlarmsActiveView: function getAlarmsActiveView(state, getters) {
    if (state.route.query && state.route.query.view) {
      return getters.getViews.find(function (view) {
        return view.id == state.route.query.view;
      }) || null;
    }

    return null;
  },
  getAlarmsActiveViews: function getAlarmsActiveViews(state, getters) {
    if (state.route.query && state.route.query.view) {
      var queryView = state.route.query.view;
      var viewIds = queryView ? queryView.split(",") : null;
      var filterViews = viewIds && viewIds.length && getters.getViews && getters.getViews.length && getters.getViews.filter(function (_ref) {
        var id = _ref.id;
        return viewIds.includes(id.toString());
      }) || null;
      return filterViews && filterViews.length ? filterViews : null;
    }

    return null;
  },
  getMode: function getMode(state) {
    return state.mode;
  },
  getGrids: function getGrids(state) {
    return state.grids;
  },
  getActiveGrid: function getActiveGrid(state) {
    return state.grids.find(function (grid) {
      return grid.value == state.grid;
    }) || null;
  },
  getGrid: function getGrid(state) {
    return state.grid;
  },
  getStream: function getStream(state) {
    return state.stream;
  },
  getUplodedVideos: function getUplodedVideos(state) {
    return state.uploadedVideos;
  },
  getVideoState: function getVideoState(state) {
    return state.videoState;
  },
  getArchCnvEnabled: function getArchCnvEnabled(state) {
    return state.archCnvEnabled;
  }
});

/***/ }),

/***/ 725:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__ = __webpack_require__(727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_last__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_last___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_last__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_forEach__ = __webpack_require__(738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_sortBy__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_sortBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_sortBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__consts_sessionStorageKeys__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_helper__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__classes_views_mainView__ = __webpack_require__(418);














var prepareCamStatusesIconList = function prepareCamStatusesIconList(cam) {
  var _cam$status = cam.status,
      focused = _cam$status.focused,
      unblinded = _cam$status.unblinded,
      state = _cam$status.state,
      _cam$status$valid = _cam$status.valid,
      valid = _cam$status$valid === undefined ? null : _cam$status$valid,
      recorded = _cam$status.recorded;
  var telemetry_id = cam.settings.telemetry_id;

  var alarmed = cam.states && cam.states.alarmed || null;

  return [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(!!telemetry_id ? ["swivel"] : ["default"]), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(recorded === "1" ? ["rec"] : []), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(["DISARM_DETACHED", "DETACHED"].includes(state) || valid !== null && valid === false ? ["detached"] : []), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(focused === "0" || unblinded === "0" || state === "ALARMED" || alarmed !== null && alarmed ? ["alarmed"] : []));
};

var prepareCam = function prepareCam(cam) {
  var icon = prepareCamStatusesIconList(cam);
  return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, cam, {
    selected: false,
    icon: icon.join(" ")
  });
};

var getView = function getView(state, viewId) {
  return state.localViews.find(function (view) {
    return view.id == viewId;
  }) || (viewId === state.mainView.id ? state.mainView : null);
};

var debounceLimit = 60;
var debounceCount = 0;
var CAMS_COUNT_TO_INCREASE_DEBOUNCE_LIMIT = 15;

var debounceTimeout = null;
var queueMap = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default.a();

var addToMap = function addToMap(cam) {
  if (!queueMap.has(cam.id)) {
    queueMap.set(cam.id, cam);
    return;
  }

  var camInMap = queueMap.get(cam.id);

  queueMap.set(cam.id, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, cam, {
    states: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, camInMap.states, cam.states),
    rt: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, camInMap.rt, camInMap.status, cam.rt)
  }));
};

/* harmony default export */ __webpack_exports__["a"] = ({
  setUser: function setUser(state, user) {
    state.user = user;
  },
  resetUser: function resetUser(state) {
    state.user = false;
    state.mode = 0;
    state.stream = 1;
  },
  setCams: function setCams(state, cams) {
    var _cams = {};

    cams.forEach(function (cam) {
      var _cam = prepareCam(cam);
      _cams[cam.id] = _cam;
    });

    debounceLimit = Math.round(cams.length / CAMS_COUNT_TO_INCREASE_DEBOUNCE_LIMIT) * 10 || debounceLimit;

    state.cams = _cams;
  },
  changeCamState: function changeCamState(state, data) {
    var _this = this;

    var cam = state.cams[data.id];

    if (!cam) {
      return;
    }

    debounceCount++;

    addToMap(data);

    if (debounceCount > debounceLimit) {
      this.commit("updateCams");
      return;
    }

    if (debounceTimeout) {
      clearTimeout(debounceTimeout);
    }

    debounceTimeout = setTimeout(function () {
      _this.commit("updateCams");
    }, 1000);
  },
  updateCams: function updateCams(state) {
    queueMap.forEach(function (cam, camId) {
      var stateCam = state.cams[camId];

      stateCam.states = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, stateCam.states, cam.states);

      stateCam.rt = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, stateCam.rt, stateCam.status, cam.rt);

      stateCam.status.state = Object(__WEBPACK_IMPORTED_MODULE_8__utils__["b" /* getStateCamFromSocket */])(stateCam.states);

      stateCam.icon = prepareCamStatusesIconList({
        settings: stateCam.settings,
        status: stateCam.rt,
        states: stateCam.states
      });
    });

    queueMap.clear();
    debounceCount = 0;
    clearTimeout(debounceTimeout);
  },
  setCamIdFromCell: function setCamIdFromCell(state, camId) {
    state.camIdFromCell = camId;
  },
  setViews: function setViews(state, views) {
    state.mainView = new __WEBPACK_IMPORTED_MODULE_11__classes_views_mainView__["a" /* MainView */]();

    state.localViews = views.localViews;

    state.globalViews = views.globalViews;
  },
  saveView: function saveView(state, view) {
    var existing = state.localViews.find(function (v) {
      return v.id == view.id;
    });

    if (existing) {
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(existing, view);
      existing.changed = false;
    } else {
      state.localViews.push(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, view, {
        changed: false,
        temp: false
      }));
    }
  },
  removeView: function removeView(state, viewId) {
    state.localViews = state.localViews.filter(function (view) {
      return view.id != viewId;
    });
  },
  changeViewGrid: function changeViewGrid(state, _ref) {
    var grid = _ref.grid,
        viewId = _ref.viewId;

    var view = getView(state, viewId);

    if (view) {
      view.grid = grid;
      view.changed = true;
    }
  },
  changeStream: function changeStream(state, stream) {
    state.stream = stream;
    sessionStorage.setItem(__WEBPACK_IMPORTED_MODULE_9__consts_sessionStorageKeys__["a" /* default */].STREAM_QUALITY, stream);
  },
  addCamsIntoView: function addCamsIntoView(state, _ref2) {
    var camIds = _ref2.camIds,
        viewId = _ref2.viewId;

    var view = getView(state, viewId);

    if (view) {
      view.changed = true;

      view.cams.forEach(function (cam, i) {
        if (!cam) {
          view.cams[i] = camIds.shift();
        }
      });

      view.cams = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(view.cams), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(camIds));

      if (view.cams.length > state.grids.find(function (g) {
        return g.value == view.grid;
      }).max) {
        var grid = state.grids.find(function (g) {
          return g.max >= view.cams.length;
        }) || __WEBPACK_IMPORTED_MODULE_5_lodash_last___default()(state.grids);
        view.grid = grid.value;
      }

      state.grid = view.grid;
    }
  },
  removeCamFromView: function removeCamFromView(state, _ref3) {
    var camId = _ref3.camId,
        viewId = _ref3.viewId;

    var view = getView(state, viewId);

    if (camId === null) {
      view.cams = [];
      view.changed = true;
      return;
    }

    var index = view.cams.findIndex(function (id) {
      return id == camId;
    });

    if (view && index > -1) {
      view.cams[index] = null;

      var _last = null;

      view.cams.forEach(function (cam, i) {
        if (cam) _last = i + 1;
      });

      view.cams = _last === null ? [] : view.cams.slice(0, _last);
      view.changed = true;
    }
  },
  replaceCam: function replaceCam(state, _ref4) {
    var camId = _ref4.camId,
        replacedCamId = _ref4.replacedCamId,
        viewId = _ref4.viewId;

    var view = getView(state, viewId);

    var index = view.cams.findIndex(function (id) {
      return id == replacedCamId;
    });
    var cams = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(view.cams));

    cams[index] = camId;
    view.cams = cams;
    view.changed = true;
  },
  resetTempView: function resetTempView(state) {
    state.mainView.grid = state.grids[0].value;
    state.mainView.cams = [];
    state.mainView.changed = false;
  },
  setMaps: function setMaps(state, maps) {
    maps.forEach(function (map) {
      var items = [];
      __WEBPACK_IMPORTED_MODULE_6_lodash_forEach___default()(map.map, function (item, i) {
        items.push(__WEBPACK_IMPORTED_MODULE_10__common_helper__["a" /* default */].transformMap(item, i, map));
      });

      map.map = items;
    });

    state.maps = maps;
  },
  updateMap: function updateMap(state, _ref5) {
    var mapGroupId = _ref5.mapGroupId,
        mapId = _ref5.mapId,
        map = _ref5.map;

    var group = state.maps.find(function (group) {
      return group.id == mapGroupId;
    }) || null;

    if (group) {
      var _map = group.map.find(function (map) {
        return map.id == mapId;
      }) || null;

      if (_map) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(_map, map);
      }
    }
  },
  setMode: function setMode(state, mode) {
    state.mode = mode;
    sessionStorage.setItem(__WEBPACK_IMPORTED_MODULE_9__consts_sessionStorageKeys__["a" /* default */].STREAM_MODE, mode);
  },
  setGrid: function setGrid(state, grid) {
    state.grid = grid;
  },
  setUplodedVideos: function setUplodedVideos(state, video) {
    var canseledStatuses = ["ARCH_TASK_CANCELLED", "ARCH_TASK_NOT_EXISTS"];
    if (canseledStatuses.indexOf(video.status) !== -1) {
      return;
    }
    var listVideo = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(state.uploadedVideos));

    var videoState = {
      percent: 0,
      allVideoCount: 0,
      completeVideoCount: 0,
      status: "success"
    };

    var completeVideo = [];

    if (listVideo.length > 0) {
      var sameSessionVideo = listVideo.find(function (item) {
        return item.session === video.session;
      });
      if (sameSessionVideo) {
        video.intervalDateVideo = sameSessionVideo.intervalDateVideo;
      }
      listVideo = listVideo.filter(function (item) {
        return item.session !== video.session;
      });
    }

    listVideo.push(video);

    listVideo = listVideo.map(function (item) {
      item.percent = parseInt(item.percent);
      if (item.hasOwnProperty("link")) {
        if (!!item.link && !item.link.includes(location.origin)) {
          item.link = location.origin + item.link;
        }
        if (!!item.link) {
          item["statusLoad"] = "success";
          item["tooltipText"] = "video.complete";
          completeVideo.push(item);
          videoState.completeVideoCount += 1;
          videoState.percent += 100;
        }
      } else {
        item["link"] = null;
        item["statusLoad"] = !!item.problem ? "fail" : "progress";
        item["tooltipText"] = !!item.problem ? item.problem : "video.loading";
        videoState.percent += item.percent;
      }

      return item;
    });

    localStorage.setItem("uploadedVideos", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(completeVideo));
    state.uploadedVideos = listVideo;

    videoState.percent = videoState.percent / listVideo.length;
    videoState.allVideoCount = listVideo.length;
    videoState.status = videoState.completeVideoCount === videoState.allVideoCount ? "success" : listVideo.every(function (item) {
      return !!item.problem;
    }) ? "fail" : "progress";

    state.videoState = videoState;
  },
  deleteUplodedVideo: function deleteUplodedVideo(state, id) {
    var newUploadedVideos = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(state.uploadedVideos)).filter(function (item) {
      return item.session !== id;
    });
    var newCompleteVideos = newUploadedVideos.filter(function (item) {
      return !!item.link;
    });
    var commonPercent = newUploadedVideos.reduce(function (summ, video) {
      return !!video.link ? summ + 100 : summ + video.percent;
    }, 0);

    localStorage.setItem("uploadedVideos", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(newCompleteVideos));

    state.uploadedVideos = newUploadedVideos;

    state.videoState = {
      allVideoCount: newUploadedVideos.length,
      percent: commonPercent / newUploadedVideos.length,
      completeVideoCount: newCompleteVideos.length,
      status: newCompleteVideos.length === newUploadedVideos.length ? "success" : newUploadedVideos.every(function (item) {
        return !!item.problem;
      }) ? "fail" : "progress"
    };
  },
  setArchCnvEnabled: function setArchCnvEnabled(state, isEnabled) {
    state.archCnvEnabled = isEnabled;
  },
  setWsWebConnect: function setWsWebConnect(state, wsWebConnect) {
    state.wsWebConnect = wsWebConnect;
  },
  setObjectState: function setObjectState(state, _ref6) {
    var getters = _ref6.getters,
        data = _ref6.data;

    var activeMap = getters.getActiveMap;
    if (activeMap) {
      var object = activeMap.objects.find(function (o) {
        return o.type === data.type && o.id === data.id;
      });
      object.status = data.state;
    }
  }
});

/***/ }),

/***/ 73:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getStateCamFromSocket; });
/* unused harmony export getDate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getIsAlarmedForMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return setIsAlarmedForMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return transformLocalViews; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getViewName; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__consts_sessionStorageKeys__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__consts_consts__ = __webpack_require__(84);




/**
 *
 * @param {alarmed: Boolean, armed: Boolean, attached: Boolean} socketStates
 */
var getStateCamFromSocket = function getStateCamFromSocket(socketStates) {
  var alarmed = socketStates.alarmed,
      armed = socketStates.armed,
      attached = socketStates.attached;

  if (alarmed && attached) {
    return "ALARMED";
  }
  if (!alarmed && !armed && attached) {
    return "DISARMED";
  }
  if (!alarmed && armed && attached) {
    return "ARMED";
  }
  if (!alarmed && armed && !attached) {
    return "DETACHED";
  }
  if (!alarmed && !armed && !attached) {
    return "DISARM_DETACHED";
  }
};

var getDate = function getDate() {
  var local = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "ru";

  var numberLengthCheck = function numberLengthCheck(num) {
    return !num ? "00" : ("" + num).length < 2 ? "0" + num : num;
  };

  var getMonth = function getMonth(date) {
    if (!date) return "";
    var longStringMonth = date.toLocaleString(local, { month: "long" });
    var sliceMonth = longStringMonth.slice(0, 3);
    if (sliceMonth === "май") {
      sliceMonth = sliceMonth.slice(0, 2) + "я";
    }
    var firstL = sliceMonth.slice(0, 1).toUpperCase();
    var secondL = sliceMonth.slice(1, 3).toLowerCase();
    return firstL + secondL;
  };

  var date = new Date("01.01.2022");
  var day = numberLengthCheck(date.getDate());
  var month = getMonth(date);
  var year = date.getFullYear();
  var hours = numberLengthCheck(date.getHours());
  var minutes = numberLengthCheck(date.getMinutes());
  var seconds = numberLengthCheck(date.getSeconds());
  return day + " " + month + " " + year + " " + hours + ":" + minutes + ":" + seconds;
};

var getIsAlarmedForMap = function getIsAlarmedForMap(mapGroup, mapId) {
  var fromStorage = sessionStorage.getItem(__WEBPACK_IMPORTED_MODULE_1__consts_sessionStorageKeys__["a" /* default */].SHOW_ALARMED_CAMS);

  if (fromStorage === null) {
    return true;
  }

  var parsedAlarmedStructure = JSON.parse(fromStorage);

  var requiredMapGroup = parsedAlarmedStructure[mapGroup];
  if (!requiredMapGroup) {
    return true;
  }

  var requiredMap = requiredMapGroup[mapId];

  if (requiredMap === undefined) {
    return true;
  }

  return requiredMap;
};

var setIsAlarmedForMap = function setIsAlarmedForMap(mapGroup, mapId, value) {
  var fromStorage = sessionStorage.getItem(__WEBPACK_IMPORTED_MODULE_1__consts_sessionStorageKeys__["a" /* default */].SHOW_ALARMED_CAMS);

  if (fromStorage === null) {
    fromStorage = "{}";
  }

  var parsedAlarmedStructure = JSON.parse(fromStorage);

  if (!parsedAlarmedStructure[mapGroup]) {
    parsedAlarmedStructure[mapGroup] = {};
  }

  parsedAlarmedStructure[mapGroup][mapId] = value;

  sessionStorage.setItem(__WEBPACK_IMPORTED_MODULE_1__consts_sessionStorageKeys__["a" /* default */].SHOW_ALARMED_CAMS, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(parsedAlarmedStructure));
};

var transformLocalViews = function transformLocalViews(localViewsArray) {
  var isChanged = false;

  localViewsArray.forEach(function (localView) {
    if (String(localView.id).startsWith(__WEBPACK_IMPORTED_MODULE_2__consts_consts__["b" /* LOCAL_VIEW_ID_PREFIX */])) {
      return;
    }

    localView.id = __WEBPACK_IMPORTED_MODULE_2__consts_consts__["b" /* LOCAL_VIEW_ID_PREFIX */] + localView.id;
    isChanged = true;
  });

  return {
    isChanged: isChanged,
    localViewsArray: localViewsArray
  };
};

var getViewName = function getViewName(view, translate) {
  if (view.isGlobalView) {
    return translate(view.name) + " " + translate("global.globalView");
  }

  return translate(view.name);
};

/***/ }),

/***/ 837:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (['BOLID2_SECTION', 'BOLID2_SECTION_GROUP', 'BOLID2_ACCESS_POINT', 'BOLID2_ACCESS_ZONE', 'BOLID2_DEVICE', 'BOLID2_READER', 'BOLID2_RELAY', 'BOLID2_LOOP', 'BOLID2_SCRIPT']);

/***/ }),

/***/ 838:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_ApiService__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_helper__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__consts_storageKeys__ = __webpack_require__(108);











var api = new __WEBPACK_IMPORTED_MODULE_6__services_ApiService__["a" /* default */]();

/* harmony default export */ __webpack_exports__["a"] = ({
  getCams: function getCams(_ref) {
    var commit = _ref.commit;

    return new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      api.getCams().then(function (cams) {
        commit("setCams", cams.filter(function (cam) {
          return cam.status.enabled;
        }));
        resolve();
      }, function (e) {
        reject(e);
      });
    });
  },
  getMaps: function getMaps(_ref2) {
    var commit = _ref2.commit;

    api.getMaps().then(function (maps) {
      return commit("setMaps", maps.filter(function (_ref3) {
        var enabled = _ref3.enabled;
        return enabled;
      }));
    });
  },
  getMap: function getMap(_ref4, _ref5) {
    var commit = _ref4.commit;
    var mapId = _ref5.mapId,
        mapGroupId = _ref5.mapGroupId,
        mapName = _ref5.mapName;

    return api.getMap(mapGroupId).then(function (mapGroup) {
      var requiredMap = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default()(mapGroup.map).find(function (map) {
        return map.name === mapName;
      });

      if (!requiredMap) {
        return;
      }

      return commit("updateMap", {
        mapId: mapId,
        mapGroupId: mapGroupId,
        map: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_7__common_helper__["a" /* default */].transformMap(requiredMap, mapId, mapGroup))
      });
    });
  },
  getMapImage: function getMapImage(_ref6, _ref7) {
    var commit = _ref6.commit,
        getters = _ref6.getters;
    var mapGroupId = _ref7.mapGroupId,
        mapId = _ref7.mapId,
        activeMap = _ref7.activeMap;

    var data = {
      mapGroupId: mapGroupId,
      mapId: mapId
    };

    return new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      if (activeMap.url !== null) {
        __WEBPACK_IMPORTED_MODULE_7__common_helper__["a" /* default */].preloadImage(activeMap.url).then(function () {
          commit("updateMap", __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, data, {
            map: {
              image: activeMap.url,
              width: activeMap.width,
              height: activeMap.height
            }
          }));

          resolve(activeMap.globalURL);
        }).catch(function () {
          commit("updateMap", __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, data, {
            map: {
              image: false,
              width: activeMap.width || 1,
              height: activeMap.height || 1
            }
          }));

          reject();
        });
        return;
      }

      api.getMapImage(mapGroupId, activeMap.imageId).then(function (r) {
        __WEBPACK_IMPORTED_MODULE_7__common_helper__["a" /* default */].preloadImage(r).then(function () {
          commit("updateMap", __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, data, {
            map: {
              image: r,
              width: activeMap.width,
              height: activeMap.height
            }
          }));

          resolve(r);
        }).catch(function (e) {
          console.dir(e);
          console.log(e.message);

          commit("updateMap", __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, data, {
            map: {
              image: false,
              width: activeMap.width || 1,
              height: activeMap.height || 1
            }
          }));

          reject();
        });
      }).catch(function (e) {
        console.dir(e);
        console.log(e.message);

        commit("updateMap", __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, data, {
          map: {
            image: false,
            width: activeMap.width || 1,
            height: activeMap.height || 1
          }
        }));

        reject();
      });
    });
  },
  setGrid: function setGrid(_ref8, grid) {
    var commit = _ref8.commit,
        state = _ref8.state,
        getters = _ref8.getters;

    var view = getters.getActiveView;

    commit("setGrid", grid);

    if (view) {
      commit("changeViewGrid", {
        grid: grid,
        viewId: view.id
      });
    }
  },
  getCamImage: function getCamImage(_ref9, camId) {
    var state = _ref9.state;

    var cam = state.cams[camId] || null;

    if (cam) {
      var lastImage = null;
      if (cam.image) {
        lastImage = cam.image;
      } else if (cam.lastImage) {
        lastImage = cam.lastImage;
      }

      state.cams[camId] = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, state.cams[camId], {
        lastImage: lastImage,
        image: "loading"
      });

      api.getCamImage(cam.id).then(function (r) {
        var imageDate = __WEBPACK_IMPORTED_MODULE_8_moment___default()().locale(state.i18n.locale).format("DD MMMM YYYY HH:mm:ss").toLowerCase();

        state.cams[camId] = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, state.cams[camId], {
          imageDate: imageDate,
          lastImage: lastImage,
          image: r
        });
      }, function () {
        state.cams[camId] = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, state.cams[camId], {
          lastImage: lastImage,
          image: false
        });
      });
    }
  },
  getPage: function getPage(_ref10, name) {
    var commit = _ref10.commit,
        state = _ref10.state;

    return new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      api.getPage(name).then(function (r) {
        resolve(r);
      });
    });
  },
  getObject: function getObject(store, _ref11) {
    var type = _ref11.type,
        id = _ref11.id;

    return api.getAcsObject(type, id);
  },
  setWsWebConnect: function setWsWebConnect(_ref12) {
    var _this = this;

    var commit = _ref12.commit,
        dispatch = _ref12.dispatch,
        getters = _ref12.getters;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var res;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return api.get("ws_auth");

            case 3:
              res = _context2.sent;
              _context2.next = 6;
              return new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                var isSecure = window.location.protocol === "https:";

                var wsWebConnect = new WebSocket("ws" + (isSecure ? "s" : "") + "://" + window.location.host + "/ws/");

                commit("setWsWebConnect", wsWebConnect);

                wsWebConnect.onmessage = function () {
                  var _ref13 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(res) {
                    var data, authError;
                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            data = res.data ? JSON.parse(res.data) : null;
                            authError = new Error("Auth error");

                            authError.status = 401;

                            if (!data) {
                              _context.next = 13;
                              break;
                            }

                            _context.t0 = data.type;
                            _context.next = _context.t0 === "auth success" ? 7 : _context.t0 === "state" ? 10 : 12;
                            break;

                          case 7:
                            dispatch("subscribeCamsState");
                            resolve(wsWebConnect);
                            return _context.abrupt("break", 13);

                          case 10:
                            if (data.data.type === "CAM") {
                              commit("changeCamState", data.data);
                            } else {
                              commit("setObjectState", {
                                data: data.data,
                                getters: getters
                              });
                            }

                            return _context.abrupt("break", 13);

                          case 12:
                            reject(authError);

                          case 13:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee, _this);
                  }));

                  return function (_x) {
                    return _ref13.apply(this, arguments);
                  };
                }();
                wsWebConnect.onclose = function () {
                  var token = localStorage.getItem(__WEBPACK_IMPORTED_MODULE_9__consts_storageKeys__["a" /* default */].USER_TOKEN);

                  if (token) {
                    window.setTimeout(function () {
                      dispatch("setWsWebConnect");
                    }, 1000);
                  }
                };

                wsWebConnect.onopen = function () {
                  wsWebConnect.send(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
                    type: "auth",
                    token: res.token
                  }));
                };

                wsWebConnect.onerror = function (err) {
                  if (wsWebConnect.readyState === 0) {
                    reject(err);
                  }
                };
              });

            case 6:
              _context2.next = 11;
              break;

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](0);
              throw _context2.t0;

            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this, [[0, 8]]);
    }))();
  },
  subscribeCamsState: function subscribeCamsState(_ref14) {
    var _this2 = this;

    var state = _ref14.state;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              state.wsWebConnect.send(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
                type: "subscribe",
                data: {
                  add_rules: [{
                    type: "CAM",
                    action: "STATE_CHANGED"
                  }]
                }
              }));

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this2);
    }))();
  }
});

/***/ }),

/***/ 84:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOCAL_VIEW_ID_PREFIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_GRID_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MAIN_VIEW_ID; });
var LOCAL_VIEW_ID_PREFIX = "localView";
var DEFAULT_GRID_ID = 1;
var MAIN_VIEW_ID = "main";

/***/ }),

/***/ 841:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(842);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_dashboard_Dashboard_vue__ = __webpack_require__(843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_auth_Auth_vue__ = __webpack_require__(956);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_alarms_Alarms_vue__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_cams_Cams_vue__ = __webpack_require__(981);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_map_Map_vue__ = __webpack_require__(984);








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    redirect: '/dashboard/views/main'
  }, {
    path: '/auth',
    name: 'auth',
    component: __WEBPACK_IMPORTED_MODULE_3__modules_auth_Auth_vue__["a" /* default */]
  }, {
    path: '/dashboard/',
    name: 'Dashboard',
    component: __WEBPACK_IMPORTED_MODULE_2__modules_dashboard_Dashboard_vue__["a" /* default */],
    meta: {
      auth: true
    },
    props: { modal: 'agreement' },
    children: [{
      path: 'alarms/:alarmId?',
      name: 'alarms',
      component: __WEBPACK_IMPORTED_MODULE_4__modules_alarms_Alarms_vue__["a" /* default */],
      meta: {
        auth: true
      }
    }, {
      path: 'map/:mapGroupId/:mapId',
      name: 'map',
      component: __WEBPACK_IMPORTED_MODULE_6__modules_map_Map_vue__["a" /* default */],
      meta: {
        auth: true
      }
    }, {
      path: 'views',
      redirect: 'views/main'
    }, {
      path: 'views/:viewId?/:mapGroupId?/:mapId?/:camId?',
      name: 'views',
      component: __WEBPACK_IMPORTED_MODULE_5__modules_cams_Cams_vue__["a" /* default */],
      meta: {
        auth: true
      }
    }, {
      path: '',
      redirect: 'views/main'
    }]
  }],
  mode: 'history'
}));

/***/ }),

/***/ 843:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_dashboard_js__ = __webpack_require__(420);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cc48d22_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__ = __webpack_require__(955);
function injectStyle (ssrContext) {
  __webpack_require__(844)
}
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2cc48d22"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_dashboard_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cc48d22_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 844:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 846:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 854:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropdown",class:[_vm.positions, { opened: _vm.show }]},[_c('div',{ref:"toggle",staticClass:"toggle",attrs:{"data-id":_vm.id},on:{"click":function($event){$event.stopPropagation();!_vm.disabled ? _vm.toggle($event) : ''}}},[_vm._t("toggle",null,{"dataId":_vm.id})],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],ref:"list",staticClass:"list",class:{
      'width-container': _vm.widthContainer
    },on:{"click":function($event){$event.stopPropagation();return _vm.onClickList.apply(null, arguments)}}},[_vm._t("list")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 855:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 856:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_tree_item_js__ = __webpack_require__(425);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f477eb6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tree_item_vue__ = __webpack_require__(858);
function injectStyle (ssrContext) {
  __webpack_require__(857)
}
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_tree_item_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f477eb6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tree_item_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 857:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 858:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tree-item"},[_c('div',{staticClass:"item-btn",class:['level-' + _vm.level, 
    { active: _vm.active,
      opened: _vm.open, 
      'not-has-children': !_vm.hasChildren,
      found: _vm.found
    }],on:{"click":function($event){return _vm.select(_vm.model)}}},[(_vm.hasChildren)?_c('div',{staticClass:"arrow-wrapper",on:{"click":function($event){return _vm.onIconClick($event, _vm.model)}}},[_c('div',{staticClass:"icon-arrow"})]):_vm._e(),_vm._v(" "),_vm._t("default",function(){return [_c('div',{staticClass:"name",attrs:{"title":_vm.model.name,"model":_vm.model}},[_vm._v("\n        "+_vm._s(_vm._f("contraction")(_vm.model.name))+"\n      ")])]},{"model":_vm.model})],2),_vm._v(" "),_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasChildren && _vm.open),expression:"hasChildren && open"}],staticClass:"sub"},_vm._l((_vm.model.children),function(sub,index){return _c('li',{key:index,on:{"click":function($event){return _vm.$emit('click', sub)}}},[_c('tree-item',{attrs:{"model":sub,"bus":_vm.bus,"root":_vm.root,"value":_vm.value,"search":_vm.search,"level":_vm.level + 1,"select-on-name":_vm.selectOnName,"open-default":_vm.openDefault},on:{"update":function($event){return _vm.$emit('update')},"click":function (c) { return _vm.$emit('click', c); }},scopedSlots:_vm._u([_vm._l((_vm.$scopedSlots),function(index,name){return {key:"default",fn:function(data){return [_vm._t(name,null,null,data)]}}})],null,true)})],1)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 859:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"tree"},_vm._l((_vm.tree),function(item,index){return _c('li',{key:index},[_c('tree-item',{attrs:{"model":item,"root":_vm.root,"value":_vm.value,"bus":_vm.bus,"search":_vm.search,"select-on-name":_vm.selectOnName,"open-default":_vm.openDefault},on:{"update":function($event){return _vm.$emit('update')},"click":function (c) { return _vm.$emit('click', c); }},scopedSlots:_vm._u([_vm._l((_vm.$scopedSlots),function(index,name){return {key:"default",fn:function(data){return [_vm._t(name,null,null,data)]}}})],null,true)})],1)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 86:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_modal_js__ = __webpack_require__(437);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d760989_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__ = __webpack_require__(880);
function injectStyle (ssrContext) {
  __webpack_require__(879)
}
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_modal_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d760989_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 860:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 861:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_downloadList_js__ = __webpack_require__(429);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6087a513_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DownloadList_vue__ = __webpack_require__(871);
function injectStyle (ssrContext) {
  __webpack_require__(862)
}
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6087a513"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_downloadList_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6087a513_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DownloadList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 862:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 863:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_downloadListItem_js__ = __webpack_require__(430);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42ac1d58_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DownloadListItem_vue__ = __webpack_require__(870);
function injectStyle (ssrContext) {
  __webpack_require__(864)
}
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-42ac1d58"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_downloadListItem_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42ac1d58_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DownloadListItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 864:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 865:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 866:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner"},[(_vm.status === 'progress')?_c('svg',{staticClass:"progress",attrs:{"width":"100%","height":"100%","viewBox":"0 0 120 120"}},[_c('circle',{staticClass:"progress__meter",attrs:{"cx":"60","cy":"60","r":"54","stroke-width":"12"}}),_vm._v(" "),_c('circle',{staticClass:"progress__value",style:({strokeDashoffset: _vm.dashoffset, strokeDasharray: _vm.circumference}),attrs:{"cx":"60","cy":"60","r":"54","stroke-width":"12"}})]):_vm._e(),_vm._v(" "),(_vm.status === 'fail')?_c('img',{class:_vm.status,attrs:{"src":"/static/images/ic-oshibochka-vishla.svg"}}):_vm._e(),_vm._v(" "),(_vm.status === 'success')?_c('img',{class:_vm.status,attrs:{"src":"/static/images/ic-done.svg"}}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 867:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_tooltip_js__ = __webpack_require__(433);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d296dfd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tooltip_vue__ = __webpack_require__(869);
function injectStyle (ssrContext) {
  __webpack_require__(868)
}
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2d296dfd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_tooltip_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d296dfd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tooltip_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 868:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 869:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tooltip"},[_c('div',{staticClass:"target",class:{'haveContent': !!_vm.text}},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"contents-wrapper",class:[{ 'animation': _vm.animation,  }, ("" + _vm.position)]},[_c('span',{staticClass:"content"},[_vm._v(_vm._s(_vm.$t(_vm.text)))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 870:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"videoItem"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"left"},[_c('tooltip',{attrs:{"text":_vm.video.tooltipText,"position":_vm.index === 0 ? 'bottom-right': 'top-right'}},[_c('circle-progress',{attrs:{"progress":_vm.video.percent,"status":_vm.video.statusLoad}})],1),_vm._v(" "),_c('div',{staticClass:"id"},[_vm._v(_vm._s(_vm.video.source_id))])],1),_vm._v(" "),_c('div',{staticClass:"right"},[(_vm.video.link)?_c('a',{staticClass:"v-btn v-btn-load",attrs:{"href":_vm.video.link,"download":""}}):_vm._e(),_vm._v(" "),_c('button',{staticClass:"v-btn v-btn-close",on:{"click":function($event){return _vm.deleteVideo()}}})])]),_vm._v(" "),_c('div',{staticClass:"dates"},[_vm._v(_vm._s(_vm.video.intervalDateVideo))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 871:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.videos.length)?_c('div',{staticClass:"DownloadList",class:{'compactMode': _vm.compactMode, 'closeMenu': _vm.closeMenu}},[_c('div',{staticClass:"header",on:{"click":_vm.toggle}},[_c('div',{staticClass:"process"},[_c('circle-progress',{attrs:{"progress":_vm.videoState.percent,"status":_vm.videoState.status}}),_vm._v(" "),_c('div',{staticClass:"status"},[_vm._v(_vm._s(_vm.$t('video.downloading'))+" "+_vm._s(_vm.videoState.completeVideoCount)+"/"+_vm._s(_vm.videoState.allVideoCount))])],1),_vm._v(" "),_c('div',{staticClass:"toggler"})]),_vm._v(" "),_c('VuePerfectScrollbar',{staticClass:"scrollbar",attrs:{"settings":{ minScrollbarLength: 30 }}},[_c('div',{staticClass:"content"},_vm._l((_vm.videos),function(video,index){return _c('download-list-item',{key:video.session,attrs:{"video":video,"index":index}})}),1)])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 872:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"sidebar",class:[_vm.type, { opened: _vm.open,  'download-visible': _vm.downloadVisible} ]},[_c('div',{staticClass:"sidebar-wrap"},[( ! _vm.open)?_c('div',{staticClass:"toggle",on:{"click":_vm.toggle}},[_vm._t("icon")],2):_vm._e(),_vm._v(" "),(_vm.open)?_c('div',{staticClass:"sidebar-content"},[_vm._t("content")],2):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"bottom-toggle",on:{"click":_vm.toggle}},[_c('span',{staticClass:"icon-arrows"})]),_vm._v(" "),(_vm.type === 'right')?_c('div',{staticClass:"download-list-container",on:{"click":function($event){return _vm.toggle(true)}}},[_c('download-list',{attrs:{"closeMenu":!_vm.open},on:{"changeVisible":function($event){_vm.downloadVisible=$event}}})],1):_vm._e()]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 873:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 874:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader",class:_vm.type},[_c('div',{staticClass:"spinner"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 875:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 876:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search",class:{ clear: _vm.clear }},[_c('input',{ref:"searchInput",attrs:{"type":"text","placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"input":_vm.onInput}}),_vm._v(" "),(_vm.clear)?_c('button',{staticClass:"search__clear",on:{"click":function($event){$event.preventDefault();return _vm.clearInput.apply(null, arguments)}}}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 877:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_searchMapLevel_js__ = __webpack_require__(436);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48a105e4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchMapLevel_vue__ = __webpack_require__(902);
function injectStyle (ssrContext) {
  __webpack_require__(878)
}
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-48a105e4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_searchMapLevel_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48a105e4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchMapLevel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 878:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 879:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 880:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"modal"},[_c('div',[_vm._t("default")],2)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 881:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 885:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 886:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 887:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-wrapper",class:[
    _vm.cam.icon,
    {
      'icon-wrapper--preview': _vm.type === 'preview',
      'alarm-background': _vm.isAlarm,
      'cam-highlight': _vm.isHighlight
    }
  ],on:{"click":function($event){_vm.type === 'map' ? _vm.$emit('click') : ''}}},[_c('div',{staticClass:"icon-cam",style:(_vm.styleIcon),attrs:{"title":_vm.status ? _vm.$t(("camStatus." + _vm.status)) : ''}}),_vm._v(" "),_c('div',{staticClass:"icon-cam-status",style:(_vm.iconStatusSize)})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 888:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.cam)?_c('div',{staticClass:"cam",class:[
    {
      draggable: _vm.draggable,
      selected: _vm.selected,
      hovered: _vm.hovered,
      alarm: _vm.status === 'ALARMED',
      'in-map': _vm.inMap,
      'not-hover': _vm.notHover
    }
  ]},[_c('div',{staticClass:"info",class:{ 'has-views': _vm.cam.views && _vm.cam.views.length }},[_c('div',{staticClass:"main-info"},[_c('icon-cam',{staticClass:"icon",attrs:{"type":"preview","cam":_vm.cam}}),_vm._v(" "),(['ARMED', 'ALARMED'].includes(_vm.status))?_c('div',{staticClass:"move-on"}):_vm._e(),_vm._v(" "),(!_vm.inMap)?_c('div',{staticClass:"cam-name",attrs:{"title":_vm.cam.name}},[(!_vm.notContraction)?[_vm._v("\n          "+_vm._s(_vm._f("contraction")(_vm.cam.name))+"\n        ")]:[_vm._v("\n          "+_vm._s(_vm.cam.name)+"\n        ")]],2):_vm._e()],1),_vm._v(" "),(!_vm.inMap && !_vm.notViews && _vm.cam.views && _vm.cam.views.length)?_c('div',{staticClass:"views"},_vm._l((_vm.cam.views),function(view){return _c('a',{key:view.id,staticClass:"item",attrs:{"title":_vm.getViewName(view, _vm.$t)},on:{"click":function($event){return _vm.selectView(view)}}},[_vm._v("\n        "+_vm._s(_vm._f("contraction")(_vm.$t(view.name)))+"\n      ")])}),0):_vm._e()])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 889:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VuePerfectScrollbar',{ref:"mapListScroll",staticClass:"scrollbar",attrs:{"settings":{ suppressScrollX: true }}},[_c('div',{staticClass:"s-content"},[_c('tree',{attrs:{"data":_vm.mapData,"root":_vm.$route.params.mapGroupId,"value":_vm.$route.params.mapId,"search":_vm.search,"open-default":_vm.openDefault,"select-on-name":""},on:{"select":_vm.setMap,"update":_vm.updateScroll},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var model = ref.model;
return [(model.type === 'CAM')?_c('cam',{attrs:{"cam":model,"not-hover":"","not-contraction":"","not-views":""}}):_c('div',{attrs:{"title":model.name}},[_vm._v("\n          "+_vm._s(_vm._f("contraction")(model.name))+"\n        ")])]}}])})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 890:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 901:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dropdown',{staticClass:"dropdown-select",class:[_vm.type, { empty: !_vm.selected, 'has-scroll': _vm.scroll }],attrs:{"type":"full","container":_vm.container,"isSelect":true,"not-hide-on-list":Array.isArray(_vm.value),"width-container":""},on:{"open":_vm.openDropdown}},[_c('div',{staticClass:"current",attrs:{"slot":"toggle"},slot:"toggle"},[_c('div',{staticClass:"text"},[_vm._v("\n      "+_vm._s(Array.isArray(_vm.value) && _vm.value.length > 1 ? _vm.valueText : _vm.$t(_vm.valueText))+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"icon"})]),_vm._v(" "),_c('div',{ref:"options",staticClass:"options",attrs:{"slot":"list"},slot:"list"},[_c('VuePerfectScrollbar',{ref:"scroll",staticClass:"scrollbar",attrs:{"settings":{ minScrollbarLength: 30 }}},[_c('div',{ref:"wrap",staticClass:"s-content"},[(Array.isArray(_vm.value))?_c('div',{staticClass:"option",on:{"click":_vm.selectAll}},[_vm._v("\n          "+_vm._s(_vm.$t("global.all"))+"\n        ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.list),function(option,k){return _c('div',{key:k,staticClass:"option",class:{ active: _vm.getOptionActive(option), first: k == 0 },attrs:{"title":_vm.$t(_vm.getOptionName(option))},on:{"click":function($event){return _vm.select(option)}}},[_vm._v("\n          "+_vm._s(_vm.$t(_vm.getOptionName(option)))+"\n        ")])})],2)])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 902:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-map-level"},[_c('button',{staticClass:"btn btn-open",on:{"click":_vm.openModal}},[_vm._v("\n    "+_vm._s(_vm.$t('global.search'))+"\n  ")]),_vm._v(" "),_c('modal',{staticClass:"search-map-level-modal",attrs:{"show":_vm.modalShow}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"title"},[_c('div',{staticClass:"title__text"},[_vm._v("\n          "+_vm._s(_vm.$t('global.search'))+"\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn-close",attrs:{"type":"button"},on:{"click":_vm.hideModal}})]),_vm._v(" "),_c('div',{staticClass:"search-filters"},[_c('search',{staticClass:"search-input",attrs:{"placeholder":_vm.$t('placeHolders.findLocation')},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_vm._v(" "),_c('dropdown-select',{staticClass:"group-select",attrs:{"type":"small","list":_vm.groupOptions,"placeholder-all":_vm.$t('searchModal.allMaps')},model:{value:(_vm.selectedMapGroups),callback:function ($$v) {_vm.selectedMapGroups=$$v},expression:"selectedMapGroups"}}),_vm._v(" "),_c('button',{staticClass:"clear-filters-btn",attrs:{"type":"button"},on:{"click":_vm.clearFilters}})],1),_vm._v(" "),_c('div',{staticClass:"tree-container"},[(_vm.mapsCmp.length)?_c('map-list',{key:_vm.mapListKey,attrs:{"maps":_vm.mapsCmp,"route-name":_vm.routeName,"search":_vm.search,"open-default":"","show-objects":""},on:{"map-setted":_vm.hideModal}}):_c('div',{staticClass:"no-result"},[_vm._v("\n          "+_vm._s(_vm.$t("searchModal.No results found for '{search}'", { search: _vm.search }))+"\n        ")])],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 903:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 904:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"cams-list",class:{ preview: _vm.preview }},_vm._l((_vm.camGroups),function(cam,k){return _c('li',{key:'drag-cam' + k,on:{"click":function($event){!Array.isArray(cam) && _vm.$emit('cam-click', cam)}}},[(!Array.isArray(cam))?_c('drag',{attrs:{"transfer-data":{ camera_id: cam.id, connection_id: '' },"draggable":_vm.draggable},on:{"dragstart":_vm.onCamDrag}},[_c('cam',{staticClass:"cams-list__cam",attrs:{"draggable":_vm.draggable,"selected":_vm.isCamSelected && _vm.isCamSelected(cam),"cam":cam,"hovered":_vm.hovered,"preview":_vm.preview}})],1):_c('tree',{attrs:{"data":cam},on:{"update":function($event){return _vm.$emit('update')},"click":function (c) { return _vm.$emit('cam-click', c); }},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var model = ref.model;
return [(model.id)?_c('drag',{staticStyle:{"width":"100%"},attrs:{"transfer-data":{ camera_id: model.id, connection_id: '' },"draggable":_vm.draggable},on:{"dragstart":_vm.onCamDrag}},[_c('cam',{staticClass:"cams-list__cam",attrs:{"draggable":_vm.draggable,"hovered":_vm.hovered,"selected":_vm.isCamSelected && _vm.isCamSelected(model),"cam":model,"preview":_vm.preview}})],1):_vm._e()]}}],null,true)})],1)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 905:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_viewTabs_js__ = __webpack_require__(447);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57f43ed0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ViewTabs_vue__ = __webpack_require__(934);
function injectStyle (ssrContext) {
  __webpack_require__(906)
}
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-57f43ed0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_viewTabs_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57f43ed0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ViewTabs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 906:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 907:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 908:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-text",class:{ focused: _vm.focused, empty: _vm.empty, disabled: _vm.disabled, 'has-error': _vm.hasError }},[_c('div',{staticClass:"wrapper"},[(_vm.focused || ! _vm.empty)?_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.placeholder))]):_vm._e(),_vm._v(" "),((_vm.type)==='checkbox')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model),expression:"model"}],ref:"input",attrs:{"name":_vm.name,"placeholder":_vm.placeholder,"readonly":_vm.disabled,"autocomplete":"off","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.model)?_vm._i(_vm.model,null)>-1:(_vm.model)},on:{"focus":function($event){_vm.focused = true},"blur":function($event){_vm.focused = false; _vm.$emit('blur')},"change":function($event){var $$a=_vm.model,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.model=$$a.concat([$$v]))}else{$$i>-1&&(_vm.model=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.model=$$c}}}}):((_vm.type)==='radio')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model),expression:"model"}],ref:"input",attrs:{"name":_vm.name,"placeholder":_vm.placeholder,"readonly":_vm.disabled,"autocomplete":"off","type":"radio"},domProps:{"checked":_vm._q(_vm.model,null)},on:{"focus":function($event){_vm.focused = true},"blur":function($event){_vm.focused = false; _vm.$emit('blur')},"change":function($event){_vm.model=null}}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model),expression:"model"}],ref:"input",attrs:{"name":_vm.name,"placeholder":_vm.placeholder,"readonly":_vm.disabled,"autocomplete":"off","type":_vm.type},domProps:{"value":(_vm.model)},on:{"focus":function($event){_vm.focused = true},"blur":function($event){_vm.focused = false; _vm.$emit('blur')},"input":function($event){if($event.target.composing){ return; }_vm.model=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"clear",on:{"mousedown":_vm.clear}})]),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 909:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_timeInterval_js__ = __webpack_require__(449);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c5b0082_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimeInterval_vue__ = __webpack_require__(931);
function injectStyle (ssrContext) {
  __webpack_require__(910)
}
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5c5b0082"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_timeInterval_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c5b0082_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimeInterval_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 910:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 911:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_datetime_js__ = __webpack_require__(450);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61dabcc7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_datetime_vue__ = __webpack_require__(930);
function injectStyle (ssrContext) {
  __webpack_require__(912)
}
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_datetime_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61dabcc7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_datetime_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 912:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 913:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_input_text_js__ = __webpack_require__(451);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_216802be_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_input_text_vue__ = __webpack_require__(920);
function injectStyle (ssrContext) {
  __webpack_require__(914)
}
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-216802be"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_input_text_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_216802be_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_input_text_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 914:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 915:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_the_mask_vue__ = __webpack_require__(452);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d57587b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_the_mask_vue__ = __webpack_require__(919);
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_the_mask_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d57587b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_the_mask_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 916:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__masker__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tokens__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tokens___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__tokens__);



// https://developer.mozilla.org/en-US/docs/Web/Guide/Events/Creating_and_triggering_events#The_old-fashioned_way
function event(name) {
    var evt = document.createEvent('Event');
    evt.initEvent(name, true, true);
    return evt;
}

/* harmony default export */ __webpack_exports__["a"] = (function (el, binding) {
    var config = binding.value;
    if (Array.isArray(config) || typeof config === 'string') {
        config = {
            mask: config,
            tokens: __WEBPACK_IMPORTED_MODULE_1__tokens___default.a
        };
    }

    if (el.tagName.toLocaleUpperCase() !== 'INPUT') {
        var els = el.getElementsByTagName('input');
        if (els.length !== 1) {
            throw new Error('v-mask directive requires 1 input, found ' + els.length);
        } else {
            el = els[0];
        }
    }

    el.oninput = function (evt) {
        if (!evt.isTrusted) return; // avoid infinite loop
        /* other properties to try to diferentiate InputEvent of Event (custom)
        InputEvent (native)
        cancelable: false
        isTrusted: true
        composed: true
        isComposing: false
        which: 0
        Event (custom)
        cancelable: true
        isTrusted: false
        */
        // by default, keep cursor at same position as before the mask
        var position = el.selectionEnd;
        // save the character just inserted
        var digit = el.value[position - 1];
        el.value = Object(__WEBPACK_IMPORTED_MODULE_0__masker__["a" /* default */])(el.value, config.mask, true, config.tokens);
        // if the digit was changed, increment position until find the digit again
        if (position !== 0) {
            while (position < el.value.length && el.value.charAt(position - 1) !== digit) {
                position++;
            }
        }
        if (el === document.activeElement) {
            el.setSelectionRange(position, position);
            setTimeout(function () {
                el.setSelectionRange(position, position);
            }, 0);
        }
        el.dispatchEvent(event('input'));
    };

    var newDisplay = Object(__WEBPACK_IMPORTED_MODULE_0__masker__["a" /* default */])(el.value, config.mask, true, config.tokens);
    if (newDisplay !== el.value) {
        el.value = newDisplay;
        el.dispatchEvent(event('input'));
    }
});

/***/ }),

/***/ 917:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = maskit;
/* eslint-disable */

function maskit(value, mask) {
    var masked = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var tokens = arguments[3];

    value = value || '';
    mask = mask || '';
    var iMask = 0;
    var iValue = 0;
    var output = '';

    while (iMask < mask.length && iValue < value.length) {
        var cMask = mask[iMask];
        var masker = tokens[cMask];
        var cValue = value[iValue];
        if (masker && !masker.escape) {
            if (masker.pattern.test(cValue)) {
                output += masker.transform ? masker.transform(cValue) : cValue;
                iMask++;
            }
            iValue++;
        } else {
            if (masker && masker.escape) {
                iMask++; // take the next mask char and treat it as char
                cMask = mask[iMask];
            }
            if (masked) output += cMask;
            if (cValue === cMask) iValue++; // user typed the same char
            iMask++;
        }
    }

    // fix mask that ends with a char: (#)
    var restOutput = '';
    while (iMask < mask.length && masked) {
        var _cMask = mask[iMask];
        if (tokens[_cMask]) {
            restOutput = '';
            break;
        }
        restOutput += _cMask;
        iMask++;
    }

    return output + restOutput;
}

/***/ }),

/***/ 918:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = dynamicMask;
function dynamicMask(maskit, masks, tokens) {
    masks = masks.sort(function (a, b) {
        return a.length - b.length;
    });
    return function (value, mask) {
        var masked = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

        var i = 0;
        while (i < masks.length) {
            var currentMask = masks[i];
            i++;
            var nextMask = masks[i];
            if (!(nextMask && maskit(value, nextMask, true, tokens).length > currentMask.length)) {
                return maskit(value, currentMask, masked, tokens);
            }
        }
        return ''; // empty masks
    };
}

/***/ }),

/***/ 919:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{directives:[{name:"mask",rawName:"v-mask",value:(_vm.config),expression:"config"}],attrs:{"name":_vm.name,"type":_vm.type,"placeholder":_vm.placeholder,"readonly":_vm.disabled,"autocomplete":"off"},domProps:{"value":_vm.value},on:{"focus":function($event){return _vm.$emit('focus')},"blur":function($event){return _vm.$emit('blur')},"input":_vm.onInput}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 920:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-text",class:{ focused: _vm.focused, error: !!_vm.error && !_vm.focused }},[_c('div',{staticClass:"text-wrapper"},[(!_vm.mask)?_c('input',{ref:"input",attrs:{"name":_vm.name,"type":_vm.type,"placeholder":_vm.placeholder,"readonly":_vm.disabled,"autocomplete":"off"},domProps:{"value":_vm.value},on:{"focus":function($event){_vm.focused = true},"blur":function($event){_vm.focused = false},"input":function ($event) { _vm.$emit('input', $event.target.value) }}}):_vm._e(),_vm._v(" "),(_vm.mask)?_c('the-mask',{attrs:{"value":_vm.value,"name":_vm.name,"type":_vm.type,"placeholder":_vm.placeholder,"disabled":_vm.disabled,"mask":_vm.mask,"masked":_vm.masked},on:{"focus":function($event){_vm.focused = true},"blur":function($event){_vm.focused = false},"input":function (value) { _vm.$emit('input', value) }}}):_vm._e(),_vm._v(" "),(_vm.error && !_vm.focused && _vm.errorText)?_c('div',{staticClass:"error"},[_vm._v(_vm._s(_vm.error))]):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 921:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_datepicker_js__ = __webpack_require__(455);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b32b6b2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_datepicker_vue__ = __webpack_require__(923);
function injectStyle (ssrContext) {
  __webpack_require__(922)
}
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2b32b6b2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_datepicker_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b32b6b2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_datepicker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 922:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 923:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"datepicker"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"month-header"},[_c('div',{staticClass:"arrow arrow-left",on:{"click":_vm.prevMonth}},[_c('div',{staticClass:"icon"})]),_vm._v(" "),_c('span',{staticClass:"current-month"},[_vm._v(_vm._s(_vm._f("moment")(_vm.month,'MMMM YYYY')))]),_vm._v(" "),_c('div',{staticClass:"arrow arrow-right",on:{"click":_vm.nextMonth}},[_c('div',{staticClass:"icon"})])]),_vm._v(" "),_c('div',{staticClass:"days-header"},_vm._l((_vm.days[_vm.lang]),function(day){return _c('div',{key:day,staticClass:"col"},[_vm._v(_vm._s(day))])}),0)]),_vm._v(" "),_c('div',{staticClass:"body"},_vm._l((_vm.grid),function(week,i){return _c('div',{key:i,staticClass:"row row-body"},_vm._l((week),function(day,j){return _c('div',{key:'day' + j,staticClass:"col",class:{ 'other-month': day.otherMonth, today: day.today, selected: day.selected },on:{"click":function($event){return _vm.select(day)}}},[_c('div',{staticClass:"date"},[_vm._v(_vm._s(day.num))])])}),0)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 924:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_dropdown_js__ = __webpack_require__(456);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33915bb5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dropdown_vue__ = __webpack_require__(926);
function injectStyle (ssrContext) {
  __webpack_require__(925)
}
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-33915bb5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_dropdown_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33915bb5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 925:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 926:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropdown",class:{ opened: _vm.show }},[_c('div',{staticClass:"slot-toggle",on:{"click":function($event){$event.stopPropagation();return _vm.toggle.apply(null, arguments)}}},[_vm._t("toggle")],2),_vm._v(" "),_c('div',{staticClass:"slot-list",on:{"click":function($event){$event.stopPropagation();}}},[(_vm.show)?_vm._t("list"):_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 927:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_button_js__ = __webpack_require__(457);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d6c1bf1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_button_vue__ = __webpack_require__(929);
function injectStyle (ssrContext) {
  __webpack_require__(928)
}
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4d6c1bf1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_button_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d6c1bf1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 928:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 929:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:[_vm.type, { loading: _vm.loading }],attrs:{"type":_vm.submit ? 'submit' : 'button',"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"button-wrapper"},[_c('div',{staticClass:"bg-grad"}),_vm._v(" "),_c('span',{staticClass:"slot"},[_vm._t("default")],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 930:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"datetime"},[_c('div',{staticClass:"date"},[_c('dropdown',[_c('div',{staticClass:"dropdown-toggle",attrs:{"slot":"toggle"},slot:"toggle"},[_c('div',{staticClass:"datepicker-icon"},[_c('img',{attrs:{"src":"/static/images/ic-date.svg","alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"dropdown-list",attrs:{"slot":"list"},slot:"list"},[_c('datepicker',{attrs:{"format":_vm.data.date.format,"lang":_vm.lang},on:{"input":_vm.closePicker},model:{value:(_vm.control.date),callback:function ($$v) {_vm.$set(_vm.control, "date", $$v)},expression:"control.date"}})],1)]),_vm._v(" "),_c('input-text',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true, regex: _vm.data.date.regex }),expression:"{ required: true, regex: data.date.regex }"}],attrs:{"name":_vm.name + '_date',"placeholder":"—.—.——","mask":"##.##.####","masked":true,"error":_vm.errors.first(_vm.name + '_date') || _vm.error},model:{value:(_vm.control.date),callback:function ($$v) {_vm.$set(_vm.control, "date", $$v)},expression:"control.date"}})],1),_vm._v(" "),_c('div',{staticClass:"time"},[_c('input-text',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true, regex: _vm.data.time.regex }),expression:"{ required: true, regex: data.time.regex }"}],attrs:{"name":_vm.name + '_time',"placeholder":"—:—","mask":"##:##","masked":true,"error":_vm.errors.first(_vm.name + '_time') || _vm.error},model:{value:(_vm.control.time),callback:function ($$v) {_vm.$set(_vm.control, "time", $$v)},expression:"control.time"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 931:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"timeInterval"},[(_vm.titleTextPath)?_c('div',{key:("timeInterval__header_" + _vm.titleTextPath),staticClass:"header"},[_vm._v("\n        "+_vm._s(_vm.$t(_vm.titleTextPath))+"\n    ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"interval"},[_c('Datetime',{attrs:{"name":'start_date',"lang":_vm.lang,"format":_vm.format,"error":_vm.errorDifferent},on:{"error":_vm.getError},model:{value:(_vm.start_date),callback:function ($$v) {_vm.start_date=$$v},expression:"start_date"}}),_vm._v(" "),_c('span',{staticClass:"separator"},[_vm._v("-")]),_vm._v(" "),_c('Datetime',{attrs:{"name":'end_date',"lang":_vm.lang,"format":_vm.format,"error":_vm.errorDifferent},on:{"error":_vm.getError},model:{value:(_vm.end_date),callback:function ($$v) {_vm.end_date=$$v},expression:"end_date"}})],1),_vm._v(" "),_c('div',{staticClass:"btns"},[_c('div',{staticClass:"btn btn-secondary",on:{"click":function($event){return _vm.$emit('toggleExport')}}},[_c('span',[_vm._v(_vm._s(_vm.$t('btn.cancel')))])]),_vm._v(" "),_c('div',{staticClass:"btn btn-secondary",class:{'disable': _vm.error || _vm.errorDifferent},on:{"click":function($event){return _vm.saveVideo()}}},[_c('span',[_vm._v(_vm._s(_vm.$t('global.download')))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 932:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GlobalView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__consts_consts__ = __webpack_require__(84);



/**
 * @typedef {Object} SecurOSView
 * @property {string} cameras Cameras ids: cam1id,cam2id,cam3id,..,
 * @property {string} geometry View geometry: 0:0:1:1|1:0:1:1|...|2:1:1:1
 * @property {string} id View id: 1
 * @property {string} name View name: View 1
 */

/**
 * @class GlobalView
 * @property {string[]} cams Cameras ids: [cam1id,cam2id,cam3id,...]
 * @property {string} geometry View geometry: 0:0:1:1|1:0:1:1|...|2:1:1:1
 * @property {string} id View id: 1
 * @property {string} name View name: View 1
 * @property {boolean} isGlobalView Is global view flag
 * @property {number} grid Default grid id for GlobalViews
 */
var GlobalView =
/**
 * @param {SecurOSView} view
 */
function GlobalView(view) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, GlobalView);

  this.cams = view.cameras.split(",");
  this.geometry = view.geometry;
  this.id = view.id;
  this.name = view.name;
  this.isGlobalView = true;

  this.grid = __WEBPACK_IMPORTED_MODULE_1__consts_consts__["a" /* DEFAULT_GRID_ID */];
};

/***/ }),

/***/ 933:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LocalView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);

/**
 * @typedef {Object} View
 * @property {Array<string|number>} cams Cameras ids: [cam1id,cam2id,cam3id,...]
 * @property {number} grid View grid: 4
 * @property {number} id View id: 1
 * @property {string} name View name: View 1
 */

/**
 * @class LocalView
 * @property {Array<string|number>} cams Cameras ids: [cam1id,cam2id,cam3id,...]
 * @property {number} grid View grid: 4
 * @property {string} id View id: localView1
 * @property {string} name View name: View 1
 * @property {boolean} changed don't know
 * @property {boolean} temp don't know
 * @property {boolean} selected don't know
 * @property {boolean} isGlobalView is global view flag
 */

var LocalView =
/**
 * @param {View} view
 */
function LocalView(view) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, LocalView);

  this.cams = view.cams;
  this.grid = view.grid;
  this.id = view.id;
  this.name = view.name;

  this.changed = false;
  this.temp = false;
  this.selected = false;

  this.isGlobalView = false;
};

/***/ }),

/***/ 934:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabs",class:{ updating: _vm.updating, full: _vm.full }},[(_vm.updating)?_c('loader',{attrs:{"type":"small"}}):_vm._e(),_vm._v(" "),_c('div',{ref:"list",staticClass:"list"},[_vm._l((_vm.list.tabs),function(tab){return _c('div',{key:tab.id,staticClass:"tab",class:{
        active: _vm.activeView && _vm.activeView.id == tab.id,
        opened: tab.menu
      }},[_c('div',{staticClass:"btn-tab",on:{"click":function($event){return _vm.select(tab)}}},[_c('div',{staticClass:"inner",attrs:{"title":_vm.getViewName(tab, _vm.$t)}},[(tab.isGlobalView)?_c('div',{staticClass:"icon-globalView"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"name"},[_vm._v("\n            "+_vm._s(_vm._f("contraction")(_vm.$t(tab.name)))+"\n          ")])]),_vm._v(" "),(_vm.dropdownMenu(tab).length)?_c('dropdown',{staticClass:"dropdown-menu",attrs:{"show":tab.menu}},[_c('div',{staticClass:"icon-edit",attrs:{"slot":"toggle"},slot:"toggle"},[_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span')]),_vm._v(" "),_c('div',{staticClass:"tab-list",attrs:{"slot":"list"},slot:"list"},[_vm._l((_vm.dropdownMenu(tab)),function(option){return [_c('div',{key:option.title,staticClass:"item",on:{"click":option.action}},[_vm._v("\n                "+_vm._s(_vm.$t(option.title))+"\n              ")])]})],2)]):_vm._e()],1)])}),_vm._v(" "),(_vm.more)?_c('dropdown',{staticClass:"dropdown-more"},[_c('div',{staticClass:"icon-more",attrs:{"slot":"toggle"},slot:"toggle"},[_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span')]),_vm._v(" "),_c('div',{staticClass:"more-list",attrs:{"slot":"list"},slot:"list"},_vm._l((_vm.list.dropdown),function(tab,index){return _c('div',{key:index,staticClass:"item",class:{
            active: _vm.activeView && _vm.activeView.id == tab.id,
            opened: tab.menu
          },on:{"click":function($event){return _vm.select(tab)}}},[_c('div',{staticClass:"more__row"},[_c('div',{class:{
                'icon-globalView': tab.isGlobalView,
                'icon-empty':
                  !tab.isGlobalView && _vm.list.dropdown.some(function (t) { return t.isGlobalView; })
              }}),_vm._v(" "),_c('div',{staticClass:"name",attrs:{"title":_vm.getViewName(tab, _vm.$t)}},[_vm._v("\n              "+_vm._s(_vm._f("contraction")(_vm.$t(tab.name)))+"\n            ")])]),_vm._v(" "),(tab.changed && !tab.isGlobalView)?_c('div',{staticClass:"btn-save",class:{ empty: !tab.cams.length },attrs:{"title":_vm.$t('viewAction.undo')},on:{"click":function($event){$event.stopPropagation();return _vm.reset(tab)}}},[_c('span',{staticClass:"icon-reset"})]):_vm._e(),_vm._v(" "),(tab.changed)?_c('div',{staticClass:"btn-save",class:{ empty: !tab.cams.length },attrs:{"title":'btn.save'},on:{"click":function($event){$event.stopPropagation();tab.temp ? _vm.edit(tab) : _vm.save(tab)}}},[_c('span',{staticClass:"icon-save"})]):_vm._e(),_vm._v(" "),(_vm.dropdownMenu(tab, false).length)?_c('dropdown',{staticClass:"dropdown-menu",attrs:{"show":tab.menu}},[_c('div',{staticClass:"icon-edit",attrs:{"slot":"toggle"},slot:"toggle"},[_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span')]),_vm._v(" "),_c('div',{staticClass:"tab-list",attrs:{"slot":"list"},slot:"list"},_vm._l((_vm.dropdownMenu(tab, false)),function(option){return _c('div',{key:option.title,staticClass:"item",on:{"click":option.action}},[_vm._v("\n                "+_vm._s(_vm.$t(option.title))+"\n              ")])}),0)]):_vm._e()],1)}),0)]):_vm._e()],2),_vm._v(" "),_c('modal',{attrs:{"show":!!_vm.saving}},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t("viewCreateModal.title")))]),_vm._v(" "),_c('div',{staticClass:"fields"},[_c('div',{staticClass:"field"},[_c('input-text',{directives:[{name:"validate",rawName:"v-validate.initial",value:(_vm.form.name.validator),expression:"form.name.validator",modifiers:{"initial":true}}],ref:"form-name",attrs:{"value":_vm.form.name.value,"name":_vm.form.name.name,"type":"text","placeholder":_vm.$t(_vm.form.name.placeholder),"hasError":_vm.errors.has(_vm.form.name.name)},on:{"update:value":function($event){return _vm.$set(_vm.form.name, "value", $event)}}})],1)]),_vm._v(" "),_c('div',{staticClass:"btns padding"},[_c('div',{staticClass:"btn btn-secondary",on:{"click":function($event){_vm.form.name.value = null;
          _vm.saving = false;}}},[_c('span',[_vm._v(_vm._s(_vm.$t("btn.cancel")))])]),_vm._v(" "),_c('div',{staticClass:"btn",class:{ disabled: _vm.errors.count() },on:{"click":function($event){return _vm.save(_vm.saving)}}},[_c('span',[_vm._v(_vm._s(_vm.$t("btn.save")))])])])]),_vm._v(" "),_c('modal',{attrs:{"show":!!_vm.removing}},[_c('div',{staticClass:"title small"},[_vm._v(_vm._s(_vm.$t("viewDeleteModal.confirm")))]),_vm._v(" "),_c('div',{staticClass:"btns"},[_c('div',{staticClass:"btn btn-secondary",on:{"click":function($event){_vm.removing = false}}},[_c('span',[_vm._v(_vm._s(_vm.$t("btn.cancel")))])]),_vm._v(" "),_c('div',{staticClass:"btn btn-removing",on:{"click":function($event){return _vm.remove(_vm.removing)}}},[_c('span',[_vm._v(_vm._s(_vm.$t("viewDeleteModal.remove")))])])])]),_vm._v(" "),_c('modal',{staticClass:"forgot",attrs:{"show":_vm.limit}},[_c('div',{staticClass:"message"},[_vm._v(_vm._s(_vm.$t("tabs.createMoreThan10")))]),_vm._v(" "),_c('div',{staticClass:"btns padding single"},[_c('div',{staticClass:"btn",on:{"click":function($event){_vm.limit = false}}},[_c('span',[_vm._v(_vm._s(_vm.$t("btn.ok")))])])])]),_vm._v(" "),_c('modal',{staticClass:"saveVideo",attrs:{"show":_vm.isShowDownload}},[_c('timeInterval',{attrs:{"title-text-path":_vm.titleTextPath},on:{"save":_vm.onSaveVideo,"toggleExport":_vm.toggleExport}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 935:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 942:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_datepicker_js__ = __webpack_require__(462);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13dbade4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Datepicker_vue__ = __webpack_require__(944);
function injectStyle (ssrContext) {
  __webpack_require__(943)
}
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-13dbade4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_datepicker_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13dbade4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Datepicker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 943:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 944:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"date-picker"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"month-header"},[_c('div',{staticClass:"arrow arrow-left",on:{"click":_vm.prevMonth}},[_c('div',{staticClass:"icon"})]),_vm._v(" "),_c('span',{staticClass:"current-month"},[_vm._v(_vm._s(_vm._f("moment")(_vm.selectedMonth,'MMMM YYYY')))]),_vm._v(" "),_c('div',{staticClass:"arrow arrow-right",on:{"click":_vm.nextMonth}},[_c('div',{staticClass:"icon"})])]),_vm._v(" "),_c('div',{staticClass:"days-header"},_vm._l((_vm.days[_vm.lang]),function(day){return _c('div',{staticClass:"col"},[_vm._v(_vm._s(day))])}),0)]),_vm._v(" "),_c('div',{staticClass:"body"},_vm._l((_vm.month),function(week,i){return _c('div',{key:i,staticClass:"row row-body"},_vm._l((week),function(day,j){return _c('div',{key:'day' + j,staticClass:"col",class:{ disabled: day.disabled, selected: _vm.isSelected(day.date), 'other-month': day.otherMonth, today: day.today, 'limit-date': day.limitDate },on:{"click":function($event){return _vm.selectDate(day)}}},[_c('div',{staticClass:"date"},[_vm._v(_vm._s(day.num))])])}),0)}),0),_vm._v(" "),_c('div',{staticClass:"btns"},[_c('div',{staticClass:"btn-dropdown-list",on:{"click":function($event){return _vm.cancel()}}},[_c('span',[_vm._v(_vm._s(_vm.$t('btn.cancel')))])]),_vm._v(" "),_c('div',{staticClass:"btn-dropdown-list",on:{"click":function($event){return _vm.submit()}}},[_c('span',[_vm._v(_vm._s(_vm.$t('btn.ok')))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 945:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 946:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return playerEvents; });
var playerEvents = {
  'CHANGE_MONITOR_MODE': 'changeMonitorMode',
  'SHOW_MONITOR': 'show_monitor',
  'INIT': 'init',
  'GET_CAMERAS_DATA': 'cameras_data',
  'START_EXPORT': 'arch_cnv_export',
  'STOP_EXPORT': 'arch_cnv_cancel',
  'ALERTS': 'alerts',
  'ON_MAP': 'onmap',
  "SET_PLAYER_MODE": 'setPlayerMode',
  'CLOSE_CAMERA': 'closeCamera',
  "ADD_CAMERA": 'camera_drop',
  'LONG_POOL_UPLOAD': 'arch_cnv_poll',
  'PLAYER_DOUBLE_CLICK': 'camera_dbl_click',
  'EXPORT_CONTROL': 'arch_cnv_export_show_control'
};

/***/ }),

/***/ 947:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"player",class:{ loading: _vm.loading }},[_c('iframe',{ref:"player",attrs:{"frameborder":"0","allowfullscreen":"allowfullscreen","name":"webview_player"}}),_vm._v(" "),(_vm.loading)?_c('loader'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 948:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alarms"},[_c('sidebar',{attrs:{"type":"left","open":_vm.filters.open},on:{"update:open":function($event){return _vm.$set(_vm.filters, "open", $event)}}},[_c('div',{attrs:{"slot":"icon"},slot:"icon"},[_c('img',{attrs:{"width":"15","src":"/static/images/ic-filter.svg"}})]),_vm._v(" "),_c('div',{staticClass:"slot-content",attrs:{"slot":"content"},slot:"content"},[_c('div',{staticClass:"list-wrap"},[_c('div',{staticClass:"filters"},[(_vm.views.length)?_c('div',{ref:"views-filter-group",staticClass:"filter-group filter-group--views",class:{ opened: _vm.groups.views.open }},[_c('div',{staticClass:"sidebar-header"},[_c('div',{staticClass:"toggle",on:{"click":function($event){return _vm.toggleGroup('views')}}},[_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.$t(_vm.groups.views.name)))]),_vm._v(" "),_c('div',{staticClass:"icon-arrow"})]),_vm._v(" "),_c('div',{staticClass:"sidebar-header__content"},[(_vm.groups.views.open)?_c('search',{attrs:{"placeholder":_vm.$t(_vm.groups.views.placeholder),"clear":""},model:{value:(_vm.groups.views.search),callback:function ($$v) {_vm.$set(_vm.groups.views, "search", $$v)},expression:"groups.views.search"}}):_vm._e(),_vm._v(" "),(_vm.groups.views.open)?_c('button',{staticClass:"alarms__reset",attrs:{"title":_vm.$t('btn.resetFilters')},on:{"click":function($event){$event.preventDefault();return _vm.resetRouterQuery('view')}}}):_vm._e()],1)]),_vm._v(" "),_c('VuePerfectScrollbar',{ref:"viewsScroll",staticClass:"scrollbar"},[(_vm.groups.views.open)?_c('div',{staticClass:"list"},_vm._l((_vm.filteredItems(_vm.views, _vm.groups.views.search)),function(view){return _c('a',{key:'alarmview' + view.id,staticClass:"filter views",class:{ active: _vm.isItemSelected('view', view) },attrs:{"replace":""},on:{"click":function($event){return _vm.addedRouterQuery('view', view)}}},[_c('div',{staticClass:"name",attrs:{"title":_vm.getViewName(view, _vm.$t)}},[_vm._v("\n                    "+_vm._s(_vm._f("contraction")(_vm.$t(view.name)))+"\n                  ")])])}),0):_vm._e()])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"filter-group",class:{ opened: _vm.groups.cams.open },style:({ maxHeight: ("calc(100% - " + _vm.viewsFilterHeight + "px)") })},[_c('div',{staticClass:"sidebar-header"},[_c('div',{staticClass:"toggle",on:{"click":function($event){return _vm.toggleGroup('cams')}}},[_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.$t(_vm.groups.cams.name)))]),_vm._v(" "),_c('div',{staticClass:"icon-arrow"})]),_vm._v(" "),_c('div',{staticClass:"sidebar-header__content"},[(_vm.groups.cams.open)?_c('search',{staticStyle:{"width":"100%"},attrs:{"placeholder":_vm.$t(_vm.groups.cams.placeholder),"clear":""},model:{value:(_vm.groups.cams.search),callback:function ($$v) {_vm.$set(_vm.groups.cams, "search", $$v)},expression:"groups.cams.search"}}):_vm._e(),_vm._v(" "),(_vm.groups.cams.open)?_c('button',{staticClass:"alarms__reset",attrs:{"title":_vm.$t('btn.resetFilters')},on:{"click":function($event){$event.preventDefault();return _vm.resetRouterQuery('cams')}}}):_vm._e()],1)]),_vm._v(" "),(_vm.groups.cams.open)?_c('VuePerfectScrollbar',{ref:"camsScroll",staticClass:"scrollbar list"},[(_vm.groups.cams.open)?_c('div',{staticClass:"list"},[_c('cams-list',{attrs:{"hovered":"","cams":_vm.filteredItems(_vm.cams, _vm.groups.cams.search),"is-cam-selected":function (cam) { return _vm.isItemSelected('cams', cam); }},on:{"update":_vm.updateScroll,"cam-click":function (cam) { return _vm.addedRouterQuery('cams', cam); }}})],1):_vm._e()]):_vm._e()],1)])])])]),_vm._v(" "),_c('div',{staticClass:"alarms-list-wrapper"},[_c('div',{staticClass:"alarms-list"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"header-left"},[_c('div',{staticClass:"icon-back",on:{"click":_vm.goBack}}),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t("global.alarms")))])]),_vm._v(" "),_c('div',{staticClass:"header-right",class:{ loading: _vm.loading }},[(_vm.dateStart)?_c('div',{staticClass:"alarms__date-result"},[_c('span',[_vm._v(_vm._s(_vm.dateStart)+_vm._s(_vm.dateStop && _vm.dateStart !== _vm.dateStop ? " - " : ""))]),_vm._v(" "),(_vm.dateStop && _vm.dateStart !== _vm.dateStop)?_c('span',[_vm._v(_vm._s(_vm.dateStop))]):_vm._e()]):_vm._e(),_vm._v(" "),_c('dropdown',{attrs:{"open":_vm.datepicker.open},on:{"update:open":function($event){return _vm.$set(_vm.datepicker, "open", $event)}}},[_c('div',{staticClass:"datepicker",attrs:{"slot":"toggle"},slot:"toggle"},[_c('img',{attrs:{"src":"/static/images/ic-date.svg"}})]),_vm._v(" "),_c('div',{staticClass:"datepicker-list",attrs:{"slot":"list"},on:{"click":function($event){$event.stopPropagation();}},slot:"list"},[_c('datepicker',{attrs:{"dateStart":_vm.datepicker.start,"dateEnd":_vm.datepicker.stop,"lang":_vm.$store.state.i18n.locale},on:{"select":_vm.selectDate,"cancel":function($event){_vm.datepicker.open = false}}})],1)])],1)]),_vm._v(" "),_c('div',{staticClass:"list-wrap",class:{ empty: _vm.loading || _vm.isEmpty }},[(_vm.loading)?_c('loader',{attrs:{"type":"dark"}}):_vm._e(),_vm._v(" "),(!_vm.isEmpty && !_vm.loading)?_c('VuePerfectScrollbar',{ref:"alarmsScroll",staticClass:"scrollbar",attrs:{"settings":{ minScrollbarLength: 50 }}},[_c('div',{staticClass:"s-content"},[_vm._l((_vm.alarms),function(group,day){return _c('div',{key:day,staticClass:"group"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm._f("moment")(day,"DD MMMM YYYY")))]),_vm._v(" "),_c('div',{staticClass:"day-list"},_vm._l((group),function(alarm,k){return _c('div',{key:'alarm' + k,staticClass:"alarm",class:{
                    active: _vm.activeAlarm && _vm.activeAlarm.id === alarm.id
                  },on:{"click":function($event){return _vm.toggleAlarm(alarm)}}},[_c('div',{staticClass:"info"},[_c('div',{staticClass:"name"},[_vm._v(_vm._s(alarm.name))]),_vm._v(" "),_c('div',{staticClass:"date"},[_vm._v("\n                      "+_vm._s(_vm._f("moment")(alarm.timestamp,"DD MMM YYYY HH:mm:ss"))+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"comment"},[_vm._v(_vm._s(_vm.getComment(alarm)))])])}),0)])}),_vm._v(" "),(_vm.showLoadMore)?_c('div',{staticClass:"alarms-module__loadMore btn-dropdown-list",on:{"click":function($event){!_vm.pagination.loading ? _vm.getAlarms() : ''}}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.pagination.loading),expression:"!pagination.loading"}]},[_vm._v("\n                "+_vm._s(_vm.$t("alarmsPage.loadMore"))+"\n              ")]),_vm._v(" "),_c('loader',{directives:[{name:"show",rawName:"v-show",value:(_vm.pagination.loading),expression:"pagination.loading"}],attrs:{"type":"small"}})],1):_vm._e()],2)]):_vm._e(),_vm._v(" "),(_vm.isEmpty && !_vm.loading)?_c('div',{staticClass:"empty"},[_c('div',{staticClass:"icon-no-alarms"}),_vm._v(" "),_c('div',{staticClass:"caption"},[_vm._v(_vm._s(_vm.$t("alarmsPage.noAlarmsPeriod")))])]):_vm._e()],1)])]),_vm._v(" "),(!!_vm.activeAlarm)?_c('player',{attrs:{"data":_vm.playerData}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 949:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_userInfo_js__ = __webpack_require__(466);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aad52784_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserInfo_vue__ = __webpack_require__(954);
function injectStyle (ssrContext) {
  __webpack_require__(950)
}
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-aad52784"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_userInfo_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aad52784_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserInfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 950:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 951:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_modalPage_js__ = __webpack_require__(467);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ecd7ae82_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalPage_vue__ = __webpack_require__(953);
function injectStyle (ssrContext) {
  __webpack_require__(952)
}
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_modalPage_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ecd7ae82_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 952:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 953:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"modal-page"},[_c('div',[_c('div',{staticClass:"header"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('router-link',{staticClass:"close",attrs:{"to":{ query: null },"replace":""}})],1),_vm._v(" "),_c('div',{staticClass:"content"},[(! _vm.loaded)?_c('loader'):_vm._e(),_vm._v(" "),(_vm.loaded)?_c('VuePerfectScrollbar',{ref:"scroll",staticClass:"scrollbar"},[_c('div',{staticClass:"s-content",domProps:{"innerHTML":_vm._s(_vm.content)}})]):_vm._e()],1)])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 954:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-info"},[_c('dropdown',{staticClass:"user-info__dropdown",attrs:{"type":"left"}},[_c('div',{staticClass:"user-info__header",attrs:{"slot":"toggle"},slot:"toggle"},[_c('div',{staticClass:"user-info__logo"},[_c('img',{attrs:{"src":"/static/images/logo-min.svg"}})]),_vm._v(" "),_c('div',{staticClass:"user-info__profile"},[_c('div',{staticClass:"user-info__profile-name",attrs:{"title":_vm.loginText()}},[_vm._v("\n          "+_vm._s(_vm.title)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"user-info__icons icon-arrow"})])]),_vm._v(" "),_c('div',{staticClass:"user-info__dropdown-list",attrs:{"slot":"list"},slot:"list"},[_c('div',{staticClass:"user-info__dropdown-item",on:{"click":function($event){return _vm.edit()}}},[_c('div',[_vm._v(_vm._s(_vm.siteActionName))]),_vm._v(" "),_c('div',{staticClass:"user-info__icons icon-edit"})]),_vm._v(" "),_c('div',{staticClass:"user-info__dropdown-item",on:{"click":function($event){_vm.lang.modal = true}}},[_c('div',[_vm._v(_vm._s(_vm.$t("profileMenu.changeLanguage")))]),_vm._v(" "),_c('div',{staticClass:"user-info__icons icon-lang",class:_vm.lang.active})]),_vm._v(" "),(_vm.$store.state.user)?_c('div',{staticClass:"user-info__dropdown-item",on:{"click":function($event){return _vm.logout()}}},[_c('div',[_vm._v(_vm._s(_vm.$t("profileMenu.logout")))]),_vm._v(" "),_c('div',{staticClass:"user-info__icons icon-logout"})]):_vm._e()])]),_vm._v(" "),_c('modal',{attrs:{"show":_vm.editing}},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.modalTitle))]),_vm._v(" "),_c('div',{staticClass:"fields"},[_c('div',{staticClass:"field"},[_c('input-text',{directives:[{name:"validate",rawName:"v-validate.initial",value:(_vm.form.site.validator),expression:"form.site.validator",modifiers:{"initial":true}}],ref:"form-object",attrs:{"value":_vm.form.site.value,"name":_vm.form.site.name,"type":"text","placeholder":_vm.$t(_vm.form.site.placeholder),"hasError":_vm.errors.has(_vm.form.site.name)},on:{"update:value":function($event){return _vm.$set(_vm.form.site, "value", $event)}}})],1)]),_vm._v(" "),_c('div',{staticClass:"btns padding"},[_c('div',{staticClass:"btn btn-secondary",on:{"click":function($event){_vm.form.site.value = null;
          _vm.editing = false;}}},[_c('span',[_vm._v(_vm._s(_vm.$t("btn.cancel")))])]),_vm._v(" "),_c('div',{staticClass:"btn",class:{ disabled: _vm.errors.count() },on:{"click":function($event){return _vm.save()}}},[_c('span',[_vm._v(_vm._s(_vm.$t("btn.save")))])])])]),_vm._v(" "),_c('modal',{staticClass:"modal-lang",attrs:{"show":_vm.lang.modal}},[_c('div',{staticClass:"title small"},[_vm._v(_vm._s(_vm.$t("changeLanguageModal.title")))]),_vm._v(" "),_c('div',{staticClass:"fields"},_vm._l((_vm.lang.list),function(l,i){return _c('div',{key:'user-info-field-' + i,staticClass:"field"},[_c('div',{staticClass:"lang-item",on:{"click":function($event){_vm.lang.active = l.name}}},[_c('div',{staticClass:"icon-check",class:{ active: l.name === _vm.lang.active }}),_vm._v(" "),_c('div',{staticClass:"name"},[_vm._v(_vm._s(l.title))]),_vm._v(" "),_c('div',{staticClass:"icon-lang",class:l.name})])])}),0),_vm._v(" "),_c('div',{staticClass:"btns padding"},[_c('div',{staticClass:"btn",class:{ disabled: _vm.errors.count() },on:{"click":function($event){return _vm.changeLang()}}},[_c('span',[_vm._v(_vm._s(_vm.$t('btn.ok')))])])])]),_vm._v(" "),_vm._l((_vm.links),function(link){return _c('modal-page',{key:'modal' + link.alias,attrs:{"title":_vm.$t(link.name),"name":link.alias}})})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 955:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard"},[_c('div',{staticClass:"header"},[_c('user-info'),_vm._v(" "),_c('dropdown',{staticClass:"grid-dropdown",class:{ disabled: _vm.disableGrid },attrs:{"type":"left","disabled":_vm.disableGrid,"title":_vm.gridTitle}},[_c('div',{staticClass:"icon-grid",style:({
          'background-image': ("url(/static/images/grid/" + (_vm.activeGrid.icon) + ".svg)")
        }),attrs:{"slot":"toggle"},slot:"toggle"}),_vm._v(" "),_c('div',{staticClass:"grid-list",attrs:{"slot":"list"},slot:"list"},_vm._l((_vm.grids),function(item){return _c('div',{key:item.icon,staticClass:"item",class:{ active: _vm.$store.state.grid == item.value },on:{"click":function($event){return _vm.setGrid(item)}}},[_c('img',{attrs:{"src":'/static/images/grid/' + item.icon + '.svg'}})])}),0)]),_vm._v(" "),_c('div',{staticClass:"views"},[_c('view-tabs')],1),_vm._v(" "),_c('div',{staticClass:"controls"},[_c('dropdown',{staticClass:"stream-role-dropdown"},[_c('div',{staticClass:"btn-control",attrs:{"slot":"toggle"},slot:"toggle"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t(_vm.videoStreams.find(function (s) { return s.value === _vm.stream; }).name)))])]),_vm._v(" "),_c('div',{staticClass:"stream-role-list",attrs:{"slot":"list"},slot:"list"},_vm._l((_vm.videoStreams),function(s,k){return _c('div',{key:k,staticClass:"stream-item",class:{
              selected: s.value === _vm.stream
            },on:{"click":function($event){return _vm.onSelectStream(s)}}},[_vm._v("\n            "+_vm._s(_vm.$t(s.name))+"\n          ")])}),0)]),_vm._v(" "),_vm._l((_vm.modes),function(mode,k){return _c('div',{key:k,staticClass:"btn-control",class:[mode.alias, { active: _vm.$store.state.mode == mode.value }],on:{"click":function($event){return _vm.setMode(mode.value)}}},[_c('span',{staticClass:"icon",class:'icon-' + mode.alias}),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t(mode.name)))])])}),_vm._v(" "),_c('dropdown',{staticClass:"alarms-dropdown",on:{"open":_vm.openAlarms}},[_c('div',{staticClass:"btn-control",class:{ active: _vm.$route.name === 'alarms' },attrs:{"slot":"toggle"},slot:"toggle"},[_c('span',{staticClass:"icon icon-alarms"}),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t("global.alarms")))])]),_vm._v(" "),_c('div',{staticClass:"alarms-list",attrs:{"slot":"list"},slot:"list"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t("global.alarms")))]),_vm._v(" "),(_vm.loading.alarms)?_c('loader',{attrs:{"type":"small"}}):_vm._e(),_vm._v(" "),(!_vm.loading.alarms)?_c('div',{staticClass:"list-wrap"},_vm._l((_vm.latestAlarms),function(alarm,k){return _c('div',{key:'alarm' + k,staticClass:"alarm-item",on:{"click":function($event){return _vm.goToAlarm(alarm)}}},[_c('div',{staticClass:"alarm-info"},[_c('div',{staticClass:"name"},[_vm._v(_vm._s(alarm.name))]),_vm._v(" "),_c('div',{staticClass:"date"},[_vm._v("\n                  "+_vm._s(_vm._f("moment")(alarm.timestamp,"DD MMM YYYY HH:mm:ss"))+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"description"},[_vm._v(_vm._s(_vm.getAlarmComment(alarm)))])])}),0):_vm._e(),_vm._v(" "),(!_vm.loading.alarms)?_c('div',{staticClass:"btns"},[_c('div',{staticClass:"btn-dropdown-list",on:{"click":_vm.getAllAlarms}},[_c('span',[_vm._v(_vm._s(_vm.$t("alarmsModal.viewAll")))])])]):_vm._e()],1)])],2)],1),_vm._v(" "),_c('div',{staticClass:"container",attrs:{"id":"container"}},[_c('sidebar',{attrs:{"type":"left","open":_vm.sidebars.cams.open,"show":_vm.sidebars.cams.show},on:{"update:open":function($event){return _vm.$set(_vm.sidebars.cams, "open", $event)},"open":function($event){return _vm.updateScroll(_vm.$refs.camsScroll)}}},[_c('div',{attrs:{"slot":"icon"},slot:"icon"},[_c('img',{attrs:{"src":"/static/images/ic-cam-default.svg"}})]),_vm._v(" "),_c('div',{staticClass:"slot-content",attrs:{"slot":"content"},slot:"content"},[_c('div',{staticClass:"sidebar-header"},[_c('div',{staticClass:"cams-mode"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t("global.cameras")))])]),_vm._v(" "),_c('search',{attrs:{"placeholder":_vm.$t('placeHolders.findCameras')},model:{value:(_vm.sidebars.cams.search),callback:function ($$v) {_vm.$set(_vm.sidebars.cams, "search", $$v)},expression:"sidebars.cams.search"}})],1),_vm._v(" "),_c('div',{staticClass:"list-wrap cams-wrap"},[_c('VuePerfectScrollbar',{ref:"camsScroll",staticClass:"scrollbar"},[_c('div',{staticClass:"s-content"},[_c('cams-list',{attrs:{"cams":_vm.cams,"preview":_vm.sidebars.cams.modes.active == 'preview',"draggable":_vm.activeView != null && !_vm.activeView.isGlobalView,"is-cam-selected":_vm.isCamSelected},on:{"update":function($event){return _vm.updateScroll(_vm.$refs.camsScroll)}}})],1)])],1)])]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('router-view')],1),_vm._v(" "),_c('sidebar',{attrs:{"type":"right","open":_vm.sidebars.maps.open,"show":_vm.sidebars.cams.show},on:{"update:open":function($event){return _vm.$set(_vm.sidebars.maps, "open", $event)},"open":function($event){return _vm.updateScroll(_vm.$refs.mapsScroll)}}},[_c('div',{attrs:{"slot":"icon"},slot:"icon"},[_c('img',{attrs:{"src":"/static/images/ic-map-block.svg"}})]),_vm._v(" "),_c('div',{staticClass:"slot-content",attrs:{"slot":"content"},slot:"content"},[_c('div',{staticClass:"sidebar-header"},[_c('div',{staticClass:"maps-mode"},[_c('div',{staticClass:"modes"},_vm._l((_vm.sidebars.maps.modes.list),function(mode){return _c('div',{key:mode.value,staticClass:"item",class:[
                  mode.value,
                  { active: _vm.sidebars.maps.modes.active == mode.value }
                ],on:{"click":function($event){return _vm.changeMapMode(mode.value)}}},[_c('div',{staticClass:"icon"}),_vm._v(" "),_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.$t(mode.name)))])])}),0)]),_vm._v(" "),_c('search-map-level',{attrs:{"maps":_vm.maps,"route-name":_vm.sidebars.maps.modes.active}})],1),_vm._v(" "),_c('div',{staticClass:"list-wrap map-wrap"},[_c('div',{staticClass:"list-block"},[_c('map-list',{attrs:{"maps":_vm.maps,"route-name":_vm.sidebars.maps.modes.active,"search":_vm.sidebars.maps.search}})],1),_vm._v(" "),_c('div',{staticClass:"list-block"},[_c('div',{staticClass:"list-block__title"},[_vm._v(_vm._s(_vm.$t("global.alarms")))]),_vm._v(" "),_c('map-list',{attrs:{"maps":_vm.alarmMaps,"route-name":_vm.sidebars.maps.modes.active}})],1)])])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 956:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_auth_js__ = __webpack_require__(468);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aad0069a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Auth_vue__ = __webpack_require__(980);
function injectStyle (ssrContext) {
  __webpack_require__(957)
}
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-aad0069a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_auth_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aad0069a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Auth_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 957:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 958:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = ({
    login: '^[a-zA-Z0-9\s(\)\"\/\.\-]*$',
    password: '^[a-zA-Z0-9\s(\)\"\/\.\-]*$'
});

/***/ }),

/***/ 959:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_dropdownSearch_js__ = __webpack_require__(469);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_237f4f81_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DropdownSearch_vue__ = __webpack_require__(979);
function injectStyle (ssrContext) {
  __webpack_require__(960)
}
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-237f4f81"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_dropdownSearch_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_237f4f81_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DropdownSearch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 960:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 965:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 967:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 979:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dropdown',{ref:"dropdown",staticClass:"dropdown-search",class:[_vm.type, { empty: _vm.list.length === 0, 'has-scroll': _vm.scroll }],attrs:{"type":"full","container":_vm.container,"width-container":""},on:{"open":_vm.openDropdown}},[_c('div',{staticClass:"current",attrs:{"slot":"toggle"},slot:"toggle"},[_c('input-text',{staticClass:"dropdown-search__input",attrs:{"name":_vm.placeholder,"placeholder":_vm.placeholder},on:{"input":_vm.openDropDownSearch},nativeOn:{"click":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"selft",undefined,$event.key,undefined)){ return null; }$event.stopPropagation();return _vm.openDropDownSearch.apply(null, arguments)}},model:{value:(_vm.inputedText),callback:function ($$v) {_vm.inputedText=$$v},expression:"inputedText"}}),_vm._v(" "),_c('div',{staticClass:"icon"})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.filteredList.length),expression:"filteredList.length"}],ref:"options",staticClass:"options",style:(_vm.dropdownStyle),attrs:{"slot":"list"},slot:"list"},[_c('VuePerfectScrollbar',{ref:"scroll",staticClass:"scrollbar",attrs:{"settings":{ minScrollbarLength: 30 }}},[_c('div',{ref:"wrap",staticClass:"s-content"},_vm._l((_vm.filteredList),function(option,k){return _c('div',{key:k,staticClass:"option",class:{ first: k == 0},attrs:{"title":_vm.$t(_vm.getOptionName(option))},on:{"click":function($event){return _vm.select(option)}}},[_vm._v("\n          "+_vm._s(_vm.$t(_vm.getOptionName(option)))+"\n        ")])}),0)])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 980:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth"},[_c('div',{staticClass:"wrapper"},[_vm._m(0),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.login.apply(null, arguments)}}},[(_vm.lang.active)?_c('dropdown',{staticClass:"lang-dropdown"},[_c('div',{staticClass:"lang-toggle",attrs:{"slot":"toggle"},slot:"toggle"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.lang.active.title))]),_vm._v(" "),_c('span',{staticClass:"icon-lang",class:_vm.lang.active.name}),_vm._v(" "),_c('span',{staticClass:"icon-arrow"})]),_vm._v(" "),_c('div',{staticClass:"lang-list",attrs:{"slot":"list"},slot:"list"},_vm._l((_vm.lang.list),function(l,i){return _c('div',{key:'lang-list-item-' + i,staticClass:"item",on:{"click":function($event){_vm.lang.active = l; _vm.localization.set(l.name)}}},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(l.title))]),_vm._v(" "),_c('div',{staticClass:"icon-lang",class:l.name})])}),0)]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:( ! _vm.loading),expression:" ! loading"}],staticClass:"auth-form"},[_c('div',{staticClass:"fields"},[_vm._l((_vm.form),function(field,key){return [(! field.mode || field.mode == _vm.mode)?_c('div',{key:field.name,staticClass:"field",class:'field-' + key},[(field.control == 'input-text')?_c('input-text',{directives:[{name:"validate",rawName:"v-validate.initial",value:(field.validator),expression:"field.validator",modifiers:{"initial":true}}],key:key,attrs:{"value":field.value,"data-vv-as":_vm.$t(field.placeholder),"name":key,"type":field.type ? field.type : 'text',"placeholder":_vm.$t(field.placeholder),"hasError":_vm.errors.has(key) && _vm.fields[key].dirty,"disabled":field.disabled},on:{"update:value":function($event){return _vm.$set(field, "value", $event)}}}):(field.control === 'search-select')?_c('drop-down-search',{directives:[{name:"validate",rawName:"v-validate.initial",value:(field.validator),expression:"field.validator",modifiers:{"initial":true}}],attrs:{"value":field.value,"name":key,"data-vv-as":_vm.$t(field.placeholder),"type":field.type ? field.type : 'text',"placeholder":_vm.$t(field.placeholder),"hasError":_vm.errors.has(key) && _vm.fields[key].dirty,"disabled":field.disabled,"list":_vm.siteHistory},on:{"update:value":function($event){return _vm.$set(field, "value", $event)}}}):_vm._e()],1):_vm._e()]})],2),_vm._v(" "),(_vm.errors.count())?_c('div',{staticClass:"errors"},[_vm._l((_vm.fields),function(field,key){return [(_vm.errors.has(key) && field.dirty)?_c('div',{key:'error-' + key,staticClass:"error"},[_vm._v("\n              "+_vm._s(_vm.$t(_vm.errors.first(key)))+"\n            ")]):_vm._e()]})],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"links"},[_c('div',{staticClass:"link",on:{"click":function($event){_vm.forgot.show = true}}},[_vm._v(_vm._s(_vm.$t('authPage.forgotPassword')))])]),_vm._v(" "),_c('div',{staticClass:"btns"},[_c('button',{staticClass:"btn",class:{ disabled: _vm.errors.count() },attrs:{"type":"submit","tabindex":"0"}},[_c('span',[_vm._v(_vm._s(_vm.$t('btn.enter')))])])])])],1),_vm._v(" "),(_vm.loading)?_c('loader'):_vm._e()],1),_vm._v(" "),_c('modal',{staticClass:"forgot",attrs:{"show":_vm.forgot.show}},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('authPage.forgotPassword')))]),_vm._v(" "),_c('div',{staticClass:"message"},[_vm._v(_vm._s(_vm.$t('authPage.forgotPasswordMessage')))]),_vm._v(" "),_c('div',{staticClass:"btns padding single"},[_c('div',{staticClass:"btn",on:{"click":function($event){_vm.forgot.show = false}}},[_c('span',[_vm._v(_vm._s(_vm.$t('btn.ok')))])])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":"/static/images/logo.svg"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 981:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cams_js__ = __webpack_require__(481);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ea2bec3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cams_vue__ = __webpack_require__(983);
function injectStyle (ssrContext) {
  __webpack_require__(982)
}
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1ea2bec3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cams_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ea2bec3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cams_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 982:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 983:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('drop',{staticClass:"cams",class:{ empty: !_vm.cams.length },on:{"drop":_vm.add}},[(_vm.cams.length)?_c('div',{staticClass:"wrap"},[_c('player',{attrs:{"data":_vm.playerData}})],1):_vm._e(),_vm._v(" "),(!_vm.cams.length && !_vm.isMap)?_c('div',{staticClass:"empty"},[_c('div',{staticClass:"icon-drop-cameras"}),_vm._v(" "),_c('div',{staticClass:"caption"},[_vm._v(_vm._s(_vm.$t("layout.backgroundDropText")))])]):_vm._e(),_vm._v(" "),(!_vm.cams.length && _vm.isMap)?_c('div',{staticClass:"empty"},[_c('div',{staticClass:"icon-no-cameras"}),_vm._v(" "),_c('div',{staticClass:"caption"},[_vm._v(_vm._s(_vm.$t("camOnMap.noCameras")))])]):_vm._e(),_vm._v(" "),_c('modal',{staticClass:"forgot",attrs:{"show":_vm.info.show}},[_c('div',{staticClass:"message"},[_vm._v(_vm._s(_vm.$t("layout.maximumCamerasError")))]),_vm._v(" "),_c('div',{staticClass:"btns padding single"},[_c('div',{staticClass:"btn",on:{"click":function($event){_vm.info.show = false}}},[_c('span',[_vm._v(_vm._s(_vm.$t('btn.ok')))])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 984:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_map_js__ = __webpack_require__(482);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5615d3cc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Map_vue__ = __webpack_require__(989);
function injectStyle (ssrContext) {
  __webpack_require__(985)
}
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5615d3cc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_map_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5615d3cc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Map_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 985:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 986:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_map_object_js__ = __webpack_require__(483);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e97a4e76_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_map_object_vue__ = __webpack_require__(988);
function injectStyle (ssrContext) {
  __webpack_require__(987)
}
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e97a4e76"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_map_object_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e97a4e76_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_map_object_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 987:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 988:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"map-object",staticClass:"map-object",style:({
    top: _vm.styleWidthDistance.top + 'px',
    left: _vm.styleWidthDistance.left + 'px'
  })},[_c('dropdown',{attrs:{"type":"left"},on:{"update:open":_vm.onDropdownOpen}},[_c('template',{slot:"toggle"},[(_vm.type === 'cam')?_c('icon-cam',{attrs:{"isHighlight":_vm.isHighlight,"isAlarm":!!_vm.alarmCams.find(function (aCam) { return aCam.id === _vm.cam.id; }) && _vm.isIndicateAlarms,"cam":_vm.cam,"width":_vm.styleWidthDistance.width,"scale":_vm.scale}}):(_vm.type === 'object')?_c('div',{staticClass:"object-icon",style:({
          width: _vm.styleWidthDistance.width + 'px',
          height: _vm.styleWidthDistance.width + 'px',
          'background-image': ("url('/static/images/acs/" + (_vm.mapObject.status) + ".png')")
        })}):_vm._e(),_vm._v(" "),(_vm.styleWidthDistance.width > _vm.limitWidthIcon)?_c('div',{staticClass:"map-object__name",style:([_vm.objectFontSize, { color: _vm.map.color }])},[(_vm.type === 'cam')?[_vm._v("\n          "+_vm._s(_vm._f("contraction")(_vm.cam.name))+"\n        ")]:(_vm.dataObject)?[_vm._v("\n          "+_vm._s(_vm._f("contraction")(_vm.dataObject.name))+"\n        ")]:_vm._e()],2):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"list",attrs:{"slot":"list"},slot:"list"},[_c('div',{staticClass:"preview",class:{
          loaded: _vm.isDataLoaded
        }},[(_vm.type === 'cam' ? _vm.loading : !_vm.isDataLoaded)?_c('loader',{attrs:{"type":"small"}}):_vm._e(),_vm._v(" "),(_vm.type === 'cam' && (!_vm.image || !_vm.isHaveImage))?_c('div',{staticClass:"preview__status-disabled"},[_c('div',{staticClass:"preview__icon-no-signal"}),_vm._v(" "),_c('div',{staticClass:"preview__error"},[_vm._v(_vm._s(_vm.$t("camOnMap.noSignal")))])]):_vm._e(),_vm._v(" "),(_vm.type === 'cam' && _vm.image)?_c('div',{staticClass:"preview__img",style:({ 'background-image': 'url(' + _vm.image + ')' })}):_vm._e(),_vm._v(" "),(
            _vm.isDataLoaded && !_vm.isHaveImage && _vm.dataObject && !_vm.dataObject.cameras
          )?_c('div',{staticClass:"preview__btn-link preview__btn-link--no-clickable"},[_vm._v("\n          "+_vm._s(_vm.$t("camOnMap.noCameras"))+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.isViewCamera || _vm.isRefresh)?_c('div',{staticClass:"preview-actions"},[(_vm.isViewCamera)?_c('button',{staticClass:"preview-actions__action",attrs:{"title":_vm.$t('camOnMap.viewCamera')},on:{"click":_vm.viewCam}},[_c('div',{staticClass:"preview__icon-view"})]):_vm._e(),_vm._v(" "),(_vm.isRefresh)?_c('button',{staticClass:"preview-actions__action",attrs:{"title":_vm.$t('camOnMap.refreshFrame')},on:{"click":function($event){$event.stopPropagation();return _vm.onDropdownOpen.apply(null, arguments)}}},[_c('div',{staticClass:"preview__icon-reload"})]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.type === 'cam')?_c('cam',{staticClass:"preview__cam",attrs:{"cam":_vm.cam,"in-map":""}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"map-info"},[(_vm.type === 'cam')?_c('div',{staticClass:"map-info__name",attrs:{"title":_vm.cam.name}},[_vm._v("\n          "+_vm._s(_vm._f("contraction")(_vm.cam.name))+"\n        ")]):(_vm.dataObject)?_c('div',{staticClass:"map-info__name",attrs:{"title":_vm.dataObject.name}},[_vm._v("\n          "+_vm._s(_vm._f("contraction")(_vm.dataObject.name))+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.type === 'cam')?[(_vm.cam.views && _vm.cam.views.length)?_c('div',{staticClass:"map-info__group"},[_c('div',{staticClass:"map-info__label"},[_vm._v("\n              "+_vm._s(_vm.$t("camOnMap.viewsWithCamera"))+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"map-info__values"},_vm._l((_vm.cam.views),function(view){return _c('router-link',{key:'view' + view.id,staticClass:"map-info__value",attrs:{"title":_vm.getViewName(view, _vm.$t),"to":{
                  name: 'views',
                  params: { viewId: view.id }
                }}},[_vm._v("\n                "+_vm._s(_vm._f("contraction")(_vm.$t(view.name)))+"\n              ")])}),1)]):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.dataObject && _vm.dataObject.cameras)?_c('div',{staticClass:"map-info__group"},[_c('div',{staticClass:"map-info__label"},[_vm._v(_vm._s(_vm.$t("camOnMap.cameraId")))]),_vm._v(" "),_c('div',{staticClass:"map-info__value"},[_vm._v(_vm._s(_vm.dataObject.cameras))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"map-info__group"},[_c('div',{staticClass:"map-info__label"},[_vm._v("\n            "+_vm._s(_vm.$t("camOnMap.locationOnMap"))+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"map-info__value"},[_vm._v("\n            "+_vm._s(_vm.map.group.name)+" - "+_vm._s(_vm.map.name)+"\n          ")])]),_vm._v(" "),(_vm.imageDate)?_c('div',{staticClass:"map-info__group"},[_c('div',{staticClass:"map-info__label"},[_vm._v("\n            "+_vm._s(_vm.$t("camOnMap.frameDateAndTime"))+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"map-info__value"},[_vm._v(_vm._s(_vm.imageDate))])]):_vm._e()],2)])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 989:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.map)?_c('div',{ref:"map",staticClass:"map"},[_c('div',{staticClass:"scheme"},[_c('div',{staticClass:"img",class:{ dragging: _vm.dragging },style:({
        transform:
          'translate3d(' + _vm.translate.x + 'px,' + _vm.translate.y + 'px,0)',
        width:
          _vm.map.image || _vm.showGridMap ? _vm.map.width * _vm.zoom.active + 'px' : '0px',
        height:
          _vm.map.image || _vm.showGridMap ? _vm.map.height * _vm.zoom.active + 'px' : '0px'
      }),on:{"mousedown":_vm.mousedown,"mouseup":_vm.mouseup,"mousewheel":_vm.mouseWheel}},[(_vm.map.image)?_c('img',{ref:"scheme",attrs:{"src":_vm.map.image}}):_vm._e(),_vm._v(" "),(!_vm.map.image && _vm.showGridMap)?_c('div',{style:({
          width: _vm.map.width * _vm.zoom.active + 'px',
          height: _vm.map.height * _vm.zoom.active + 'px',
          backgroundColor: '#0e1528'
        })},[_c('svg',{attrs:{"width":"100%","height":"100%","xmlns":"http://www.w3.org/2000/svg"}},[_c('defs',[_c('pattern',{attrs:{"id":"smallGrid","width":_vm.cellSize,"height":_vm.cellSize,"patternUnits":"userSpaceOnUse"}},[_c('path',{attrs:{"d":("M " + _vm.cellSize + " 0 L 0 0 0 " + _vm.cellSize),"fill":"none","stroke":"#1A2135","stroke-width":"2"}})])]),_vm._v(" "),_c('rect',{attrs:{"width":"100%","height":"100%","fill":"url(#smallGrid)"}})])]):_vm._e(),_vm._v(" "),(_vm.map.image || _vm.showGridMap)?_c('div',{staticClass:"cams"},[_vm._l((_vm.map.cams),function(cam){return _c('map-object',{key:'cam' + cam.id,attrs:{"map":_vm.map,"cam":cam,"scale":_vm.currentScale,"styleWidthDistance":_vm.objsStyle[cam.id],"isHighlight":cam.id === _vm.camIdFromCell && _vm.isIndicateCamIdFromCell,"isIndicateAlarms":_vm.isIndicateAlarms}})}),_vm._v(" "),_vm._l((_vm.map.mapObjs),function(object){return _c('map-object',{key:((object.type) + "_" + (object.id)),attrs:{"type":"object","scale":_vm.currentScale,"map":_vm.map,"mapObject":object,"styleWidthDistance":_vm.objsStyle[((object.type) + "_" + (object.id))]}})}),_vm._v(" "),_vm._l((_vm.map.levels),function(level){return _c('router-link',{key:'level' + level.mapId,ref:'level' + level.mapId,refInFor:true,staticClass:"level-item",style:([
            _vm.levelPositionOnMap(level, 'level' + level.mapId),
            _vm.levelOnMapSizes
          ]),attrs:{"to":{
            name: 'map',
            params: { rootMapId: _vm.map.group.id, mapId: level.mapId }
          },"title":level.id}},[_c('div',{staticClass:"level-name"},[_vm._v(_vm._s(_vm._f("contraction")(level.id,7)))]),_vm._v(" "),_c('div',{staticClass:"icon-level",style:(_vm.arrowOnLevelSize)})])})],2):_vm._e()])]),_vm._v(" "),(_vm.map.image || _vm.showGridMap)?_c('div',{staticClass:"controls"},[(_vm.isShowIndicateAlarmsControl)?_c('label',{staticClass:"indicate-alarms-label",class:{ checked: _vm.isShowIndicateAlarms }},[_c('div',{staticClass:"indicate-alarms-label__text"},[_vm._v("\n        "+_vm._s(_vm.$t("map.indicateAlarmsOnCameras"))+"\n      ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.isShowIndicateAlarms),expression:"isShowIndicateAlarms"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.isShowIndicateAlarms)?_vm._i(_vm.isShowIndicateAlarms,null)>-1:(_vm.isShowIndicateAlarms)},on:{"change":[function($event){var $$a=_vm.isShowIndicateAlarms,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.isShowIndicateAlarms=$$a.concat([$$v]))}else{$$i>-1&&(_vm.isShowIndicateAlarms=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.isShowIndicateAlarms=$$c}},_vm.onChangeShowIndicateAlarms]}})]):_vm._e(),_vm._v(" "),_c('dropdown-select',{staticClass:"dropdown-zoom",attrs:{"list":_vm.zoomList,"value":_vm.zoom.active,"type":"small","id-field":"value"},on:{"change":_vm.setZoom}}),_vm._v(" "),_c('div',{staticClass:"bigger control-btn",class:{
        disabled: _vm.zoom.active >= _vm.zoom.list[_vm.zoom.list.length - 1].value
      },on:{"click":function($event){return _vm.nextZoom()}}}),_vm._v(" "),_c('div',{staticClass:"smaller control-btn",class:{ disabled: _vm.zoom.active <= _vm.zoom.list[0].value },on:{"click":function($event){return _vm.nextZoom(true)}}})],1):_vm._e(),_vm._v(" "),_c('loader',{class:{ loading: _vm.loading }}),_vm._v(" "),(!_vm.map.image)?_c('div',{staticClass:"map__notification"},[_c('div',{staticClass:"map__notification-icon"}),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.$t("map.imageProblem")))])]):_vm._e()],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 990:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

/* harmony default export */ __webpack_exports__["a"] = ({
  filters: {
    contraction: function contraction(value) {
      var maxLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;

      var half = maxLength / 2;

      if (value.length > maxLength) {
        return value.slice(0, half).trim() + "..." + value.slice(-half).trim();
      }

      return value;
    }
  },
  install: function install(Vue) {
    var _this = this;

    var filters = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.filters);

    filters.forEach(function (k) {
      return Vue.filter(k, _this.filters[k]);
    });
  }
});

/***/ }),

/***/ 991:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_js__ = __webpack_require__(484);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60412210_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(993);
function injectStyle (ssrContext) {
  __webpack_require__(992)
}
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60412210_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 992:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 993:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"app",attrs:{"id":"app"},on:{"click":_vm.rootClick,"mouseup":_vm.mouseup,"mousemove":_vm.mousemove}},[(!_vm.isIE)?_c('router-view'):_vm._e(),_vm._v(" "),(_vm.error)?_c('modal',{attrs:{"show":!! _vm.error}},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('global.error'))+" "+_vm._s(_vm.error.code))]),_vm._v(" "),_c('div',{staticClass:"message"},[_vm._v(_vm._s(_vm.$t(_vm.error.message)))]),_vm._v(" "),_c('div',{staticClass:"btns padding single"},[_c('div',{staticClass:"btn",on:{"click":function($event){_vm.error = null}}},[_c('span',[_vm._v(_vm._s(_vm.$t('btn.ok')))])])])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 994:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__consts_sessionStorageKeys__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__consts_storageKeys__ = __webpack_require__(108);










var _class = function () {
    function _class(store, router) {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, _class);

        this.$store = store;

        router.beforeEach(function (to, from, next) {
            if (to.meta.auth && !store.state.user) {
                _this.loginFromStorage().then(function () {
                    next();
                }, function () {
                    next('/auth');
                });
            } else {
                next();
            }
        });
    }

    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(_class, [{
        key: 'login',
        value: function () {
            var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee(data) {
                var token, storageToken, user;
                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                token = btoa(unescape(encodeURIComponent(data.login + ':' + data.password)));
                                storageToken = btoa(unescape(encodeURIComponent(data.login + '㋛' + data.password)));
                                user = {
                                    site: {
                                        name: data.site,
                                        id: Date.now()
                                    },
                                    login: data.login,
                                    remember: data.remember
                                };


                                addNewUserInUsers(user, storageToken);
                                addNewSiteInSiteHistory(user.site);

                                this.$store.commit('setUser', user);

                                __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].http.headers.common['Authorization'] = 'Basic ' + token;

                                _context.prev = 7;
                                _context.next = 10;
                                return this.$store.dispatch('getCams');

                            case 10:
                                _context.next = 16;
                                break;

                            case 12:
                                _context.prev = 12;
                                _context.t0 = _context['catch'](7);

                                if (_context.t0.status === 400) {
                                    this.$store.commit('resetUser');
                                }
                                throw _context.t0;

                            case 16:
                                _context.prev = 16;
                                _context.next = 19;
                                return this.$store.dispatch('setWsWebConnect');

                            case 19:
                                _context.next = 25;
                                break;

                            case 21:
                                _context.prev = 21;
                                _context.t1 = _context['catch'](16);

                                this.$store.commit('resetUser');
                                throw _context.t1;

                            case 25:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[7, 12], [16, 21]]);
            }));

            function login(_x) {
                return _ref.apply(this, arguments);
            }

            return login;
        }()
    }, {
        key: 'loginFromStorage',
        value: function loginFromStorage() {
            var _this2 = this;

            return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                var user = _this2.getUserFromStorage();

                if (user) {
                    _this2.login(user).then(function () {
                        resolve();
                    }, function () {
                        reject();
                    });
                } else reject();
            });
        }
    }, {
        key: 'getTokenFromStorage',
        value: function getTokenFromStorage(token) {
            return decodeURIComponent(escape(atob(token))).split('㋛');
        }
    }, {
        key: 'getUserFromStorage',
        value: function getUserFromStorage() {
            var usersJson = localStorage.getItem(__WEBPACK_IMPORTED_MODULE_8__consts_storageKeys__["a" /* default */].USERS);
            var token = localStorage.getItem(__WEBPACK_IMPORTED_MODULE_8__consts_storageKeys__["a" /* default */].USER_TOKEN);

            if (!(usersJson && token)) {
                return;
            }

            var users = JSON.parse(usersJson);
            var data = this.getTokenFromStorage(token);

            if (data.length !== 2) {
                return;
            }

            var login = data[0];
            var user = users.find(function (item) {
                return item.login = login;
            });

            if (!user) {
                return;
            }

            return { site: user.site.name, login: login, password: data[1], remember: user.remember };
        }
    }, {
        key: 'logout',
        value: function logout() {
            localStorage.removeItem(__WEBPACK_IMPORTED_MODULE_8__consts_storageKeys__["a" /* default */].USER_TOKEN);
            sessionStorage.removeItem(__WEBPACK_IMPORTED_MODULE_7__consts_sessionStorageKeys__["a" /* default */].STREAM_MODE);
            sessionStorage.removeItem(__WEBPACK_IMPORTED_MODULE_7__consts_sessionStorageKeys__["a" /* default */].STREAM_QUALITY);
            sessionStorage.removeItem(__WEBPACK_IMPORTED_MODULE_7__consts_sessionStorageKeys__["a" /* default */].SHOW_ALARMED_CAMS);

            this.$store.commit('resetUser');

            return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                resolve();
            });
        }
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);


var addNewUserInUsers = function addNewUserInUsers(user, storageToken) {
    var usersInLocalStorage = localStorage.getItem(__WEBPACK_IMPORTED_MODULE_8__consts_storageKeys__["a" /* default */].USERS);
    var users = usersInLocalStorage ? JSON.parse(usersInLocalStorage) : [];

    var userIndexInUsers = users.findIndex(function (userInUsers) {
        return userInUsers.login === user.login;
    });

    if (userIndexInUsers > -1) {
        users.splice(userIndexInUsers, 1);
    }

    users.unshift(user);

    localStorage.setItem(__WEBPACK_IMPORTED_MODULE_8__consts_storageKeys__["a" /* default */].USERS, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(users));
    localStorage.setItem(__WEBPACK_IMPORTED_MODULE_8__consts_storageKeys__["a" /* default */].USER_TOKEN, storageToken);
};

var addNewSiteInSiteHistory = function addNewSiteInSiteHistory(newSite) {
    var siteHistoryJSON = localStorage.getItem(__WEBPACK_IMPORTED_MODULE_8__consts_storageKeys__["a" /* default */].SITE_HISTORY);
    var siteHistory = siteHistoryJSON ? JSON.parse(siteHistoryJSON) : [];

    if (siteHistory.length > 0) {
        var currentSiteNameIndex = siteHistory.findIndex(function (siteInHistory) {
            return siteInHistory.name === newSite.name;
        });

        if (currentSiteNameIndex > -1) {
            siteHistory.splice(currentSiteNameIndex, 1);
        }
    }

    siteHistory.unshift(newSite);

    localStorage.setItem(__WEBPACK_IMPORTED_MODULE_8__consts_storageKeys__["a" /* default */].SITE_HISTORY, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(siteHistory));
};

/***/ }),

/***/ 995:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vee_validate__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_cookies__ = __webpack_require__(996);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_cookies___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_cookies__);









var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, _class);

        this.lang = {
            default: 'en',
            storage: localStorage.getItem('lang'),
            browser: navigator.language.substr(0, 2)
        };

        this.set(this.get());
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(_class, [{
        key: "get",
        value: function get() {
            if (this.lang.storage && __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].i18n.locales().indexOf(this.lang.storage)) {
                return this.lang.storage;
            }

            if (this.lang.browser) return this.lang.browser;

            return this.lang.default;
        }
    }, {
        key: "set",
        value: function () {
            var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(lang) {
                var shadowLang, evt, langCode;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                shadowLang = lang === 'ru' ? lang : 'en';


                                localStorage.setItem('lang', shadowLang);
                                _context.next = 4;
                                return __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].i18n.set(shadowLang);

                            case 4:
                                __WEBPACK_IMPORTED_MODULE_5_moment___default.a.locale(shadowLang);
                                __WEBPACK_IMPORTED_MODULE_6_vee_validate__["a" /* Validator */].localize(shadowLang);

                                if (typeof Event === 'function') {
                                    window.dispatchEvent(new Event('resize'));
                                } else {
                                    evt = window.document.createEvent('UIEvents');

                                    evt.initUIEvent('resize', true, false, window, 0);
                                    window.dispatchEvent(evt);
                                }

                                langCode = 0;
                                _context.t0 = lang;
                                _context.next = _context.t0 === 'ru' ? 11 : _context.t0 === 'fr' ? 13 : _context.t0 === 'pt' ? 15 : 17;
                                break;

                            case 11:
                                langCode = 1;
                                return _context.abrupt("break", 17);

                            case 13:
                                langCode = 2;
                                return _context.abrupt("break", 17);

                            case 15:
                                langCode = 3;
                                return _context.abrupt("break", 17);

                            case 17:

                                __WEBPACK_IMPORTED_MODULE_7_vue_cookies___default.a.set('language', langCode, 0, '/webview');

                            case 18:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function set(_x) {
                return _ref.apply(this, arguments);
            }

            return set;
        }()
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ })

},[485]);


// WEBPACK FOOTER //
// static/js/app.022fae701bfe6906b89b.js